export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  DateTime: { input: Date; output: Date; }
  Long: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export enum AccessLevel {
  FullAccess = 'FULL_ACCESS',
  LimitedAccess = 'LIMITED_ACCESS'
}

export enum AccessPermission {
  ReadAndWrite = 'READ_AND_WRITE',
  ReadOnly = 'READ_ONLY'
}

export type Address = {
  __typename?: 'Address';
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  municipalityCode?: Maybe<Scalars['String']['output']>;
  municipalityName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalDistrict?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type AddressFilterInput = {
  and?: InputMaybe<Array<AddressFilterInput>>;
  country?: InputMaybe<StringOperationFilterInput>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  municipalityCode?: InputMaybe<StringOperationFilterInput>;
  municipalityName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressFilterInput>>;
  postalCode?: InputMaybe<StringOperationFilterInput>;
  postalDistrict?: InputMaybe<StringOperationFilterInput>;
  streetAddress?: InputMaybe<StringOperationFilterInput>;
};

export type AddressSortInput = {
  country?: InputMaybe<SortEnumType>;
  countryCode?: InputMaybe<SortEnumType>;
  municipalityCode?: InputMaybe<SortEnumType>;
  municipalityName?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  postalDistrict?: InputMaybe<SortEnumType>;
  streetAddress?: InputMaybe<SortEnumType>;
};

export type AdgangViewModel = {
  __typename?: 'AdgangViewModel';
  cvr: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  institutioner: Array<InstitutionViewModel>;
  navn: Scalars['String']['output'];
  type: BrugerAdgangEntityType;
};

/** A connection to a list of items. */
export type AffectedEntitiesConnection = {
  __typename?: 'AffectedEntitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AffectedEntitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AffectedEntity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AffectedEntitiesEdge = {
  __typename?: 'AffectedEntitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AffectedEntity;
};

export type AffectedEntity = {
  __typename?: 'AffectedEntity';
  brugerAktivitetId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  entityId: Scalars['UUID']['output'];
  entityType: EntityType;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type AffectedEntityFilterInput = {
  and?: InputMaybe<Array<AffectedEntityFilterInput>>;
  brugerAktivitetId?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  entityId?: InputMaybe<UuidOperationFilterInput>;
  entityType?: InputMaybe<EntityTypeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AffectedEntityFilterInput>>;
};

export type AffectedEntitySortInput = {
  brugerAktivitetId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  entityId?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
};

export enum Afsendersystem {
  Cpr = 'CPR',
  Datakontrol = 'DATAKONTROL',
  SocialTilbud = 'SOCIAL_TILBUD',
  SupportTool = 'SUPPORT_TOOL',
  Ukendt = 'UKENDT'
}

export type AfsendersystemOperationFilterInput = {
  eq?: InputMaybe<Afsendersystem>;
  in?: InputMaybe<Array<Afsendersystem>>;
  neq?: InputMaybe<Afsendersystem>;
  nin?: InputMaybe<Array<Afsendersystem>>;
};

export type AggregationCount = {
  __typename?: 'AggregationCount';
  count: Scalars['Int']['output'];
};

export type AliasPerson = {
  __typename?: 'AliasPerson';
  aggregatedBeskrivelse: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  beskrivelse: Scalars['String']['output'];
  cpr: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  fundetDato: Scalars['Date']['output'];
  gruppe: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  institutionId: Scalars['UUID']['output'];
  institutionsnummer: Scalars['String']['output'];
  kommunekode: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  outOfScope: Scalars['Boolean']['output'];
  relationer: Array<Relation>;
};

/** A connection to a list of items. */
export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuditLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Bruger>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuditLogEdge = {
  __typename?: 'AuditLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Bruger;
};

export type Barn = {
  __typename?: 'Barn';
  antalAktiveMedarbejdere: Scalars['Long']['output'];
  antalAktiveTilbud: Scalars['Long']['output'];
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  grace?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  naesteMedarbejderBarnValideringInden?: Maybe<Scalars['DateTime']['output']>;
  person: Person;
  personReplikaId: Scalars['UUID']['output'];
  registrerendeKommuneInfo?: Maybe<RegistrendeKommuneInfo>;
  sidsteMedarbejderBarnValideringsTidspunkt?: Maybe<Scalars['DateTime']['output']>;
  tilbudsTilknytninger: Array<TilbudsTilknytning>;
  tilbudsmedarbejderBoern: Array<TilbudsmedarbejderBarn>;
};

export type BaseResultat = {
  __typename?: 'BaseResultat';
  barnHovedgruppe?: Maybe<Scalars['String']['output']>;
  behandletAfPersonNavn?: Maybe<Scalars['String']['output']>;
  behandletDato?: Maybe<Scalars['Date']['output']>;
  behandletPersonNavn: Scalars['String']['output'];
  /**
   * The note from a completed Alias-besked concerning this person, materialized onto the Resultat
   * at kontrol creation. Shown as a fallback "Tidligere handling" when no real one exists.
   */
  beskedHandling?: Maybe<BeskedHandling>;
  beskrivelse?: Maybe<Scalars['String']['output']>;
  cpr: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** @deprecated Replaced by DisplayValue */
  displayText: Scalars['String']['output'];
  displayValue?: Maybe<ResultatDisplayValue>;
  handling: ResultatHandlingEnum;
  id: Scalars['UUID']['output'];
  institution: Institution;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  personType: ResultatPersonType;
  relationCpr?: Maybe<Scalars['String']['output']>;
  relationName?: Maybe<Scalars['String']['output']>;
  relationType?: Maybe<Scalars['String']['output']>;
  tidligereResultater: Array<BaseResultat>;
  vaerdi: ValideringsregelIndstillingValueEnum;
  valideringsregel: Valideringsregel;
};

export type Besked = {
  __typename?: 'Besked';
  backupRoleDescriptionPrepend: Scalars['String']['output'];
  backupRoles?: Maybe<Array<Scalars['String']['output']>>;
  brugerBeskedhandlinger: Array<BrugerBeskedhandling>;
  created: Scalars['DateTime']['output'];
  customContent?: Maybe<Scalars['String']['output']>;
  deliveringSystem: Afsendersystem;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  instanceHash: Scalars['Int']['output'];
  institution?: Maybe<Scalars['UUID']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  omhandlerCpr?: Maybe<Scalars['String']['output']>;
  push: Scalars['Boolean']['output'];
  recieverId: Scalars['UUID']['output'];
  recieverType: RecieverType;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  showInInbox: Scalars['Boolean']['output'];
  systemAction: Scalars['String']['output'];
  task?: Maybe<Scalars['String']['output']>;
  titel: Scalars['String']['output'];
  type: BeskedType;
};

export type BeskedFilterInput = {
  and?: InputMaybe<Array<BeskedFilterInput>>;
  backupRoleDescriptionPrepend?: InputMaybe<StringOperationFilterInput>;
  backupRoles?: InputMaybe<ListStringOperationFilterInput>;
  brugerBeskedhandlinger?: InputMaybe<ListFilterInputTypeOfBrugerBeskedhandlingFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  customContent?: InputMaybe<StringOperationFilterInput>;
  deliveringSystem?: InputMaybe<AfsendersystemOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institution?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  omhandlerCpr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BeskedFilterInput>>;
  push?: InputMaybe<BooleanOperationFilterInput>;
  recieverId?: InputMaybe<UuidOperationFilterInput>;
  recieverType?: InputMaybe<RecieverTypeOperationFilterInput>;
  roles?: InputMaybe<ListStringOperationFilterInput>;
  showInInbox?: InputMaybe<BooleanOperationFilterInput>;
  systemAction?: InputMaybe<StringOperationFilterInput>;
  task?: InputMaybe<StringOperationFilterInput>;
  titel?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<BeskedTypeOperationFilterInput>;
};

export type BeskedHandling = {
  __typename?: 'BeskedHandling';
  dato?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  udfoertAf?: Maybe<Scalars['String']['output']>;
};

export type BeskedSortInput = {
  backupRoleDescriptionPrepend?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customContent?: InputMaybe<SortEnumType>;
  deliveringSystem?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institution?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  omhandlerCpr?: InputMaybe<SortEnumType>;
  push?: InputMaybe<SortEnumType>;
  recieverId?: InputMaybe<SortEnumType>;
  recieverType?: InputMaybe<SortEnumType>;
  showInInbox?: InputMaybe<SortEnumType>;
  systemAction?: InputMaybe<SortEnumType>;
  task?: InputMaybe<SortEnumType>;
  titel?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum BeskedType {
  Alias = 'ALIAS',
  Ukendt = 'UKENDT'
}

export type BeskedTypeOperationFilterInput = {
  eq?: InputMaybe<BeskedType>;
  in?: InputMaybe<Array<BeskedType>>;
  neq?: InputMaybe<BeskedType>;
  nin?: InputMaybe<Array<BeskedType>>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Bruger = {
  __typename?: 'Bruger';
  brugerAdgange?: Maybe<BrugerAdgangeConnection>;
  brugerAktiviteter?: Maybe<BrugerAktiviteterConnection>;
  brugerBeskedhandlinger?: Maybe<BrugerBeskedhandlingerConnection>;
  brugerLoginLog?: Maybe<BrugerLoginLogConnection>;
  brugerType: UserType;
  created: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastRegisteredJobFunctionRoles: Array<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  personIdentifier: Scalars['String']['output'];
  personIdentifierType: Scalars['String']['output'];
};


export type BrugerBrugerAdgangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerAdgangSortInput>>;
  where?: InputMaybe<BrugerAdgangFilterInput>;
};


export type BrugerBrugerAktiviteterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerAktivitetSortInput>>;
  where?: InputMaybe<BrugerAktivitetFilterInput>;
};


export type BrugerBrugerBeskedhandlingerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerBeskedhandlingSortInput>>;
  where?: InputMaybe<BrugerBeskedhandlingFilterInput>;
};


export type BrugerBrugerLoginLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerLoginLogSortInput>>;
  where?: InputMaybe<BrugerLoginLogFilterInput>;
};

export type BrugerAdgang = {
  __typename?: 'BrugerAdgang';
  brugerAdgangStatus: BrugerAdgangStatusType;
  brugerAktiviteter?: Maybe<BrugerAktiviteterConnection>;
  brugerInvitationer?: Maybe<BrugerInvitationerConnection>;
  created: Scalars['DateTime']['output'];
  cvrNummer: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  kommuneId?: Maybe<Scalars['UUID']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  organisationId?: Maybe<Scalars['UUID']['output']>;
  organisationNavn: Scalars['String']['output'];
  tilbudId?: Maybe<Scalars['UUID']['output']>;
};


export type BrugerAdgangBrugerAktiviteterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerAktivitetSortInput>>;
  where?: InputMaybe<BrugerAktivitetFilterInput>;
};


export type BrugerAdgangBrugerInvitationerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerInvitationSortInput>>;
  where?: InputMaybe<BrugerInvitationFilterInput>;
};

export enum BrugerAdgangEntityType {
  Kommune = 'KOMMUNE',
  Organisation = 'ORGANISATION',
  Tilbud = 'TILBUD',
  Ukendt = 'UKENDT'
}

export type BrugerAdgangEntityTypeOperationFilterInput = {
  eq?: InputMaybe<BrugerAdgangEntityType>;
  in?: InputMaybe<Array<BrugerAdgangEntityType>>;
  neq?: InputMaybe<BrugerAdgangEntityType>;
  nin?: InputMaybe<Array<BrugerAdgangEntityType>>;
};

export type BrugerAdgangFilterInput = {
  and?: InputMaybe<Array<BrugerAdgangFilterInput>>;
  brugerAdgangStatus?: InputMaybe<BrugerAdgangStatusTypeOperationFilterInput>;
  brugerAktiviteter?: InputMaybe<ListFilterInputTypeOfBrugerAktivitetFilterInput>;
  brugerInvitationer?: InputMaybe<ListFilterInputTypeOfBrugerInvitationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  cvrNummer?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  kommuneId?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BrugerAdgangFilterInput>>;
  organisationId?: InputMaybe<UuidOperationFilterInput>;
  organisationNavn?: InputMaybe<StringOperationFilterInput>;
  tilbudId?: InputMaybe<UuidOperationFilterInput>;
};

export type BrugerAdgangSortInput = {
  brugerAdgangStatus?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  cvrNummer?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kommuneId?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  organisationId?: InputMaybe<SortEnumType>;
  organisationNavn?: InputMaybe<SortEnumType>;
  tilbudId?: InputMaybe<SortEnumType>;
};

export enum BrugerAdgangStatusType {
  CanAccess = 'CAN_ACCESS',
  CanNotAccess = 'CAN_NOT_ACCESS',
  CodeValidationExpired = 'CODE_VALIDATION_EXPIRED',
  NeedCodeValidation = 'NEED_CODE_VALIDATION',
  NeedLoginToAccess = 'NEED_LOGIN_TO_ACCESS'
}

export type BrugerAdgangStatusTypeOperationFilterInput = {
  eq?: InputMaybe<BrugerAdgangStatusType>;
  in?: InputMaybe<Array<BrugerAdgangStatusType>>;
  neq?: InputMaybe<BrugerAdgangStatusType>;
  nin?: InputMaybe<Array<BrugerAdgangStatusType>>;
};

/** A connection to a list of items. */
export type BrugerAdgangeConnection = {
  __typename?: 'BrugerAdgangeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BrugerAdgangeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BrugerAdgang>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BrugerAdgangeEdge = {
  __typename?: 'BrugerAdgangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BrugerAdgang;
};

export type BrugerAktivitet = {
  __typename?: 'BrugerAktivitet';
  affectedEntities?: Maybe<AffectedEntitiesConnection>;
  affectedOrganisationIds?: Maybe<Array<Scalars['UUID']['output']>>;
  aktivitet: Scalars['String']['output'];
  brugerId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  elapsedMiliseconds: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  variables?: Maybe<VariablesConnection>;
};


export type BrugerAktivitetAffectedEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AffectedEntitySortInput>>;
  where?: InputMaybe<AffectedEntityFilterInput>;
};


export type BrugerAktivitetVariablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VariableSortInput>>;
  where?: InputMaybe<VariableFilterInput>;
};

export type BrugerAktivitetDetalje = {
  __typename?: 'BrugerAktivitetDetalje';
  aktivitet: Scalars['String']['output'];
  brugerId: Scalars['Int']['output'];
  brugerNavn: Scalars['String']['output'];
  elapsedMiliseconds: Scalars['Float']['output'];
  operation: Scalars['String']['output'];
  tidspunkt: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  variables: Array<BrugerAktivitetVariabel>;
};

export type BrugerAktivitetFilterInput = {
  affectedEntities?: InputMaybe<ListFilterInputTypeOfAffectedEntityFilterInput>;
  affectedOrganisationIds?: InputMaybe<ListUuidOperationFilterInput>;
  aktivitet?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<BrugerAktivitetFilterInput>>;
  brugerId?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  elapsedMiliseconds?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BrugerAktivitetFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
  variables?: InputMaybe<ListFilterInputTypeOfVariableFilterInput>;
};

export type BrugerAktivitetSortInput = {
  aktivitet?: InputMaybe<SortEnumType>;
  brugerId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  elapsedMiliseconds?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type BrugerAktivitetVariabel = {
  __typename?: 'BrugerAktivitetVariabel';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type BrugerAktiviteterConnection = {
  __typename?: 'BrugerAktiviteterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BrugerAktiviteterEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BrugerAktivitet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BrugerAktiviteterEdge = {
  __typename?: 'BrugerAktiviteterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BrugerAktivitet;
};

export type BrugerBeskedhandling = {
  __typename?: 'BrugerBeskedhandling';
  besked: Besked;
  beskedId: Scalars['Int']['output'];
  bruger: Bruger;
  brugerId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  readTimestamp?: Maybe<Scalars['DateTime']['output']>;
  taskCompleted?: Maybe<Scalars['Boolean']['output']>;
  taskCompletedTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type BrugerBeskedhandlingFilterInput = {
  and?: InputMaybe<Array<BrugerBeskedhandlingFilterInput>>;
  besked?: InputMaybe<BeskedFilterInput>;
  beskedId?: InputMaybe<IntOperationFilterInput>;
  bruger?: InputMaybe<BrugerFilterInput>;
  brugerId?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BrugerBeskedhandlingFilterInput>>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  readTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  taskCompleted?: InputMaybe<BooleanOperationFilterInput>;
  taskCompletedTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BrugerBeskedhandlingSortInput = {
  besked?: InputMaybe<BeskedSortInput>;
  beskedId?: InputMaybe<SortEnumType>;
  bruger?: InputMaybe<BrugerSortInput>;
  brugerId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  readTimestamp?: InputMaybe<SortEnumType>;
  taskCompleted?: InputMaybe<SortEnumType>;
  taskCompletedTimestamp?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BrugerBeskedhandlingerConnection = {
  __typename?: 'BrugerBeskedhandlingerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BrugerBeskedhandlingerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BrugerBeskedhandling>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BrugerBeskedhandlingerEdge = {
  __typename?: 'BrugerBeskedhandlingerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BrugerBeskedhandling;
};

export type BrugerFilterInput = {
  and?: InputMaybe<Array<BrugerFilterInput>>;
  brugerAdgange?: InputMaybe<ListFilterInputTypeOfBrugerAdgangFilterInput>;
  brugerAktiviteter?: InputMaybe<ListFilterInputTypeOfBrugerAktivitetFilterInput>;
  brugerBeskedhandlinger?: InputMaybe<ListFilterInputTypeOfBrugerBeskedhandlingFilterInput>;
  brugerLoginLog?: InputMaybe<ListFilterInputTypeOfBrugerLoginLogFilterInput>;
  brugerType?: InputMaybe<UserTypeOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastRegisteredJobFunctionRoles?: InputMaybe<ListStringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BrugerFilterInput>>;
  personIdentifier?: InputMaybe<StringOperationFilterInput>;
  personIdentifierType?: InputMaybe<StringOperationFilterInput>;
};

export type BrugerImpersonationTokenInput = {
  impersonatedBrugerId: Scalars['UUID']['input'];
  sagsnummer: Scalars['String']['input'];
};

export type BrugerImpersonationTokenPayload = {
  __typename?: 'BrugerImpersonationTokenPayload';
  impersonationToken?: Maybe<ImpersonationToken>;
};

export type BrugerInvitation = {
  __typename?: 'BrugerInvitation';
  brugerAdgangId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  cvRnummer: Scalars['String']['output'];
  engangsKode: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  invitationExpiration: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  oprettetTidspunkt: Scalars['DateTime']['output'];
};

export type BrugerInvitationFilterInput = {
  and?: InputMaybe<Array<BrugerInvitationFilterInput>>;
  brugerAdgangId?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  cvRnummer?: InputMaybe<StringOperationFilterInput>;
  engangsKode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  invitationExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  oprettetTidspunkt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BrugerInvitationFilterInput>>;
};

export type BrugerInvitationSortInput = {
  brugerAdgangId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  cvRnummer?: InputMaybe<SortEnumType>;
  engangsKode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invitationExpiration?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  oprettetTidspunkt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BrugerInvitationerConnection = {
  __typename?: 'BrugerInvitationerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BrugerInvitationerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BrugerInvitation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BrugerInvitationerEdge = {
  __typename?: 'BrugerInvitationerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BrugerInvitation;
};

export type BrugerLoginLog = {
  __typename?: 'BrugerLoginLog';
  bruger: Bruger;
  brugerId: Scalars['Int']['output'];
  correlationId: Scalars['UUID']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  registeredInstitutionsafgraensning?: Maybe<Scalars['String']['output']>;
  registeredJobFunctionRoles?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type BrugerLoginLogConnection = {
  __typename?: 'BrugerLoginLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BrugerLoginLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BrugerLoginLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BrugerLoginLogEdge = {
  __typename?: 'BrugerLoginLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BrugerLoginLog;
};

export type BrugerLoginLogFilterInput = {
  and?: InputMaybe<Array<BrugerLoginLogFilterInput>>;
  bruger?: InputMaybe<BrugerFilterInput>;
  brugerId?: InputMaybe<IntOperationFilterInput>;
  correlationId?: InputMaybe<UuidOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BrugerLoginLogFilterInput>>;
  registeredInstitutionsafgraensning?: InputMaybe<StringOperationFilterInput>;
  registeredJobFunctionRoles?: InputMaybe<StringOperationFilterInput>;
};

export type BrugerLoginLogSortInput = {
  bruger?: InputMaybe<BrugerSortInput>;
  brugerId?: InputMaybe<SortEnumType>;
  correlationId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  registeredInstitutionsafgraensning?: InputMaybe<SortEnumType>;
  registeredJobFunctionRoles?: InputMaybe<SortEnumType>;
};

export type BrugerSortInput = {
  brugerType?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  personIdentifier?: InputMaybe<SortEnumType>;
  personIdentifierType?: InputMaybe<SortEnumType>;
};

export type BrugerViewModel = {
  __typename?: 'BrugerViewModel';
  adgange: Array<AdgangViewModel>;
  id: Scalars['UUID']['output'];
  navn: Scalars['String']['output'];
  roller: Array<Scalars['String']['output']>;
  type: UserType;
};

export type CpRdata = {
  __typename?: 'CPRdata';
  adresse: Scalars['String']['output'];
  adresseBeskyttet: Scalars['Boolean']['output'];
  by: Scalars['String']['output'];
  cprNummer: Scalars['String']['output'];
  efternavn: Scalars['String']['output'];
  f_dselsdato: Scalars['Date']['output'];
  fornavn: Scalars['String']['output'];
  postnummer: Scalars['Int']['output'];
  stednavn?: Maybe<Scalars['String']['output']>;
};

export type ChangedTilbudEntity = {
  __typename?: 'ChangedTilbudEntity';
  id: Scalars['UUID']['output'];
  type: TilbudsportalChangeType;
};

export type ContactPersonFilterInput = {
  accessLevel?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<ContactPersonFilterInput>>;
  childCustody?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ContactPersonFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  relation?: InputMaybe<RelationOperationFilterInput>;
};

export type ContactPersonSortInput = {
  accessLevel?: InputMaybe<SortEnumType>;
  childCustody?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  relation?: InputMaybe<SortEnumType>;
};

export type CreateGraviteeApplicationMutationModelInput = {
  description: Scalars['String']['input'];
  kommuneKoder: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateKundeError = SupportToolMutationError;

export type CreateKundeInput = {
  mutationModel: CreateKundeMutationModelInput;
};

export type CreateKundeMutationModelInput = {
  cvr?: InputMaybe<Scalars['String']['input']>;
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  navn?: InputMaybe<Scalars['String']['input']>;
};

export type CreateKundePayload = {
  __typename?: 'CreateKundePayload';
  errors?: Maybe<Array<CreateKundeError>>;
  kunde?: Maybe<Kunde>;
};

export type DatakontrolModulViewModel = {
  __typename?: 'DatakontrolModulViewModel';
  cprOpslagServiceAftaleUUID?: Maybe<Scalars['UUID']['output']>;
  displayText: Scalars['String']['output'];
  kundeModulId?: Maybe<Scalars['UUID']['output']>;
};

export type DatakontrolMutationError = Error & {
  __typename?: 'DatakontrolMutationError';
  contextData: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum DatakontrolTypeEnum {
  Application = 'APPLICATION',
  System = 'SYSTEM',
  Unknown = 'UNKNOWN'
}

export type DatakontrolTypeEnumOperationFilterInput = {
  eq?: InputMaybe<DatakontrolTypeEnum>;
  in?: InputMaybe<Array<DatakontrolTypeEnum>>;
  neq?: InputMaybe<DatakontrolTypeEnum>;
  nin?: InputMaybe<Array<DatakontrolTypeEnum>>;
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteGraviteeApplicationError = SupportToolMutationError;

export type DeleteGraviteeApplicationInput = {
  mutationModel: DeleteGraviteeApplicationMutationModelInput;
};

export type DeleteGraviteeApplicationMutationModelInput = {
  applicationId: Scalars['String']['input'];
};

export type DeleteGraviteeApplicationPayload = {
  __typename?: 'DeleteGraviteeApplicationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteGraviteeApplicationError>>;
};

export type DeleteOutOfScopeError = DatakontrolMutationError;

export type DeleteOutOfScopeInput = {
  daysOutOfScopeThreshold: Scalars['Int']['input'];
};

export type DeleteOutOfScopePayload = {
  __typename?: 'DeleteOutOfScopePayload';
  errors?: Maybe<Array<DeleteOutOfScopeError>>;
  int?: Maybe<Scalars['Int']['output']>;
};

export type DomainAction = {
  __typename?: 'DomainAction';
  entityId: Scalars['UUID']['output'];
  entityType: Scalars['String']['output'];
  severity: DomainActionSeverity;
  type: DomainActionType;
  values: Array<KeyValuePairOfStringAndString>;
};

export enum DomainActionSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum DomainActionType {
  BarnManglerMedarbejdere = 'BARN_MANGLER_MEDARBEJDERE',
  MedarbejderHarUdloebsdato = 'MEDARBEJDER_HAR_UDLOEBSDATO',
  MedarbejderManglerBoern = 'MEDARBEJDER_MANGLER_BOERN',
  MedarbejderUdloeberSnart = 'MEDARBEJDER_UDLOEBER_SNART',
  TilbudsmedarbejderBarnGodkendelseNaesteValideringIndenOverskredet = 'TILBUDSMEDARBEJDER_BARN_GODKENDELSE_NAESTE_VALIDERING_INDEN_OVERSKREDET',
  TilbudsmedarbejderBarnGodkendelseUdloeberSnart = 'TILBUDSMEDARBEJDER_BARN_GODKENDELSE_UDLOEBER_SNART',
  TilbudManglerBoern = 'TILBUD_MANGLER_BOERN',
  TilbudManglerMedarbejdere = 'TILBUD_MANGLER_MEDARBEJDERE',
  TilbudTilknytningErFremtidig = 'TILBUD_TILKNYTNING_ER_FREMTIDIG',
  TilbudTilknytningGodkendelseManglerGodkendelse = 'TILBUD_TILKNYTNING_GODKENDELSE_MANGLER_GODKENDELSE',
  TilbudTilknytningUdloeberSnart = 'TILBUD_TILKNYTNING_UDLOEBER_SNART'
}

export type EmployeeFilterInput = {
  and?: InputMaybe<Array<EmployeeFilterInput>>;
  groupIds?: InputMaybe<ListStringOperationFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfGroupFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  occupation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmployeeFilterInput>>;
  roles?: InputMaybe<ListEmployeeRoleOperationFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInput>;
};

export enum EmployeeRole {
  Konsulent = 'KONSULENT',
  Ledelse = 'LEDELSE',
  Leder = 'LEDER',
  Laerer = 'Laerer',
  Paedagog = 'Paedagog',
  Tap = 'TAP',
  Ukendt = 'UKENDT',
  Vikar = 'VIKAR'
}

export type EmployeeRoleOperationFilterInput = {
  eq?: InputMaybe<EmployeeRole>;
  in?: InputMaybe<Array<EmployeeRole>>;
  neq?: InputMaybe<EmployeeRole>;
  nin?: InputMaybe<Array<EmployeeRole>>;
};

export type EmployeeSortInput = {
  location?: InputMaybe<SortEnumType>;
  occupation?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
};

export enum EntityType {
  AffectedEntities = 'AFFECTED_ENTITIES',
  Barn = 'BARN',
  Bruger = 'BRUGER',
  BrugerAdgang = 'BRUGER_ADGANG',
  BrugerAktivitet = 'BRUGER_AKTIVITET',
  BrugerInvitation = 'BRUGER_INVITATION',
  Gruppe = 'GRUPPE',
  GruppeInstitution = 'GRUPPE_INSTITUTION',
  Institution = 'INSTITUTION',
  Kommune = 'KOMMUNE',
  KommuneValideringskilde = 'KOMMUNE_VALIDERINGSKILDE',
  KommuneValideringskildeIndstilling = 'KOMMUNE_VALIDERINGSKILDE_INDSTILLING',
  Kontrol = 'KONTROL',
  KontrolloerInstitution = 'KONTROLLOER_INSTITUTION',
  KontrolInstitution = 'KONTROL_INSTITUTION',
  KontrolValideringsregel = 'KONTROL_VALIDERINGSREGEL',
  LokalKonfiguration = 'LOKAL_KONFIGURATION',
  Notifikation = 'NOTIFIKATION',
  OrganisationsEnhed = 'ORGANISATIONS_ENHED',
  Person = 'PERSON',
  Resultat = 'RESULTAT',
  Rollemapping = 'ROLLEMAPPING',
  Skabelon = 'SKABELON',
  SkabelonInstitution = 'SKABELON_INSTITUTION',
  SkabelonValideringsregel = 'SKABELON_VALIDERINGSREGEL',
  SystemKonfiguration = 'SYSTEM_KONFIGURATION',
  Tilbud = 'TILBUD',
  TilbudsmedarbejderBarn = 'TILBUDSMEDARBEJDER_BARN',
  TilbudsmedarbejderBarnGodkendelse = 'TILBUDSMEDARBEJDER_BARN_GODKENDELSE',
  TilbudsMedarbejder = 'TILBUDS_MEDARBEJDER',
  TilbudsTilknytning = 'TILBUDS_TILKNYTNING',
  TilbudsTilknytningGodkendelse = 'TILBUDS_TILKNYTNING_GODKENDELSE',
  TilbudInfo = 'TILBUD_INFO',
  Undefined = 'UNDEFINED',
  Valideringskilde = 'VALIDERINGSKILDE',
  Valideringsregel = 'VALIDERINGSREGEL',
  ValideringsregelIndstilling = 'VALIDERINGSREGEL_INDSTILLING',
  ValidResultat = 'VALID_RESULTAT',
  Variable = 'VARIABLE'
}

export type EntityTypeOperationFilterInput = {
  eq?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  neq?: InputMaybe<EntityType>;
  nin?: InputMaybe<Array<EntityType>>;
};

export type Environment = {
  __typename?: 'Environment';
  id: Scalars['UUID']['output'];
  kommunekode: Scalars['String']['output'];
  navn: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type ExternFilterInput = {
  and?: InputMaybe<Array<ExternFilterInput>>;
  groupIds?: InputMaybe<ListStringOperationFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfGroupFilterInput>;
  or?: InputMaybe<Array<ExternFilterInput>>;
  role?: InputMaybe<ExternRoleOperationFilterInput>;
};

export enum ExternRole {
  Ekstern = 'EKSTERN',
  Praktikant = 'PRAKTIKANT',
  Ukendt = 'UKENDT'
}

export type ExternRoleOperationFilterInput = {
  eq?: InputMaybe<ExternRole>;
  in?: InputMaybe<Array<ExternRole>>;
  neq?: InputMaybe<ExternRole>;
  nin?: InputMaybe<Array<ExternRole>>;
};

export type ExternSortInput = {
  role?: InputMaybe<SortEnumType>;
};

export type FagsystemMedarbejderDatakildeViewModel = {
  __typename?: 'FagsystemMedarbejderDatakildeViewModel';
  cpr: Scalars['String']['output'];
  instId?: Maybe<Scalars['String']['output']>;
  instNavn?: Maybe<Scalars['String']['output']>;
  instType: Scalars['String']['output'];
  rolle?: Maybe<Scalars['String']['output']>;
  stilling?: Maybe<Scalars['String']['output']>;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export enum Gender {
  K = 'K',
  M = 'M',
  Ukendt = 'UKENDT'
}

export type GenderOperationFilterInput = {
  eq?: InputMaybe<Gender>;
  in?: InputMaybe<Array<Gender>>;
  neq?: InputMaybe<Gender>;
  nin?: InputMaybe<Array<Gender>>;
};

export type GenererValideResultaterRapportMutationError = DatakontrolMutationError;

export type GenererValideResultaterRapportMutationInput = {
  kontrolId: Scalars['UUID']['input'];
};

export type GenererValideResultaterRapportMutationPayload = {
  __typename?: 'GenererValideResultaterRapportMutationPayload';
  errors?: Maybe<Array<GenererValideResultaterRapportMutationError>>;
  string?: Maybe<Scalars['String']['output']>;
};

export type GenkoerKontrolMutationError = DatakontrolMutationError;

export type GenkoerKontrolMutationInput = {
  kontrolGenkoerMutationModel: KontrolGenkoerMutationModelInput;
};

export type GenkoerKontrolMutationPayload = {
  __typename?: 'GenkoerKontrolMutationPayload';
  errors?: Maybe<Array<GenkoerKontrolMutationError>>;
  kontrol?: Maybe<Kontrol>;
};

export type GensendCprHaendelserForKundeError = SupportToolMutationError;

export type GensendCprHaendelserForKundeInput = {
  fraDato: Scalars['Date']['input'];
  kundeId: Scalars['UUID']['input'];
};

export type GensendCprHaendelserForKundePayload = {
  __typename?: 'GensendCprHaendelserForKundePayload';
  errors?: Maybe<Array<GensendCprHaendelserForKundeError>>;
  string?: Maybe<Scalars['String']['output']>;
};

export type GraviteeApiKey = {
  __typename?: 'GraviteeApiKey';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type GraviteeApplication = {
  __typename?: 'GraviteeApplication';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GraviteePlan = {
  __typename?: 'GraviteePlan';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selectionRule: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GraviteeProvisioningResult = {
  __typename?: 'GraviteeProvisioningResult';
  apiKeys: Array<GraviteeApiKey>;
  application: GraviteeApplication;
  plan: GraviteePlan;
  subscription: GraviteeSubscription;
};

export type GraviteeSubscription = {
  __typename?: 'GraviteeSubscription';
  id: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GroupFilterInput = {
  and?: InputMaybe<Array<GroupFilterInput>>;
  fromDate?: InputMaybe<DateOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  groupLevel?: InputMaybe<LevelOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  groupType?: InputMaybe<GroupTypeOperationFilterInput>;
  line?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GroupFilterInput>>;
  toDate?: InputMaybe<DateOperationFilterInput>;
};

export type GroupSortInput = {
  fromDate?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  groupLevel?: InputMaybe<SortEnumType>;
  groupName?: InputMaybe<SortEnumType>;
  groupType?: InputMaybe<SortEnumType>;
  line?: InputMaybe<SortEnumType>;
  toDate?: InputMaybe<SortEnumType>;
};

export enum GroupType {
  Andet = 'ANDET',
  Aargang = 'Aargang',
  Hold = 'HOLD',
  Hovedgruppe = 'HOVEDGRUPPE',
  Retning = 'RETNING',
  Sfo = 'SFO',
  Team = 'TEAM',
  Ukendt = 'UKENDT'
}

export type GroupTypeOperationFilterInput = {
  eq?: InputMaybe<GroupType>;
  in?: InputMaybe<Array<GroupType>>;
  neq?: InputMaybe<GroupType>;
  nin?: InputMaybe<Array<GroupType>>;
};

export type Gruppe = {
  __typename?: 'Gruppe';
  created: Scalars['DateTime']['output'];
  gruppeInstitutioner: Array<GruppeInstitution>;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
};


export type GruppeGruppeInstitutionerArgs = {
  order?: InputMaybe<Array<GruppeInstitutionSortInput>>;
  where?: InputMaybe<GruppeInstitutionFilterInput>;
};

export type GruppeFilterInput = {
  and?: InputMaybe<Array<GruppeFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  gruppeInstitutioner?: InputMaybe<ListFilterInputTypeOfGruppeInstitutionFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GruppeFilterInput>>;
};

export type GruppeInstitution = {
  __typename?: 'GruppeInstitution';
  created: Scalars['DateTime']['output'];
  gruppe: Gruppe;
  id: Scalars['UUID']['output'];
  institution: Institution;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type GruppeInstitutionFilterInput = {
  and?: InputMaybe<Array<GruppeInstitutionFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  gruppe?: InputMaybe<GruppeFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institution?: InputMaybe<InstitutionFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<GruppeInstitutionFilterInput>>;
};

export type GruppeInstitutionSortInput = {
  created?: InputMaybe<SortEnumType>;
  gruppe?: InputMaybe<GruppeSortInput>;
  id?: InputMaybe<SortEnumType>;
  institution?: InputMaybe<InstitutionSortInput>;
  lastUpdated?: InputMaybe<SortEnumType>;
};

export type GruppeSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type GyldigTilViewModel = {
  __typename?: 'GyldigTilViewModel';
  entityExternalId: Scalars['UUID']['output'];
};

export enum HealthcheckOverallStatus {
  Degraded = 'DEGRADED',
  Healthy = 'HEALTHY',
  Unhealthy = 'UNHEALTHY'
}

export type HealthcheckServiceStatusViewModel = {
  __typename?: 'HealthcheckServiceStatusViewModel';
  name: Scalars['String']['output'];
  status: HealthcheckOverallStatus;
};

export type HealthcheckStatusViewModel = {
  __typename?: 'HealthcheckStatusViewModel';
  dashboardUrl: Scalars['String']['output'];
  overallStatus: HealthcheckOverallStatus;
  services: Array<HealthcheckServiceStatusViewModel>;
};

export type ImpersonationToken = {
  __typename?: 'ImpersonationToken';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
};

export type Institution = {
  __typename?: 'Institution';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  institutionKode: Scalars['String']['output'];
  institutionType: Institutionstype;
  institutionsreplikaExternalId: Scalars['UUID']['output'];
  kontrolloerer: Array<Replikabruger>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
};

export type InstitutionFilterInput = {
  and?: InputMaybe<Array<InstitutionFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institutionsreplikaExternalId?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InstitutionFilterInput>>;
};

export type InstitutionPersonFilterInput = {
  and?: InputMaybe<Array<InstitutionPersonFilterInput>>;
  employee?: InputMaybe<EmployeeFilterInput>;
  extern?: InputMaybe<ExternFilterInput>;
  localPersonId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InstitutionPersonFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personType?: InputMaybe<PersonTypeOperationFilterInput>;
  student?: InputMaybe<StudentFilterInput>;
};

export type InstitutionPersonSortInput = {
  employee?: InputMaybe<EmployeeSortInput>;
  extern?: InputMaybe<ExternSortInput>;
  localPersonId?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personType?: InputMaybe<SortEnumType>;
  student?: InputMaybe<StudentSortInput>;
};

export type InstitutionSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institutionsreplikaExternalId?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
};

export type InstitutionViewModel = {
  __typename?: 'InstitutionViewModel';
  id: Scalars['UUID']['output'];
  institutionsKode: Scalars['String']['output'];
  navn: Scalars['String']['output'];
};

export type InstitutionsreplikaMutationError = Error & {
  __typename?: 'InstitutionsreplikaMutationError';
  contextData: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum Institutionstype {
  Daginstitution = 'DAGINSTITUTION',
  Institution = 'INSTITUTION',
  Klub = 'KLUB',
  Skole = 'SKOLE',
  Ukendt = 'UKENDT'
}

export type InstitutionstypeOperationFilterInput = {
  eq?: InputMaybe<Institutionstype>;
  in?: InputMaybe<Array<Institutionstype>>;
  neq?: InputMaybe<Institutionstype>;
  nin?: InputMaybe<Array<Institutionstype>>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InternalPopulateInstitutionsError = InstitutionsreplikaMutationError;

export type InternalPopulateInstitutionsInput = {
  /** Kommunekode for den aktive kommune */
  kommunekode: Scalars['String']['input'];
};

export type InternalPopulateInstitutionsPayload = {
  __typename?: 'InternalPopulateInstitutionsPayload';
  errors?: Maybe<Array<InternalPopulateInstitutionsError>>;
  int?: Maybe<Scalars['Int']['output']>;
};

export type KeyValuePairOfGuidAndStringInput = {
  key: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
};

export type KeyValuePairOfStringAndRolleEnum__Input = {
  key: Scalars['String']['input'];
  value: Array<RolleEnum>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Kommune = {
  __typename?: 'Kommune';
  created: Scalars['DateTime']['output'];
  cvr: Scalars['String']['output'];
  grupper: Array<Gruppe>;
  id: Scalars['UUID']['output'];
  institutioner: Array<Institution>;
  institutionsregisterKommunekode: Scalars['String']['output'];
  kommuneValideringskilder: Array<KommuneValideringskilde>;
  kommuneValideringsregler: Array<KommuneValideringsregelIndstilling>;
  kommunekode: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  rollemappings: Array<Rollemapping>;
  skabeloner: Array<Skabelon>;
};


export type KommuneGrupperArgs = {
  order?: InputMaybe<Array<GruppeSortInput>>;
  where?: InputMaybe<GruppeFilterInput>;
};


export type KommuneInstitutionerArgs = {
  order?: InputMaybe<Array<InstitutionSortInput>>;
  where?: InputMaybe<InstitutionFilterInput>;
};


export type KommuneKommuneValideringskilderArgs = {
  order?: InputMaybe<Array<KommuneValideringskildeSortInput>>;
  where?: InputMaybe<KommuneValideringskildeFilterInput>;
};


export type KommuneKommuneValideringsreglerArgs = {
  order?: InputMaybe<Array<KommuneValideringsregelIndstillingSortInput>>;
  where?: InputMaybe<KommuneValideringsregelIndstillingFilterInput>;
};


export type KommuneRollemappingsArgs = {
  order?: InputMaybe<Array<RollemappingSortInput>>;
  where?: InputMaybe<RollemappingFilterInput>;
};


export type KommuneSkabelonerArgs = {
  order?: InputMaybe<Array<SkabelonSortInput>>;
  where?: InputMaybe<SkabelonFilterInput>;
};

export type KommuneBorgerAktivitetSummary = {
  __typename?: 'KommuneBorgerAktivitetSummary';
  aktivitetAntal: Scalars['Int']['output'];
  entityId: Scalars['UUID']['output'];
  entityType: EntityType;
  erFundet: Scalars['Boolean']['output'];
  navn?: Maybe<Scalars['String']['output']>;
  senesteAktivitet: Scalars['DateTime']['output'];
};

export type KommuneMedKontrolansvarligeInput = {
  kommuneExternalId: Scalars['UUID']['input'];
  kontrolansvarligIds: Array<Scalars['UUID']['input']>;
};

export type KommuneMedarbejderAktivitetSummary = {
  __typename?: 'KommuneMedarbejderAktivitetSummary';
  aktivitetAntal: Scalars['Int']['output'];
  brugerId: Scalars['Int']['output'];
  navn: Scalars['String']['output'];
  senesteAktivitet: Scalars['DateTime']['output'];
};

export type KommuneValideringskilde = {
  __typename?: 'KommuneValideringskilde';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  valideringskilde: Valideringskilde;
};

export type KommuneValideringskildeFilterInput = {
  and?: InputMaybe<Array<KommuneValideringskildeFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<KommuneValideringskildeFilterInput>>;
  valideringskilde?: InputMaybe<ValideringskildeFilterInput>;
};

export type KommuneValideringskildeSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  valideringskilde?: InputMaybe<ValideringskildeSortInput>;
};

export type KommuneValideringsregelIndstilling = {
  __typename?: 'KommuneValideringsregelIndstilling';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  notat?: Maybe<Scalars['String']['output']>;
  valideringsregel: Valideringsregel;
};

export type KommuneValideringsregelIndstillingFilterInput = {
  and?: InputMaybe<Array<KommuneValideringsregelIndstillingFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  notat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KommuneValideringsregelIndstillingFilterInput>>;
  valideringsregel?: InputMaybe<ValideringsregelFilterInput>;
};

export type KommuneValideringsregelIndstillingSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  notat?: InputMaybe<SortEnumType>;
  valideringsregel?: InputMaybe<ValideringsregelSortInput>;
};

export type Kontrol = {
  __typename?: 'Kontrol';
  afsluttetAfBrugerId?: Maybe<Scalars['UUID']['output']>;
  afsluttetDato?: Maybe<Scalars['Date']['output']>;
  antalBehandledeResultater: Scalars['Int']['output'];
  antalInstitutioner: Scalars['Int']['output'];
  antalResultater: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deadline: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  inkluderValide: Scalars['Boolean']['output'];
  kontrolInstitutioner: Array<KontrolInstitution>;
  kontrolValideringsregler: Array<KontrolValideringsregel>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  oprettetAfBrugerId: Scalars['UUID']['output'];
  oprettetDato: Scalars['Date']['output'];
  resultater: Array<Resultat>;
  startetAfBrugerId?: Maybe<Scalars['UUID']['output']>;
  startetDato?: Maybe<Scalars['Date']['output']>;
  statusViewModel: KontrolStatusEnum;
  type: DatakontrolTypeEnum;
};


export type KontrolKontrolInstitutionerArgs = {
  order?: InputMaybe<Array<KontrolInstitutionSortInput>>;
  where?: InputMaybe<KontrolInstitutionFilterInput>;
};


export type KontrolKontrolValideringsreglerArgs = {
  order?: InputMaybe<Array<KontrolValideringsregelSortInput>>;
  where?: InputMaybe<KontrolValideringsregelFilterInput>;
};


export type KontrolResultaterArgs = {
  order?: InputMaybe<Array<ResultatSortInput>>;
  where?: InputMaybe<ResultatFilterInput>;
};

export type KontrolFilterInput = {
  afsluttetAfBrugerId?: InputMaybe<UuidOperationFilterInput>;
  afsluttetDato?: InputMaybe<DateOperationFilterInput>;
  and?: InputMaybe<Array<KontrolFilterInput>>;
  antalBehandledeResultater?: InputMaybe<IntOperationFilterInput>;
  antalInstitutioner?: InputMaybe<IntOperationFilterInput>;
  antalResultater?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  deadline?: InputMaybe<DateOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  inkluderValide?: InputMaybe<BooleanOperationFilterInput>;
  kontrolInstitutioner?: InputMaybe<ListFilterInputTypeOfKontrolInstitutionFilterInput>;
  kontrolValideringsregler?: InputMaybe<ListFilterInputTypeOfKontrolValideringsregelFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  oprettetAfBrugerId?: InputMaybe<UuidOperationFilterInput>;
  oprettetDato?: InputMaybe<DateOperationFilterInput>;
  or?: InputMaybe<Array<KontrolFilterInput>>;
  resultater?: InputMaybe<ListFilterInputTypeOfResultatFilterInput>;
  startetAfBrugerId?: InputMaybe<UuidOperationFilterInput>;
  startetDato?: InputMaybe<DateOperationFilterInput>;
  statusViewModel?: InputMaybe<KontrolStatusEnumOperationFilterInput>;
  type?: InputMaybe<DatakontrolTypeEnumOperationFilterInput>;
};

export type KontrolGenkoerMutationModelInput = {
  deadline?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['UUID']['input'];
  navn?: InputMaybe<Scalars['String']['input']>;
};

export type KontrolInfoMutationModelInput = {
  deadline?: InputMaybe<Scalars['Date']['input']>;
  kontrolExternalId: Scalars['UUID']['input'];
  navn?: InputMaybe<Scalars['String']['input']>;
};

export type KontrolInstitution = {
  __typename?: 'KontrolInstitution';
  antalBehandledeResultater: Scalars['Int']['output'];
  antalResultater: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  institution: Institution;
  kontrol: Kontrol;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  resultater: Array<Resultat>;
};


export type KontrolInstitutionResultaterArgs = {
  order?: InputMaybe<Array<ResultatSortInput>>;
  where?: InputMaybe<ResultatFilterInput>;
};

export type KontrolInstitutionFilterInput = {
  and?: InputMaybe<Array<KontrolInstitutionFilterInput>>;
  antalBehandledeResultater?: InputMaybe<IntOperationFilterInput>;
  antalResultater?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institution?: InputMaybe<InstitutionFilterInput>;
  kontrol?: InputMaybe<KontrolFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<KontrolInstitutionFilterInput>>;
  resultater?: InputMaybe<ListFilterInputTypeOfResultatFilterInput>;
};

export type KontrolInstitutionSortInput = {
  antalBehandledeResultater?: InputMaybe<SortEnumType>;
  antalResultater?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institution?: InputMaybe<InstitutionSortInput>;
  kontrol?: InputMaybe<KontrolSortInput>;
  lastUpdated?: InputMaybe<SortEnumType>;
};

export type KontrolMutationModelInput = {
  deadline: Scalars['Date']['input'];
  inkluderValide: Scalars['Boolean']['input'];
  institutionerIds: Array<Scalars['UUID']['input']>;
  navn: Scalars['String']['input'];
  valideringsreglerIds: Array<Scalars['UUID']['input']>;
};

export type KontrolResultatMutationModelInput = {
  handling?: InputMaybe<ResultatHandlingEnum>;
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type KontrolSkabelonMutationModelInput = {
  inkluderValide: Scalars['Boolean']['input'];
  skabelonId: Scalars['UUID']['input'];
};

export type KontrolSortInput = {
  afsluttetAfBrugerId?: InputMaybe<SortEnumType>;
  afsluttetDato?: InputMaybe<SortEnumType>;
  antalBehandledeResultater?: InputMaybe<SortEnumType>;
  antalInstitutioner?: InputMaybe<SortEnumType>;
  antalResultater?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  deadline?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inkluderValide?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  oprettetAfBrugerId?: InputMaybe<SortEnumType>;
  oprettetDato?: InputMaybe<SortEnumType>;
  startetAfBrugerId?: InputMaybe<SortEnumType>;
  startetDato?: InputMaybe<SortEnumType>;
  statusViewModel?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum KontrolStatusEnum {
  Afsluttet = 'AFSLUTTET',
  Fejlet = 'FEJLET',
  Igang = 'IGANG',
  Klar = 'KLAR',
  Klargoerer = 'KLARGOERER'
}

export type KontrolStatusEnumOperationFilterInput = {
  eq?: InputMaybe<KontrolStatusEnum>;
  in?: InputMaybe<Array<KontrolStatusEnum>>;
  neq?: InputMaybe<KontrolStatusEnum>;
  nin?: InputMaybe<Array<KontrolStatusEnum>>;
};

export type KontrolStatusMutationModelInput = {
  kontrolExternalId: Scalars['UUID']['input'];
  target: KontrolStatusEnum;
};

export type KontrolValideringsregel = {
  __typename?: 'KontrolValideringsregel';
  created: Scalars['DateTime']['output'];
  evaluated: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  kontrol: Kontrol;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  valideringsregel: Valideringsregel;
};

export type KontrolValideringsregelFilterInput = {
  and?: InputMaybe<Array<KontrolValideringsregelFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  evaluated?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  kontrol?: InputMaybe<KontrolFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<KontrolValideringsregelFilterInput>>;
  valideringsregel?: InputMaybe<ValideringsregelFilterInput>;
};

export type KontrolValideringsregelSortInput = {
  created?: InputMaybe<SortEnumType>;
  evaluated?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kontrol?: InputMaybe<KontrolSortInput>;
  lastUpdated?: InputMaybe<SortEnumType>;
  valideringsregel?: InputMaybe<ValideringsregelSortInput>;
};

export type Kunde = {
  __typename?: 'Kunde';
  created: Scalars['DateTime']['output'];
  cvr: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Kundens institutioner */
  institutioner: Array<Replikainstitution>;
  isActive: Scalars['Boolean']['output'];
  kommuneKode: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  moduler: Array<KundeModul>;
  navn: Scalars['String']['output'];
};


export type KundeInstitutionerArgs = {
  where?: InputMaybe<Institutionsreplika_InstitutionFilterInput>;
};


export type KundeModulerArgs = {
  order?: InputMaybe<Array<KundeModulSortInput>>;
  where?: InputMaybe<KundeModulFilterInput>;
};

export type KundeFilterInput = {
  and?: InputMaybe<Array<KundeFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  cvr?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  kommuneKode?: InputMaybe<StringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  moduler?: InputMaybe<ListFilterInputTypeOfKundeModulFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KundeFilterInput>>;
};

export type KundeModul = {
  __typename?: 'KundeModul';
  concreteModulId?: Maybe<Scalars['UUID']['output']>;
  concreteModulType: BrugerAdgangEntityType;
  created: Scalars['DateTime']['output'];
  handlinger: Array<ModulHandling>;
  id: Scalars['UUID']['output'];
  integrationer: Array<ModulIntegration>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  modul: Modul;
};


export type KundeModulHandlingerArgs = {
  order?: InputMaybe<Array<ModulHandlingSortInput>>;
  where?: InputMaybe<ModulHandlingFilterInput>;
};


export type KundeModulIntegrationerArgs = {
  order?: InputMaybe<Array<ModulIntegrationSortInput>>;
  where?: InputMaybe<ModulIntegrationFilterInput>;
};

export type KundeModulFilterInput = {
  and?: InputMaybe<Array<KundeModulFilterInput>>;
  concreteModulId?: InputMaybe<UuidOperationFilterInput>;
  concreteModulType?: InputMaybe<BrugerAdgangEntityTypeOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  handlinger?: InputMaybe<ListFilterInputTypeOfModulHandlingFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  integrationer?: InputMaybe<ListFilterInputTypeOfModulIntegrationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  modul?: InputMaybe<ModulFilterInput>;
  or?: InputMaybe<Array<KundeModulFilterInput>>;
};

export type KundeModulSortInput = {
  concreteModulId?: InputMaybe<SortEnumType>;
  concreteModulType?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  modul?: InputMaybe<ModulSortInput>;
};

export enum Level {
  Andet = 'ANDET',
  Dt = 'DT',
  Trin0 = 'TRIN0',
  Trin1 = 'TRIN1',
  Trin2 = 'TRIN2',
  Trin3 = 'TRIN3',
  Trin4 = 'TRIN4',
  Trin5 = 'TRIN5',
  Trin6 = 'TRIN6',
  Trin7 = 'TRIN7',
  Trin8 = 'TRIN8',
  Trin9 = 'TRIN9',
  Trin10 = 'TRIN10',
  U1 = 'U1',
  U2 = 'U2',
  U3 = 'U3',
  U4 = 'U4',
  Ukendt = 'UKENDT',
  Vu = 'VU'
}

export type LevelOperationFilterInput = {
  eq?: InputMaybe<Level>;
  in?: InputMaybe<Array<Level>>;
  neq?: InputMaybe<Level>;
  nin?: InputMaybe<Array<Level>>;
};

export type ListEmployeeRoleOperationFilterInput = {
  all?: InputMaybe<EmployeeRoleOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeRoleOperationFilterInput>;
  some?: InputMaybe<EmployeeRoleOperationFilterInput>;
};

export type ListFilterInputTypeOfAffectedEntityFilterInput = {
  all?: InputMaybe<AffectedEntityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AffectedEntityFilterInput>;
  some?: InputMaybe<AffectedEntityFilterInput>;
};

export type ListFilterInputTypeOfBrugerAdgangFilterInput = {
  all?: InputMaybe<BrugerAdgangFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BrugerAdgangFilterInput>;
  some?: InputMaybe<BrugerAdgangFilterInput>;
};

export type ListFilterInputTypeOfBrugerAktivitetFilterInput = {
  all?: InputMaybe<BrugerAktivitetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BrugerAktivitetFilterInput>;
  some?: InputMaybe<BrugerAktivitetFilterInput>;
};

export type ListFilterInputTypeOfBrugerBeskedhandlingFilterInput = {
  all?: InputMaybe<BrugerBeskedhandlingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BrugerBeskedhandlingFilterInput>;
  some?: InputMaybe<BrugerBeskedhandlingFilterInput>;
};

export type ListFilterInputTypeOfBrugerFilterInput = {
  all?: InputMaybe<Institutionsreplika_BrugerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Institutionsreplika_BrugerFilterInput>;
  some?: InputMaybe<Institutionsreplika_BrugerFilterInput>;
};

export type ListFilterInputTypeOfBrugerInvitationFilterInput = {
  all?: InputMaybe<BrugerInvitationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BrugerInvitationFilterInput>;
  some?: InputMaybe<BrugerInvitationFilterInput>;
};

export type ListFilterInputTypeOfBrugerLoginLogFilterInput = {
  all?: InputMaybe<BrugerLoginLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BrugerLoginLogFilterInput>;
  some?: InputMaybe<BrugerLoginLogFilterInput>;
};

export type ListFilterInputTypeOfContactPersonFilterInput = {
  all?: InputMaybe<ContactPersonFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactPersonFilterInput>;
  some?: InputMaybe<ContactPersonFilterInput>;
};

export type ListFilterInputTypeOfGroupFilterInput = {
  all?: InputMaybe<GroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GroupFilterInput>;
  some?: InputMaybe<GroupFilterInput>;
};

export type ListFilterInputTypeOfGruppeInstitutionFilterInput = {
  all?: InputMaybe<GruppeInstitutionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GruppeInstitutionFilterInput>;
  some?: InputMaybe<GruppeInstitutionFilterInput>;
};

export type ListFilterInputTypeOfInstitutionFilterInput = {
  all?: InputMaybe<Institutionsreplika_InstitutionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Institutionsreplika_InstitutionFilterInput>;
  some?: InputMaybe<Institutionsreplika_InstitutionFilterInput>;
};

export type ListFilterInputTypeOfKommuneValideringsregelIndstillingFilterInput = {
  all?: InputMaybe<KommuneValideringsregelIndstillingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KommuneValideringsregelIndstillingFilterInput>;
  some?: InputMaybe<KommuneValideringsregelIndstillingFilterInput>;
};

export type ListFilterInputTypeOfKontrolInstitutionFilterInput = {
  all?: InputMaybe<KontrolInstitutionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KontrolInstitutionFilterInput>;
  some?: InputMaybe<KontrolInstitutionFilterInput>;
};

export type ListFilterInputTypeOfKontrolValideringsregelFilterInput = {
  all?: InputMaybe<KontrolValideringsregelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KontrolValideringsregelFilterInput>;
  some?: InputMaybe<KontrolValideringsregelFilterInput>;
};

export type ListFilterInputTypeOfKundeModulFilterInput = {
  all?: InputMaybe<KundeModulFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KundeModulFilterInput>;
  some?: InputMaybe<KundeModulFilterInput>;
};

export type ListFilterInputTypeOfModulHandlingFilterInput = {
  all?: InputMaybe<ModulHandlingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ModulHandlingFilterInput>;
  some?: InputMaybe<ModulHandlingFilterInput>;
};

export type ListFilterInputTypeOfModulIntegrationFilterInput = {
  all?: InputMaybe<ModulIntegrationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ModulIntegrationFilterInput>;
  some?: InputMaybe<ModulIntegrationFilterInput>;
};

export type ListFilterInputTypeOfResultatDisplayRelationFilterInput = {
  all?: InputMaybe<ResultatDisplayRelationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ResultatDisplayRelationFilterInput>;
  some?: InputMaybe<ResultatDisplayRelationFilterInput>;
};

export type ListFilterInputTypeOfResultatFilterInput = {
  all?: InputMaybe<ResultatFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ResultatFilterInput>;
  some?: InputMaybe<ResultatFilterInput>;
};

export type ListFilterInputTypeOfSkabelonInstitutionFilterInput = {
  all?: InputMaybe<SkabelonInstitutionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SkabelonInstitutionFilterInput>;
  some?: InputMaybe<SkabelonInstitutionFilterInput>;
};

export type ListFilterInputTypeOfSkabelonValideringsregelFilterInput = {
  all?: InputMaybe<SkabelonValideringsregelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SkabelonValideringsregelFilterInput>;
  some?: InputMaybe<SkabelonValideringsregelFilterInput>;
};

export type ListFilterInputTypeOfVariableFilterInput = {
  all?: InputMaybe<VariableFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VariableFilterInput>;
  some?: InputMaybe<VariableFilterInput>;
};

export type ListRolleEnumOperationFilterInput = {
  all?: InputMaybe<RolleEnumOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RolleEnumOperationFilterInput>;
  some?: InputMaybe<RolleEnumOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type ListUuidOperationFilterInput = {
  all?: InputMaybe<UuidOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UuidOperationFilterInput>;
  some?: InputMaybe<UuidOperationFilterInput>;
};

export type LokalKonfiguration = {
  __typename?: 'LokalKonfiguration';
  accessLevelChangePermission: AccessPermission;
  accessLevelInfoText?: Maybe<Scalars['String']['output']>;
  contactInformationText?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  daysLeftBeforeFirstReminder: Scalars['Int']['output'];
  daysLeftBeforeSecondReminder: Scalars['Int']['output'];
  daysLeftBeforeThirdAndFinalReminder: Scalars['Int']['output'];
  defaultAccessLevel: AccessLevel;
  domainActions: Array<DomainAction>;
  emailModtagere: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  includeMedarbejdereInElevadministrativeSystemer: Scalars['Boolean']['output'];
  includeMedarbejdereInElevadministrativeSystemerChangePermission: AccessPermission;
  kommuneKode: Scalars['Int']['output'];
  kontrolInterval: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  maxAntalMedarbejderePerBarn: Scalars['Int']['output'];
  organisationCvr: Scalars['String']['output'];
  organisationId: Scalars['UUID']['output'];
  organisationNavn: Scalars['String']['output'];
  pNummer?: Maybe<Scalars['String']['output']>;
};

export type LokalKonfigurationMutationModelInput = {
  accessLevelChangePermission?: InputMaybe<AccessPermission>;
  accessLevelInfoText?: InputMaybe<Scalars['String']['input']>;
  contactInformationText?: InputMaybe<Scalars['String']['input']>;
  daysBeforeFirstReminder?: InputMaybe<Scalars['Int']['input']>;
  daysBeforeSecondReminder?: InputMaybe<Scalars['Int']['input']>;
  daysBeforeThirdAndFinalReminder?: InputMaybe<Scalars['Int']['input']>;
  defaultAccessLevel?: InputMaybe<AccessLevel>;
  emailModtagere?: InputMaybe<Array<Scalars['String']['input']>>;
  includeMedarbejdereInElevadministrativeSystemer?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedarbejdereInElevadministrativeSystemerChangePermission?: InputMaybe<AccessPermission>;
  kontrolInterval?: InputMaybe<Scalars['Int']['input']>;
};

export type MedarbejderApiModulViewModel = {
  __typename?: 'MedarbejderApiModulViewModel';
  apiKey?: Maybe<Scalars['String']['output']>;
  displayText: Scalars['String']['output'];
  graviteeApplicationId?: Maybe<Scalars['String']['output']>;
  kundeModulId?: Maybe<Scalars['UUID']['output']>;
  oprindelse: MedarbejderApiOprindelse;
};

export enum MedarbejderApiOprindelse {
  FkOrg = 'FK_ORG',
  Import = 'IMPORT'
}

export type MedarbejderImportDatakildeViewModel = {
  __typename?: 'MedarbejderImportDatakildeViewModel';
  cpr: Scalars['String']['output'];
  instId?: Maybe<Scalars['String']['output']>;
  instNavn?: Maybe<Scalars['String']['output']>;
  instType?: Maybe<Scalars['String']['output']>;
  stilling?: Maybe<Scalars['String']['output']>;
};

export type Modul = {
  __typename?: 'Modul';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  modulKode: ModulKode;
  navn: Scalars['String']['output'];
};

export type ModulFilterInput = {
  and?: InputMaybe<Array<ModulFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  modulKode?: InputMaybe<ModulKodeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModulFilterInput>>;
};

export type ModulHandling = {
  __typename?: 'ModulHandling';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type ModulHandlingFilterInput = {
  and?: InputMaybe<Array<ModulHandlingFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ModulHandlingFilterInput>>;
};

export type ModulHandlingSortInput = {
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
};

export type ModulIntegration = {
  __typename?: 'ModulIntegration';
  beskrivelse?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  integrationId: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  noegle?: Maybe<Scalars['String']['output']>;
};

export type ModulIntegrationFilterInput = {
  and?: InputMaybe<Array<ModulIntegrationFilterInput>>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  integrationType?: InputMaybe<StringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  noegle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModulIntegrationFilterInput>>;
};

export type ModulIntegrationSortInput = {
  beskrivelse?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  integrationType?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  noegle?: InputMaybe<SortEnumType>;
};

export enum ModulKode {
  Di = 'DI',
  MedarbejderApi = 'MEDARBEJDER_API',
  SgdKontrol = 'SGD_KONTROL',
  Socialtilbud = 'SOCIALTILBUD',
  Tea = 'TEA',
  UdeladelserOgKontaktpersoner = 'UDELADELSER_OG_KONTAKTPERSONER'
}

export type ModulKodeOperationFilterInput = {
  eq?: InputMaybe<ModulKode>;
  in?: InputMaybe<Array<ModulKode>>;
  neq?: InputMaybe<ModulKode>;
  nin?: InputMaybe<Array<ModulKode>>;
};

export type ModulSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  modulKode?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  alias_deleteOutOfScope: DeleteOutOfScopePayload;
  brugerImpersonationToken: BrugerImpersonationTokenPayload;
  createKunde: CreateKundePayload;
  datakontrol_deleteOutOfScope: DeleteOutOfScopePayload;
  deleteGraviteeApplication: DeleteGraviteeApplicationPayload;
  deleteOutOfScope: Scalars['Int']['output'];
  fjernBarn: Scalars['UUID']['output'];
  fjernMedarbejder: Scalars['UUID']['output'];
  fjernMedarbejderFraBarn: Array<Scalars['UUID']['output']>;
  fjernTilbud: Scalars['UUID']['output'];
  fjernTilbudsTilknytning: Scalars['UUID']['output'];
  genererValideResultaterRapportMutation: GenererValideResultaterRapportMutationPayload;
  genkoerKontrolMutation: GenkoerKontrolMutationPayload;
  /**
   * Gensender kommunens CPR-hændelser fra IST Serviceplatform til Personreplika fra den givne dato og frem til nu.
   * Bruges når hændelser ikke er blevet behandlet, fx efter en fejl i Personreplika. Allerede behandlede hændelser springes over.
   */
  gensendCprHaendelserForKunde: GensendCprHaendelserForKundePayload;
  godkendTilbudsTilknytning: TilbudsTilknytning;
  /**
   * Super illegal and only for internal use as it bypasses all security checks.
   * Populates institutions for the given kommunekode unless it is already populated so worst case scenario is that it does nothing.
   */
  internalPopulateInstitutions: InternalPopulateInstitutionsPayload;
  opdaterKontrolInfoMutation: OpdaterKontrolInfoMutationPayload;
  opdaterKontrolResultatMutation: OpdaterKontrolResultatMutationPayload;
  opdaterKontrolStatusMutation: OpdaterKontrolStatusMutationPayload;
  opdaterLokalKonfigurationForOrganisation: LokalKonfiguration;
  opdaterMedarbejder: TilbudsMedarbejder;
  opdaterTilbud: Tilbud;
  opdaterTilbudregisterFraPortalen: Array<ChangedTilbudEntity>;
  opdaterTilbudsmedarbejderBarn: TilbudsmedarbejderBarn;
  opdaterTilbudsmedarbejderBarnGodkendelse: TilbudsmedarbejderBarnGodkendelse;
  opdaterTilknytning: TilbudsTilknytning;
  opretKontrolSkabelonMutation: OpretKontrolSkabelonMutationPayload;
  opretKontrolTilpassetMutation: OpretKontrolTilpassetMutationPayload;
  opretTilbud: Tilbud;
  /**
   * Genkører institutions-populeringen for den givne kommune (samme trin som køres automatisk ved
   * oprettelse af kunde). Bruges når en kunde ikke har fået institutioner hentet korrekt ned.
   */
  populateInstitutionerForKunde: PopulateInstitutionerForKundePayload;
  /** Populates institutions for the given kommunekode unless it is already populated */
  populateInstitutions: PopulateInstitutionsPayload;
  processInactiveKontroller: ProcessInactiveKontrollerPayload;
  processKontrollerPerformance: ProcessKontrollerPerformancePayload;
  processMedarbejderGyldigTil: Array<GyldigTilViewModel>;
  processNotifications: ProcessNotificationsPayload;
  processProtectedPersonsWithIncompleteAlias: ProcessProtectedPersonsWithIncompleteAliasPayload;
  processSystemKontroller: ProcessSystemKontrollerPayload;
  processTilbudsTilknytningGyldigTil: Array<GyldigTilViewModel>;
  provisionGraviteeApplication: ProvisionGraviteeApplicationPayload;
  removeDatakontrolModul: RemoveDatakontrolModulPayload;
  removeMedarbejderApiModul: RemoveMedarbejderApiModulPayload;
  removeSocialTilbudModul: RemoveSocialTilbudModulPayload;
  removeUdeladelserKontaktpersonerModul: RemoveUdeladelserKontaktpersonerModulPayload;
  /** @deprecated Don't use me, call the http://dataseeder/reseed end point */
  resetTestData: Scalars['Boolean']['output'];
  sletGruppeMutation: SletGruppeMutationPayload;
  sletKontrolMutation: SletKontrolMutationPayload;
  sletSkabelonMutation: SletSkabelonMutationPayload;
  supporttool_deleteOutOfScope: DeleteOutOfScopePayload;
  /** @deprecated Skal migreres til brugerTilknytning når dette er muligt */
  synchronizeKontrolloerInstitutionMutation: SynchronizeKontrolloerInstitutionMutationPayload;
  /** @deprecated Skal kun bruges indtil vi har migreret væk fra datakontrol. Brug UpsertInstitutionerForBruger i stedet. */
  synchronizeKontrolloerer: SynchronizeKontrolloererPayload;
  tilbudregister_deleteOutOfScope: Scalars['Int']['output'];
  tilknytBarnTilTilbud: TilbudsTilknytning;
  tilknytMedarbejderTilBarn: TilbudsmedarbejderBarn;
  tilknytNyMedarbejderTilbarn: TilbudsmedarbejderBarn;
  tilknytNytBarnTilTilbud: Barn;
  updateKunde: UpdateKundePayload;
  /** Opdaterer de tilknyttede brugere for en institution */
  upsertBrugereForInstitution: UpsertBrugereForInstitutionPayload;
  upsertDatakontrolModul: UpsertDatakontrolModulPayload;
  upsertGruppeMutation: UpsertGruppeMutationPayload;
  /** Opdaterer de tilknyttede institutioner for en bruger */
  upsertInstitutionerForBruger: UpsertInstitutionerForBrugerPayload;
  upsertKommuneValideringsreglerMutation: UpsertKommuneValideringsreglerMutationPayload;
  upsertMedarbejderApiModul: UpsertMedarbejderApiModulPayload;
  upsertRollemappings: UpsertRollemappingsPayload;
  upsertSkabelonMutation: UpsertSkabelonMutationPayload;
  upsertSocialTilbudModul: UpsertSocialTilbudModulPayload;
  upsertUdeladelserKontaktpersonerModul: UpsertUdeladelserKontaktpersonerModulPayload;
  validerTilbudsmedarbejderBarn: TilbudsTilknytning;
};


export type MutationAlias_DeleteOutOfScopeArgs = {
  input: DeleteOutOfScopeInput;
};


export type MutationBrugerImpersonationTokenArgs = {
  input: BrugerImpersonationTokenInput;
};


export type MutationCreateKundeArgs = {
  input: CreateKundeInput;
};


export type MutationDatakontrol_DeleteOutOfScopeArgs = {
  input: DeleteOutOfScopeInput;
};


export type MutationDeleteGraviteeApplicationArgs = {
  input: DeleteGraviteeApplicationInput;
};


export type MutationDeleteOutOfScopeArgs = {
  daysOutOfScopeThreshold: Scalars['Int']['input'];
};


export type MutationFjernBarnArgs = {
  barnId: Scalars['UUID']['input'];
};


export type MutationFjernMedarbejderArgs = {
  tilbudsMedarbejderId: Scalars['UUID']['input'];
};


export type MutationFjernMedarbejderFraBarnArgs = {
  tilbudId?: InputMaybe<Scalars['UUID']['input']>;
  tilbudsMedarbejderBarnIder: Array<Scalars['UUID']['input']>;
};


export type MutationFjernTilbudArgs = {
  tilbudId: Scalars['UUID']['input'];
};


export type MutationFjernTilbudsTilknytningArgs = {
  tilbudsTilknytningId: Scalars['UUID']['input'];
};


export type MutationGenererValideResultaterRapportMutationArgs = {
  input: GenererValideResultaterRapportMutationInput;
};


export type MutationGenkoerKontrolMutationArgs = {
  input: GenkoerKontrolMutationInput;
};


export type MutationGensendCprHaendelserForKundeArgs = {
  input: GensendCprHaendelserForKundeInput;
};


export type MutationGodkendTilbudsTilknytningArgs = {
  tilbudsTilknytningId: Scalars['UUID']['input'];
};


export type MutationInternalPopulateInstitutionsArgs = {
  input: InternalPopulateInstitutionsInput;
};


export type MutationOpdaterKontrolInfoMutationArgs = {
  input: OpdaterKontrolInfoMutationInput;
};


export type MutationOpdaterKontrolResultatMutationArgs = {
  input: OpdaterKontrolResultatMutationInput;
};


export type MutationOpdaterKontrolStatusMutationArgs = {
  input: OpdaterKontrolStatusMutationInput;
};


export type MutationOpdaterLokalKonfigurationForOrganisationArgs = {
  lokalKonfigurationMutationModel: LokalKonfigurationMutationModelInput;
};


export type MutationOpdaterMedarbejderArgs = {
  tilbudsmedarbejderMutationModel: TilbudsmedarbejderMutationModelInput;
};


export type MutationOpdaterTilbudArgs = {
  mutationModel: TilbudMutationModelInput;
};


export type MutationOpdaterTilbudregisterFraPortalenArgs = {
  referencedExternalIds: Array<Scalars['UUID']['input']>;
};


export type MutationOpdaterTilbudsmedarbejderBarnArgs = {
  mutationModel: TilbudsmedarbejderBarnMutationModelInput;
};


export type MutationOpdaterTilbudsmedarbejderBarnGodkendelseArgs = {
  tilbudsmedarbejderBarnGodkendelseMutationModel: TilbudsMedarbejderBarnGodkendelseMutationModelInput;
};


export type MutationOpdaterTilknytningArgs = {
  tilbudsTilknytningMutationModel: TilbudsTilknytningMutationModelInput;
};


export type MutationOpretKontrolSkabelonMutationArgs = {
  input: OpretKontrolSkabelonMutationInput;
};


export type MutationOpretKontrolTilpassetMutationArgs = {
  input: OpretKontrolTilpassetMutationInput;
};


export type MutationOpretTilbudArgs = {
  opretTilbud: OpretTilbudInput;
};


export type MutationPopulateInstitutionerForKundeArgs = {
  input: PopulateInstitutionerForKundeInput;
};


export type MutationPopulateInstitutionsArgs = {
  input: PopulateInstitutionsInput;
};


export type MutationProcessNotificationsArgs = {
  input: ProcessNotificationsInput;
};


export type MutationProvisionGraviteeApplicationArgs = {
  input: ProvisionGraviteeApplicationInput;
};


export type MutationRemoveDatakontrolModulArgs = {
  input: RemoveDatakontrolModulInput;
};


export type MutationRemoveMedarbejderApiModulArgs = {
  input: RemoveMedarbejderApiModulInput;
};


export type MutationRemoveSocialTilbudModulArgs = {
  input: RemoveSocialTilbudModulInput;
};


export type MutationRemoveUdeladelserKontaktpersonerModulArgs = {
  input: RemoveUdeladelserKontaktpersonerModulInput;
};


export type MutationSletGruppeMutationArgs = {
  input: SletGruppeMutationInput;
};


export type MutationSletKontrolMutationArgs = {
  input: SletKontrolMutationInput;
};


export type MutationSletSkabelonMutationArgs = {
  input: SletSkabelonMutationInput;
};


export type MutationSupporttool_DeleteOutOfScopeArgs = {
  input: DeleteOutOfScopeInput;
};


export type MutationSynchronizeKontrolloerInstitutionMutationArgs = {
  input: SynchronizeKontrolloerInstitutionMutationInput;
};


export type MutationSynchronizeKontrolloererArgs = {
  input: SynchronizeKontrolloererInput;
};


export type MutationTilbudregister_DeleteOutOfScopeArgs = {
  daysOutOfScopeThreshold: Scalars['Int']['input'];
};


export type MutationTilknytBarnTilTilbudArgs = {
  barnId: Scalars['UUID']['input'];
  gyldigFra: Scalars['Date']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
  tilbudId: Scalars['UUID']['input'];
};


export type MutationTilknytMedarbejderTilBarnArgs = {
  barnId: Scalars['UUID']['input'];
  tilbudsMedarbejderId: Scalars['UUID']['input'];
};


export type MutationTilknytNyMedarbejderTilbarnArgs = {
  aliasEfternavn?: InputMaybe<Scalars['String']['input']>;
  aliasFornavn?: InputMaybe<Scalars['String']['input']>;
  barnId: Scalars['UUID']['input'];
  cprNummer: Scalars['String']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationTilknytNytBarnTilTilbudArgs = {
  cprNummer: Scalars['String']['input'];
  gyldigFra: Scalars['Date']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
  tilbudId: Scalars['UUID']['input'];
};


export type MutationUpdateKundeArgs = {
  input: UpdateKundeInput;
};


export type MutationUpsertBrugereForInstitutionArgs = {
  input: UpsertBrugereForInstitutionInput;
};


export type MutationUpsertDatakontrolModulArgs = {
  input: UpsertDatakontrolModulInput;
};


export type MutationUpsertGruppeMutationArgs = {
  input: UpsertGruppeMutationInput;
};


export type MutationUpsertInstitutionerForBrugerArgs = {
  input: UpsertInstitutionerForBrugerInput;
};


export type MutationUpsertKommuneValideringsreglerMutationArgs = {
  input: UpsertKommuneValideringsreglerMutationInput;
};


export type MutationUpsertMedarbejderApiModulArgs = {
  input: UpsertMedarbejderApiModulInput;
};


export type MutationUpsertRollemappingsArgs = {
  input: UpsertRollemappingsInput;
};


export type MutationUpsertSkabelonMutationArgs = {
  input: UpsertSkabelonMutationInput;
};


export type MutationUpsertSocialTilbudModulArgs = {
  input: UpsertSocialTilbudModulInput;
};


export type MutationUpsertUdeladelserKontaktpersonerModulArgs = {
  input: UpsertUdeladelserKontaktpersonerModulInput;
};


export type MutationValiderTilbudsmedarbejderBarnArgs = {
  tilbudsTilknytningId: Scalars['UUID']['input'];
};

export type OpdaterKontrolInfoMutationError = DatakontrolMutationError;

export type OpdaterKontrolInfoMutationInput = {
  mutationModel: KontrolInfoMutationModelInput;
};

export type OpdaterKontrolInfoMutationPayload = {
  __typename?: 'OpdaterKontrolInfoMutationPayload';
  errors?: Maybe<Array<OpdaterKontrolInfoMutationError>>;
  kontrol?: Maybe<Kontrol>;
};

export type OpdaterKontrolResultatMutationError = DatakontrolMutationError;

export type OpdaterKontrolResultatMutationInput = {
  mutationModel: KontrolResultatMutationModelInput;
};

export type OpdaterKontrolResultatMutationPayload = {
  __typename?: 'OpdaterKontrolResultatMutationPayload';
  errors?: Maybe<Array<OpdaterKontrolResultatMutationError>>;
  resultat?: Maybe<Resultat>;
};

export type OpdaterKontrolStatusMutationError = DatakontrolMutationError;

export type OpdaterKontrolStatusMutationInput = {
  mutationModel: KontrolStatusMutationModelInput;
};

export type OpdaterKontrolStatusMutationPayload = {
  __typename?: 'OpdaterKontrolStatusMutationPayload';
  errors?: Maybe<Array<OpdaterKontrolStatusMutationError>>;
  kontrol?: Maybe<Kontrol>;
};

/** Typen af GraphQL-operationen aktiviteten stammer fra. */
export enum OperationType {
  Mutation = 'MUTATION',
  Query = 'QUERY',
  Subscription = 'SUBSCRIPTION'
}

export type OpretKontrolSkabelonMutationError = DatakontrolMutationError;

export type OpretKontrolSkabelonMutationInput = {
  kontrolMutationModel: KontrolSkabelonMutationModelInput;
};

export type OpretKontrolSkabelonMutationPayload = {
  __typename?: 'OpretKontrolSkabelonMutationPayload';
  errors?: Maybe<Array<OpretKontrolSkabelonMutationError>>;
  kontrol?: Maybe<Kontrol>;
};

export type OpretKontrolTilpassetMutationError = DatakontrolMutationError;

export type OpretKontrolTilpassetMutationInput = {
  kontrolMutationModel: KontrolMutationModelInput;
};

export type OpretKontrolTilpassetMutationPayload = {
  __typename?: 'OpretKontrolTilpassetMutationPayload';
  errors?: Maybe<Array<OpretKontrolTilpassetMutationError>>;
  kontrol?: Maybe<Kontrol>;
};

export type OpretTilbudInput = {
  bynavn: Scalars['String']['input'];
  cvr: Scalars['String']['input'];
  doer?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  husbogstav?: InputMaybe<Scalars['String']['input']>;
  husnummer: Scalars['String']['input'];
  kommune: Scalars['String']['input'];
  kommunekode?: InputMaybe<Scalars['String']['input']>;
  kontaktBemaerkning?: InputMaybe<Scalars['String']['input']>;
  mobil?: InputMaybe<Scalars['String']['input']>;
  navn: Scalars['String']['input'];
  oprettendeKommunesKommuneKode?: InputMaybe<Scalars['String']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  telefon?: InputMaybe<Scalars['String']['input']>;
  tilbudUUID?: InputMaybe<Scalars['UUID']['input']>;
  vejkode?: InputMaybe<Scalars['String']['input']>;
  vejnavn: Scalars['String']['input'];
};

export type OrganisationsEnhed = {
  __typename?: 'OrganisationsEnhed';
  created: Scalars['DateTime']['output'];
  ejendeOrganisation?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lokalKonfiguration: LokalKonfiguration;
  navn: Scalars['String']['output'];
  tilbudsTilknytninger: Array<TilbudsTilknytning>;
  tilbudsmedarbejderBoern: Array<TilbudsmedarbejderBarn>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PagedResultOfBrugerAktivitetDetalje = {
  __typename?: 'PagedResultOfBrugerAktivitetDetalje';
  items: Array<BrugerAktivitetDetalje>;
  totalCount: Scalars['Int']['output'];
};

export type PagedResultOfKommuneBorgerAktivitetSummary = {
  __typename?: 'PagedResultOfKommuneBorgerAktivitetSummary';
  items: Array<KommuneBorgerAktivitetSummary>;
  totalCount: Scalars['Int']['output'];
};

export type PagedResultOfKommuneMedarbejderAktivitetSummary = {
  __typename?: 'PagedResultOfKommuneMedarbejderAktivitetSummary';
  items: Array<KommuneMedarbejderAktivitetSummary>;
  totalCount: Scalars['Int']['output'];
};

export enum Pakke {
  Fuld = 'FULD',
  FuldMyndighed = 'FULD_MYNDIGHED',
  Lille = 'LILLE',
  Mellem = 'MELLEM'
}

export type Person = {
  __typename?: 'Person';
  adresse: Scalars['String']['output'];
  adresseBeskyttetFra?: Maybe<Scalars['Date']['output']>;
  adresseBeskyttetTil?: Maybe<Scalars['DateTime']['output']>;
  by: Scalars['String']['output'];
  cprNummer: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  efternavn: Scalars['String']['output'];
  f_dselsdato?: Maybe<Scalars['Date']['output']>;
  fornavn: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  postnummer: Scalars['Int']['output'];
  stednavn?: Maybe<Scalars['String']['output']>;
};

export type PersonFilterInput = {
  address?: InputMaybe<AddressFilterInput>;
  aliasFamilyName?: InputMaybe<StringOperationFilterInput>;
  aliasFirstName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PersonFilterInput>>;
  birthDate?: InputMaybe<DateOperationFilterInput>;
  civilRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  familyName?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  gender?: InputMaybe<GenderOperationFilterInput>;
  homePhoneNumber?: InputMaybe<PhoneNumberFilterInput>;
  mobilePhoneNumber?: InputMaybe<PhoneNumberFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  photoId?: InputMaybe<StringOperationFilterInput>;
  protected?: InputMaybe<BooleanOperationFilterInput>;
  verificationLevel?: InputMaybe<IntOperationFilterInput>;
  workPhoneNumber?: InputMaybe<PhoneNumberFilterInput>;
};

export type PersonSortInput = {
  address?: InputMaybe<AddressSortInput>;
  aliasFamilyName?: InputMaybe<SortEnumType>;
  aliasFirstName?: InputMaybe<SortEnumType>;
  birthDate?: InputMaybe<SortEnumType>;
  civilRegistrationNumber?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  familyName?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  gender?: InputMaybe<SortEnumType>;
  homePhoneNumber?: InputMaybe<PhoneNumberSortInput>;
  mobilePhoneNumber?: InputMaybe<PhoneNumberSortInput>;
  photoId?: InputMaybe<SortEnumType>;
  protected?: InputMaybe<SortEnumType>;
  verificationLevel?: InputMaybe<SortEnumType>;
  workPhoneNumber?: InputMaybe<PhoneNumberSortInput>;
};

export enum PersonType {
  Aegtefaelle = 'AEGTEFAELLE',
  AndenIndehaver = 'ANDEN_INDEHAVER',
  Employee = 'EMPLOYEE',
  Extern = 'EXTERN',
  Far = 'FAR',
  Mor = 'MOR',
  Student = 'STUDENT',
  Ukendt = 'UKENDT'
}

export type PersonTypeOperationFilterInput = {
  eq?: InputMaybe<PersonType>;
  in?: InputMaybe<Array<PersonType>>;
  neq?: InputMaybe<PersonType>;
  nin?: InputMaybe<Array<PersonType>>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  protected: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberFilterInput = {
  and?: InputMaybe<Array<PhoneNumberFilterInput>>;
  or?: InputMaybe<Array<PhoneNumberFilterInput>>;
  protected?: InputMaybe<BooleanOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type PhoneNumberSortInput = {
  protected?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type PopulateInstitutionerForKundeError = SupportToolMutationError;

export type PopulateInstitutionerForKundeInput = {
  kommunekode: Scalars['String']['input'];
};

export type PopulateInstitutionerForKundePayload = {
  __typename?: 'PopulateInstitutionerForKundePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<PopulateInstitutionerForKundeError>>;
};

export type PopulateInstitutionsError = InstitutionsreplikaMutationError;

export type PopulateInstitutionsInput = {
  /** Kommunekode for den aktive kommune */
  kommunekode: Scalars['String']['input'];
};

export type PopulateInstitutionsPayload = {
  __typename?: 'PopulateInstitutionsPayload';
  errors?: Maybe<Array<PopulateInstitutionsError>>;
  int?: Maybe<Scalars['Int']['output']>;
};

export type ProcessInactiveKontrollerError = DatakontrolMutationError;

export type ProcessInactiveKontrollerPayload = {
  __typename?: 'ProcessInactiveKontrollerPayload';
  errors?: Maybe<Array<ProcessInactiveKontrollerError>>;
  string?: Maybe<Scalars['String']['output']>;
};

export type ProcessKontrollerPerformanceError = DatakontrolMutationError;

export type ProcessKontrollerPerformancePayload = {
  __typename?: 'ProcessKontrollerPerformancePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<ProcessKontrollerPerformanceError>>;
};

export type ProcessNotificationsError = DatakontrolMutationError;

export type ProcessNotificationsInput = {
  kontrolAnsvarlige: Array<KommuneMedKontrolansvarligeInput>;
};

export type ProcessNotificationsPayload = {
  __typename?: 'ProcessNotificationsPayload';
  errors?: Maybe<Array<ProcessNotificationsError>>;
  string?: Maybe<Scalars['String']['output']>;
};

export type ProcessProtectedPersonsWithIncompleteAliasPayload = {
  __typename?: 'ProcessProtectedPersonsWithIncompleteAliasPayload';
  person?: Maybe<Array<AliasPerson>>;
};

export type ProcessSystemKontrollerError = DatakontrolMutationError;

export type ProcessSystemKontrollerPayload = {
  __typename?: 'ProcessSystemKontrollerPayload';
  errors?: Maybe<Array<ProcessSystemKontrollerError>>;
  string?: Maybe<Scalars['String']['output']>;
};

export type ProvisionGraviteeApplicationError = SupportToolMutationError;

export type ProvisionGraviteeApplicationInput = {
  mutationModel: CreateGraviteeApplicationMutationModelInput;
};

export type ProvisionGraviteeApplicationPayload = {
  __typename?: 'ProvisionGraviteeApplicationPayload';
  errors?: Maybe<Array<ProvisionGraviteeApplicationError>>;
  graviteeProvisioningResult?: Maybe<GraviteeProvisioningResult>;
};

export type Query = {
  __typename?: 'Query';
  activeTilbudsregisterIds: Array<Scalars['UUID']['output']>;
  /** Henter antal aktive børn */
  aktiveBoern: AggregationCount;
  /** Henter antal aktive tilbud */
  aktiveTilbud: AggregationCount;
  aliasPersons: Array<AliasPerson>;
  auditLog?: Maybe<AuditLogConnection>;
  boern: Array<Barn>;
  boernByIdRange: Array<Barn>;
  boernForKommuneKodeByCpr: Array<Barn>;
  borgerAktiviteter: PagedResultOfBrugerAktivitetDetalje;
  brugerAktiviteter: PagedResultOfBrugerAktivitetDetalje;
  /** Henter alle brugere der har en eller flere institutioner tilknyttet i kommunen */
  brugerTilkytninger?: Maybe<Replikabruger>;
  brugere: Array<BrugerViewModel>;
  cprForAktiveBoernForKommune: Array<Scalars['String']['output']>;
  /** Henter CPR navn */
  cprNavn?: Maybe<CpRdata>;
  datakontrolModule: DatakontrolModulViewModel;
  /** Returns the Name and Id for Kommune which have the CVR provided by the CurrentUser */
  environment: Environment;
  graviteeApiKeys: Array<GraviteeApiKey>;
  healthcheckStatus: HealthcheckStatusViewModel;
  /** Indgang til institutioner, afgrænset af brugerens kommunekode og jobfunktioner */
  institutions: Array<Replikainstitution>;
  /** Returns all information for the kommune of the authenticated user. */
  kommune?: Maybe<Kommune>;
  kommuneBorgerAktivitetOversigt: PagedResultOfKommuneBorgerAktivitetSummary;
  /** Returns all information for the kommune for the kommune kode */
  kommuneByKommuneKode?: Maybe<Kommune>;
  kommuneMedarbejderAktivitetOversigt: PagedResultOfKommuneMedarbejderAktivitetSummary;
  kontroller: Array<Kontrol>;
  kunder: Array<Kunde>;
  lokalKonfiguration: Array<Maybe<LokalKonfiguration>>;
  medarbejderAPIModule: MedarbejderApiModulViewModel;
  medarbejderApiModuleByKommunekode?: Maybe<MedarbejderApiModulViewModel>;
  medarbejderFagsystemDatakilder: Array<FagsystemMedarbejderDatakildeViewModel>;
  medarbejderImportDatakilder: Array<MedarbejderImportDatakildeViewModel>;
  organisationsEnhedByCVR: Array<Maybe<OrganisationsEnhed>>;
  organisationsNavne: Array<LokalKonfiguration>;
  pingDatabase: Scalars['String']['output'];
  searchTilbudInfo: Array<TilbudInfoSearch>;
  socialtilbudModule: SocialtilbudModulViewModel;
  soegTilbudInfo: Array<TilbudInfo>;
  tilbud: Array<Tilbud>;
  tilbudAdgange: Array<TilbudsAdgang>;
  tilbudByIdRange: Array<Tilbud>;
  tilbudIdsOnOrganisation: Array<Tilbud>;
  tilbudInfo: Array<TilbudInfo>;
  tilbudInfoByCVR: Array<Maybe<TilbudInfo>>;
  tilbudInfoByExternalIds: Array<Maybe<TilbudInfo>>;
  tilbudInformationForTEA: Array<Tilbud>;
  tilbudregister_pingDatabase: Scalars['String']['output'];
  tilbudsMedarbejdere: Array<TilbudsMedarbejder>;
  tilbudsMedarbejdereByIdRange: Array<TilbudsMedarbejder>;
  tilbudsmedarbejderWithBoernThatNeedsValidationWithLokalKonfiguration: Array<TilbudsmedarbejderWithLokalKonfigurationViewModel>;
  /**
   * Returns all Valideringsregler that exists in the system, filtered by the current user's kommune access.
   * MedarbejderAPI rules are only visible if the kommune has enabled MedarbejderAPI in Support Tool settings.
   */
  valideringsregler?: Maybe<ValideringsreglerConnection>;
};


export type QueryAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BrugerSortInput>>;
  where?: InputMaybe<BrugerFilterInput>;
};


export type QueryBoernArgs = {
  grace?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryBoernByIdRangeArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryBoernForKommuneKodeByCprArgs = {
  cprNumre: Array<Scalars['String']['input']>;
  kommuneKode: Scalars['Int']['input'];
};


export type QueryBorgerAktiviteterArgs = {
  entityId: Scalars['UUID']['input'];
  fra: Scalars['DateTime']['input'];
  skip: Scalars['Int']['input'];
  soegetekst?: InputMaybe<Scalars['String']['input']>;
  sorteringStigende?: InputMaybe<Scalars['Boolean']['input']>;
  take: Scalars['Int']['input'];
  til: Scalars['DateTime']['input'];
  type?: InputMaybe<OperationType>;
};


export type QueryBrugerAktiviteterArgs = {
  brugerId: Scalars['Int']['input'];
  fra: Scalars['DateTime']['input'];
  skip: Scalars['Int']['input'];
  soegetekst?: InputMaybe<Scalars['String']['input']>;
  sorteringStigende?: InputMaybe<Scalars['Boolean']['input']>;
  take: Scalars['Int']['input'];
  til: Scalars['DateTime']['input'];
  type?: InputMaybe<OperationType>;
};


export type QueryBrugereArgs = {
  kundeId: Scalars['UUID']['input'];
};


export type QueryCprForAktiveBoernForKommuneArgs = {
  kommuneKode: Scalars['Int']['input'];
};


export type QueryCprNavnArgs = {
  boernId?: InputMaybe<Scalars['String']['input']>;
  cpr?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDatakontrolModuleArgs = {
  kundeId: Scalars['UUID']['input'];
  kundeModulId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGraviteeApiKeysArgs = {
  applicationId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type QueryInstitutionsArgs = {
  order?: InputMaybe<Array<InstitutionSortInput>>;
  where?: InputMaybe<InstitutionFilterInput>;
};


export type QueryKommuneBorgerAktivitetOversigtArgs = {
  fra: Scalars['DateTime']['input'];
  kommunekode: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  til: Scalars['DateTime']['input'];
};


export type QueryKommuneByKommuneKodeArgs = {
  kommuneKode: Scalars['Int']['input'];
};


export type QueryKommuneMedarbejderAktivitetOversigtArgs = {
  fra: Scalars['DateTime']['input'];
  kommunekode: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  til: Scalars['DateTime']['input'];
};


export type QueryKontrollerArgs = {
  kontrolId?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<Array<KontrolSortInput>>;
  where?: InputMaybe<KontrolFilterInput>;
};


export type QueryKunderArgs = {
  where?: InputMaybe<KundeFilterInput>;
};


export type QueryMedarbejderApiModuleArgs = {
  kundeId: Scalars['UUID']['input'];
  kundeModulId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMedarbejderApiModuleByKommunekodeArgs = {
  kommunekode: Scalars['String']['input'];
};


export type QueryOrganisationsEnhedByCvrArgs = {
  cvr: Scalars['String']['input'];
};


export type QuerySearchTilbudInfoArgs = {
  soegEfter: Scalars['String']['input'];
};


export type QuerySocialtilbudModuleArgs = {
  kundeId: Scalars['UUID']['input'];
  kundeModulId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySoegTilbudInfoArgs = {
  ids: Array<Scalars['UUID']['input']>;
  soegEfter: Scalars['String']['input'];
};


export type QueryTilbudArgs = {
  grace?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTilbudByIdRangeArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryTilbudInfoByCvrArgs = {
  cvr: Scalars['String']['input'];
};


export type QueryTilbudInfoByExternalIdsArgs = {
  ids: Scalars['String']['input'];
};


export type QueryTilbudInformationForTeaArgs = {
  cpr: Scalars['String']['input'];
};


export type QueryTilbudsMedarbejdereArgs = {
  grace?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTilbudsMedarbejdereByIdRangeArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryValideringsreglerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ValideringsregelSortInput>>;
  where?: InputMaybe<ValideringsregelFilterInput>;
};

export enum RecieverType {
  Direct = 'DIRECT',
  Kommune = 'KOMMUNE',
  Socialtilbud = 'SOCIALTILBUD'
}

export type RecieverTypeOperationFilterInput = {
  eq?: InputMaybe<RecieverType>;
  in?: InputMaybe<Array<RecieverType>>;
  neq?: InputMaybe<RecieverType>;
  nin?: InputMaybe<Array<RecieverType>>;
};

export type RegistrendeKommuneInfo = {
  __typename?: 'RegistrendeKommuneInfo';
  accessLevelChangePermission: AccessPermission;
  accessLevelInfoText: Scalars['String']['output'];
  contactInformationText: Scalars['String']['output'];
  defaultAccessLevel: AccessLevel;
  maxAntalMedarbejderePerBarn: Scalars['Int']['output'];
  navn: Scalars['String']['output'];
};

export type Relation = {
  __typename?: 'Relation';
  alias: Scalars['String']['output'];
  beskrivelse: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  personId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type RelationOperationFilterInput = {
  eq?: InputMaybe<Serviceplatformen_Ws10_Relation>;
  in?: InputMaybe<Array<Serviceplatformen_Ws10_Relation>>;
  neq?: InputMaybe<Serviceplatformen_Ws10_Relation>;
  nin?: InputMaybe<Array<Serviceplatformen_Ws10_Relation>>;
};

export type RemoveDatakontrolModulError = SupportToolMutationError;

export type RemoveDatakontrolModulInput = {
  mutationModel: RemoveDatakontrolModulMutationModelInput;
};

export type RemoveDatakontrolModulMutationModelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
};

export type RemoveDatakontrolModulPayload = {
  __typename?: 'RemoveDatakontrolModulPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveDatakontrolModulError>>;
};

export type RemoveMedarbejderApiModulError = SupportToolMutationError;

export type RemoveMedarbejderApiModulInput = {
  mutationModel: UpsertMedarbejderApiModulMutationModelInput;
};

export type RemoveMedarbejderApiModulPayload = {
  __typename?: 'RemoveMedarbejderApiModulPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveMedarbejderApiModulError>>;
};

export type RemoveSocialTilbudModulError = SupportToolMutationError;

export type RemoveSocialTilbudModulInput = {
  mutationModel: RemoveSocialtilbudModulMutationModelInput;
};

export type RemoveSocialTilbudModulPayload = {
  __typename?: 'RemoveSocialTilbudModulPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveSocialTilbudModulError>>;
};

export type RemoveSocialtilbudModulMutationModelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
};

export type RemoveUdeladelserKontaktpersonerModulError = SupportToolMutationError;

export type RemoveUdeladelserKontaktpersonerModulInput = {
  mutationModel: UpsertUdeladelserKontaktpersonerModulMutationModelInput;
};

export type RemoveUdeladelserKontaktpersonerModulPayload = {
  __typename?: 'RemoveUdeladelserKontaktpersonerModulPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveUdeladelserKontaktpersonerModulError>>;
};

export type Replikabruger = {
  __typename?: 'Replikabruger';
  brugerId: Scalars['UUID']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  tilknyttedeInstitutioner: Array<Replikainstitution>;
};


export type ReplikabrugerTilknyttedeInstitutionerArgs = {
  order?: InputMaybe<Array<Institutionsreplika_InstitutionSortInput>>;
  where?: InputMaybe<Institutionsreplika_InstitutionFilterInput>;
};

export type Replikainstitution = {
  __typename?: 'Replikainstitution';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  institutionType: Institutionstype;
  institutionskode: Scalars['String']['output'];
  kommunekode: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  tilknyttedeBrugere: Array<Replikabruger>;
  ws10?: Maybe<Ws10Institution>;
  ws17?: Maybe<Ws17Institution>;
};


export type ReplikainstitutionTilknyttedeBrugereArgs = {
  order?: InputMaybe<Array<Institutionsreplika_BrugerSortInput>>;
  where?: InputMaybe<Institutionsreplika_BrugerFilterInput>;
};

export type Resultat = {
  __typename?: 'Resultat';
  barnHovedgruppe?: Maybe<Scalars['String']['output']>;
  behandletAfPersonNavn?: Maybe<Scalars['String']['output']>;
  behandletDato?: Maybe<Scalars['Date']['output']>;
  behandletPersonNavn: Scalars['String']['output'];
  /**
   * The note from a completed Alias-besked concerning this person, materialized onto the Resultat
   * at kontrol creation. Shown as a fallback "Tidligere handling" when no real one exists.
   */
  beskedHandling?: Maybe<BeskedHandling>;
  beskrivelse?: Maybe<Scalars['String']['output']>;
  cpr: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** @deprecated Replaced by DisplayValue */
  displayText: Scalars['String']['output'];
  displayValue?: Maybe<ResultatDisplayValue>;
  handling: ResultatHandlingEnum;
  id: Scalars['UUID']['output'];
  institution: Institution;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  personType: ResultatPersonType;
  relationCpr?: Maybe<Scalars['String']['output']>;
  relationName?: Maybe<Scalars['String']['output']>;
  relationType?: Maybe<Scalars['String']['output']>;
  tidligereResultater: Array<BaseResultat>;
  vaerdi: ValideringsregelIndstillingValueEnum;
  valideringsregel: Valideringsregel;
};

export type ResultatDisplayRelation = {
  __typename?: 'ResultatDisplayRelation';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  relationGruppe?: Maybe<Scalars['String']['output']>;
  relationName?: Maybe<Scalars['String']['output']>;
  relationType?: Maybe<Scalars['String']['output']>;
};

export type ResultatDisplayRelationFilterInput = {
  and?: InputMaybe<Array<ResultatDisplayRelationFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ResultatDisplayRelationFilterInput>>;
  relationGruppe?: InputMaybe<StringOperationFilterInput>;
  relationName?: InputMaybe<StringOperationFilterInput>;
  relationType?: InputMaybe<StringOperationFilterInput>;
};

export type ResultatDisplayValue = {
  __typename?: 'ResultatDisplayValue';
  created: Scalars['DateTime']['output'];
  gruppe?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  relations?: Maybe<Array<ResultatDisplayRelation>>;
};

export type ResultatDisplayValueFilterInput = {
  and?: InputMaybe<Array<ResultatDisplayValueFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  gruppe?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResultatDisplayValueFilterInput>>;
  relations?: InputMaybe<ListFilterInputTypeOfResultatDisplayRelationFilterInput>;
};

export type ResultatDisplayValueSortInput = {
  created?: InputMaybe<SortEnumType>;
  gruppe?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type ResultatFilterInput = {
  and?: InputMaybe<Array<ResultatFilterInput>>;
  barnHovedgruppe?: InputMaybe<StringOperationFilterInput>;
  behandletAfPersonNavn?: InputMaybe<StringOperationFilterInput>;
  behandletDato?: InputMaybe<DateOperationFilterInput>;
  behandletPersonNavn?: InputMaybe<StringOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  cpr?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  displayText?: InputMaybe<StringOperationFilterInput>;
  displayValue?: InputMaybe<ResultatDisplayValueFilterInput>;
  handling?: InputMaybe<ResultatHandlingEnumOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institution?: InputMaybe<InstitutionFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResultatFilterInput>>;
  personType?: InputMaybe<ResultatPersonTypeOperationFilterInput>;
  relationCpr?: InputMaybe<StringOperationFilterInput>;
  relationName?: InputMaybe<StringOperationFilterInput>;
  relationType?: InputMaybe<StringOperationFilterInput>;
  vaerdi?: InputMaybe<ValideringsregelIndstillingValueEnumOperationFilterInput>;
  valideringsregel?: InputMaybe<ValideringsregelFilterInput>;
};

export enum ResultatHandlingEnum {
  Beholdt = 'BEHOLDT',
  Mangler = 'MANGLER',
  Rettet = 'RETTET'
}

export type ResultatHandlingEnumOperationFilterInput = {
  eq?: InputMaybe<ResultatHandlingEnum>;
  in?: InputMaybe<Array<ResultatHandlingEnum>>;
  neq?: InputMaybe<ResultatHandlingEnum>;
  nin?: InputMaybe<Array<ResultatHandlingEnum>>;
};

export enum ResultatPersonType {
  Barn = 'BARN',
  Medarbejder = 'MEDARBEJDER'
}

export type ResultatPersonTypeOperationFilterInput = {
  eq?: InputMaybe<ResultatPersonType>;
  in?: InputMaybe<Array<ResultatPersonType>>;
  neq?: InputMaybe<ResultatPersonType>;
  nin?: InputMaybe<Array<ResultatPersonType>>;
};

export type ResultatSortInput = {
  barnHovedgruppe?: InputMaybe<SortEnumType>;
  behandletAfPersonNavn?: InputMaybe<SortEnumType>;
  behandletDato?: InputMaybe<SortEnumType>;
  behandletPersonNavn?: InputMaybe<SortEnumType>;
  beskrivelse?: InputMaybe<SortEnumType>;
  cpr?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  displayText?: InputMaybe<SortEnumType>;
  displayValue?: InputMaybe<ResultatDisplayValueSortInput>;
  handling?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institution?: InputMaybe<InstitutionSortInput>;
  lastUpdated?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  personType?: InputMaybe<SortEnumType>;
  relationCpr?: InputMaybe<SortEnumType>;
  relationName?: InputMaybe<SortEnumType>;
  relationType?: InputMaybe<SortEnumType>;
  vaerdi?: InputMaybe<SortEnumType>;
  valideringsregel?: InputMaybe<ValideringsregelSortInput>;
};

export enum RolleEnum {
  Ekstern = 'EKSTERN',
  Konsulent = 'KONSULENT',
  Ledelse = 'LEDELSE',
  Leder = 'LEDER',
  Laerer = 'Laerer',
  Praktikant = 'PRAKTIKANT',
  Paedagog = 'Paedagog',
  Tap = 'TAP',
  Ukendt = 'UKENDT',
  Vikar = 'VIKAR'
}

export type RolleEnumOperationFilterInput = {
  eq?: InputMaybe<RolleEnum>;
  in?: InputMaybe<Array<RolleEnum>>;
  neq?: InputMaybe<RolleEnum>;
  nin?: InputMaybe<Array<RolleEnum>>;
};

export type Rollemapping = {
  __typename?: 'Rollemapping';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  roller: Array<RolleEnum>;
  stillingsbetegnelse: Scalars['String']['output'];
};

export type RollemappingFilterInput = {
  and?: InputMaybe<Array<RollemappingFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RollemappingFilterInput>>;
  roller?: InputMaybe<ListRolleEnumOperationFilterInput>;
  stillingsbetegnelse?: InputMaybe<StringOperationFilterInput>;
};

export type RollemappingSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  stillingsbetegnelse?: InputMaybe<SortEnumType>;
};

export type Skabelon = {
  __typename?: 'Skabelon';
  created: Scalars['DateTime']['output'];
  deadlineDays: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  intervalDays: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
  skabelonInstitutioner: Array<SkabelonInstitution>;
  skabelonValideringsregler: Array<SkabelonValideringsregel>;
  type: DatakontrolTypeEnum;
};


export type SkabelonSkabelonInstitutionerArgs = {
  order?: InputMaybe<Array<SkabelonInstitutionSortInput>>;
  where?: InputMaybe<SkabelonInstitutionFilterInput>;
};


export type SkabelonSkabelonValideringsreglerArgs = {
  order?: InputMaybe<Array<SkabelonValideringsregelSortInput>>;
  where?: InputMaybe<SkabelonValideringsregelFilterInput>;
};

export type SkabelonFilterInput = {
  and?: InputMaybe<Array<SkabelonFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  deadlineDays?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  intervalDays?: InputMaybe<IntOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SkabelonFilterInput>>;
  skabelonInstitutioner?: InputMaybe<ListFilterInputTypeOfSkabelonInstitutionFilterInput>;
  skabelonValideringsregler?: InputMaybe<ListFilterInputTypeOfSkabelonValideringsregelFilterInput>;
  type?: InputMaybe<DatakontrolTypeEnumOperationFilterInput>;
};

export type SkabelonInstitution = {
  __typename?: 'SkabelonInstitution';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  institution: Institution;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  skabelon: Skabelon;
};

export type SkabelonInstitutionFilterInput = {
  and?: InputMaybe<Array<SkabelonInstitutionFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institution?: InputMaybe<InstitutionFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SkabelonInstitutionFilterInput>>;
  skabelon?: InputMaybe<SkabelonFilterInput>;
};

export type SkabelonInstitutionSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institution?: InputMaybe<InstitutionSortInput>;
  lastUpdated?: InputMaybe<SortEnumType>;
  skabelon?: InputMaybe<SkabelonSortInput>;
};

export type SkabelonSortInput = {
  created?: InputMaybe<SortEnumType>;
  deadlineDays?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  intervalDays?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type SkabelonValideringsregel = {
  __typename?: 'SkabelonValideringsregel';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  skabelon: Skabelon;
  valideringsregel: Valideringsregel;
};

export type SkabelonValideringsregelFilterInput = {
  and?: InputMaybe<Array<SkabelonValideringsregelFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SkabelonValideringsregelFilterInput>>;
  skabelon?: InputMaybe<SkabelonFilterInput>;
  valideringsregel?: InputMaybe<ValideringsregelFilterInput>;
};

export type SkabelonValideringsregelSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  skabelon?: InputMaybe<SkabelonSortInput>;
  valideringsregel?: InputMaybe<ValideringsregelSortInput>;
};

export type SletGruppeMutationError = DatakontrolMutationError;

export type SletGruppeMutationInput = {
  mutationModel: SletGruppeMutationModelInput;
};

export type SletGruppeMutationModelInput = {
  gruppeId: Scalars['UUID']['input'];
};

export type SletGruppeMutationPayload = {
  __typename?: 'SletGruppeMutationPayload';
  errors?: Maybe<Array<SletGruppeMutationError>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type SletKontrolMutationError = DatakontrolMutationError;

export type SletKontrolMutationInput = {
  mutationModel: SletKontrolMutationModelInput;
};

export type SletKontrolMutationModelInput = {
  kontrolId: Scalars['UUID']['input'];
};

export type SletKontrolMutationPayload = {
  __typename?: 'SletKontrolMutationPayload';
  errors?: Maybe<Array<SletKontrolMutationError>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type SletSkabelonMutationError = DatakontrolMutationError;

export type SletSkabelonMutationInput = {
  mutationModel: SletSkabelonMutationModelInput;
};

export type SletSkabelonMutationModelInput = {
  skabelonId: Scalars['UUID']['input'];
};

export type SletSkabelonMutationPayload = {
  __typename?: 'SletSkabelonMutationPayload';
  errors?: Maybe<Array<SletSkabelonMutationError>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type SocialtilbudModulViewModel = {
  __typename?: 'SocialtilbudModulViewModel';
  beskedfordelerServiceAftaleUUID?: Maybe<Scalars['UUID']['output']>;
  cprOpslagServiceAftaleUUID?: Maybe<Scalars['UUID']['output']>;
  displayText: Scalars['String']['output'];
  kundeModulId?: Maybe<Scalars['UUID']['output']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StudentFilterInput = {
  and?: InputMaybe<Array<StudentFilterInput>>;
  contactPersons?: InputMaybe<ListFilterInputTypeOfContactPersonFilterInput>;
  groupIds?: InputMaybe<ListStringOperationFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfGroupFilterInput>;
  level?: InputMaybe<LevelOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  mainGroup?: InputMaybe<GroupFilterInput>;
  mainGroupId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StudentFilterInput>>;
  role?: InputMaybe<StudentRoleOperationFilterInput>;
  studentNumber?: InputMaybe<StringOperationFilterInput>;
};

export enum StudentRole {
  Barn = 'BARN',
  Elev = 'ELEV',
  Studerende = 'STUDERENDE',
  Ukendt = 'UKENDT'
}

export type StudentRoleOperationFilterInput = {
  eq?: InputMaybe<StudentRole>;
  in?: InputMaybe<Array<StudentRole>>;
  neq?: InputMaybe<StudentRole>;
  nin?: InputMaybe<Array<StudentRole>>;
};

export type StudentSortInput = {
  level?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  mainGroup?: InputMaybe<GroupSortInput>;
  mainGroupId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  studentNumber?: InputMaybe<SortEnumType>;
};

export type SupportToolMutationError = Error & {
  __typename?: 'SupportToolMutationError';
  contextData: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SynchronizeKontrolloerInstitutionMutationError = DatakontrolMutationError;

export type SynchronizeKontrolloerInstitutionMutationInput = {
  mutationModel: UpsertKontrolloerInstitutionMutationModelInput;
};

export type SynchronizeKontrolloerInstitutionMutationPayload = {
  __typename?: 'SynchronizeKontrolloerInstitutionMutationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<SynchronizeKontrolloerInstitutionMutationError>>;
};

export type SynchronizeKontrolloererError = InstitutionsreplikaMutationError;

export type SynchronizeKontrolloererInput = {
  /** Brugernes ExternalId */
  brugerIds: Array<Scalars['UUID']['input']>;
  /** Institutionenes externalId */
  institutionExternalId: Scalars['UUID']['input'];
  /** Kommunekode for den aktive kommune */
  kommunekode: Scalars['String']['input'];
};

export type SynchronizeKontrolloererPayload = {
  __typename?: 'SynchronizeKontrolloererPayload';
  errors?: Maybe<Array<SynchronizeKontrolloererError>>;
  institution?: Maybe<Replikainstitution>;
};

export type Tilbud = {
  __typename?: 'Tilbud';
  antalBarnManglerGodkendelse: Scalars['Long']['output'];
  antalBarnManglerMedarbejder: Scalars['Long']['output'];
  antalBarnManglerValidering: Scalars['Long']['output'];
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  grace?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  includeMedarbejdereInElevadministrativeSystemer: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  tilbudInfo: TilbudInfo;
  tilbudsMedarbejdere: Array<TilbudsMedarbejder>;
  tilbudsTilknytninger: Array<TilbudsTilknytning>;
  tilbudsregisterId: Scalars['UUID']['output'];
};

export type TilbudInfo = {
  __typename?: 'TilbudInfo';
  afdeling_UUID: Scalars['UUID']['output'];
  afdelingsnavn: Scalars['String']['output'];
  alreadyAdded: Scalars['Boolean']['output'];
  bynavn: Scalars['String']['output'];
  cprNummer?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  cvrNummer?: Maybe<Scalars['String']['output']>;
  doer: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  husbogstav: Scalars['String']['output'];
  husnummer: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  kommune: Scalars['String']['output'];
  kommunekode: Scalars['String']['output'];
  kontaktBemaerkning?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lokaltOprettet: Scalars['Boolean']['output'];
  mobil?: Maybe<Scalars['String']['output']>;
  oprettetAfKommuneKode?: Maybe<Scalars['String']['output']>;
  pNummer?: Maybe<Scalars['String']['output']>;
  postnummer: Scalars['String']['output'];
  region: Scalars['String']['output'];
  telefon?: Maybe<Scalars['String']['output']>;
  tilbud_UUID: Scalars['UUID']['output'];
  tilbudsadresse: Scalars['String']['output'];
  tilbudsnavn: Scalars['String']['output'];
  vejkode: Scalars['String']['output'];
  vejnavn: Scalars['String']['output'];
  virksomhedsform: Scalars['String']['output'];
};

export type TilbudInfoSearch = {
  __typename?: 'TilbudInfoSearch';
  afdeling_UUID: Scalars['UUID']['output'];
  afdelingsnavn: Scalars['String']['output'];
  alreadyAdded: Scalars['Boolean']['output'];
  bynavn: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  cvrNummer?: Maybe<Scalars['String']['output']>;
  husnummer: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  kommune: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  oprettendeKommune: Scalars['String']['output'];
  postnummer: Scalars['String']['output'];
  tilbud_UUID: Scalars['UUID']['output'];
  tilbudsadresse: Scalars['String']['output'];
  tilbudsnavn: Scalars['String']['output'];
  vejnavn: Scalars['String']['output'];
};

export type TilbudMutationModelInput = {
  bynavn?: InputMaybe<Scalars['String']['input']>;
  doer?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  husbogstav?: InputMaybe<Scalars['String']['input']>;
  husnummer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  includeMedarbejdereInElevadministrativeSystemer?: InputMaybe<Scalars['Boolean']['input']>;
  kommunekode?: InputMaybe<Scalars['String']['input']>;
  kontaktBemaerkning?: InputMaybe<Scalars['String']['input']>;
  mobil?: InputMaybe<Scalars['String']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  telefon?: InputMaybe<Scalars['String']['input']>;
  tilbudsnavn?: InputMaybe<Scalars['String']['input']>;
  vejkode?: InputMaybe<Scalars['String']['input']>;
  vejnavn?: InputMaybe<Scalars['String']['input']>;
};

export type TilbudsAdgang = {
  __typename?: 'TilbudsAdgang';
  cvrNummer: Scalars['String']['output'];
  externalId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type TilbudsMedarbejder = {
  __typename?: 'TilbudsMedarbejder';
  aliasEfternavn?: Maybe<Scalars['String']['output']>;
  aliasFornavn?: Maybe<Scalars['String']['output']>;
  antalAktiveBoern: Scalars['Long']['output'];
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  grace?: Maybe<Scalars['Int']['output']>;
  gyldigTil: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  person: Person;
  personReplikaId: Scalars['UUID']['output'];
  tilbud: Tilbud;
  tilbudsmedarbejderBoern: Array<TilbudsmedarbejderBarn>;
  type: TilbudsmedarbejderType;
};

export type TilbudsMedarbejderBarnGodkendelseMutationModelInput = {
  antalNotifikationerSendt?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  naesteGodkendelseInden?: InputMaybe<Scalars['DateTime']['input']>;
  valideretAf?: InputMaybe<Scalars['String']['input']>;
  valideretAfBrugerExternalId?: InputMaybe<Scalars['UUID']['input']>;
  valideretTidspunkt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TilbudsTilknytning = {
  __typename?: 'TilbudsTilknytning';
  barn: Barn;
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  godkendelse: TilbudsTilknytningGodkendelse;
  godkendelseId: Scalars['Int']['output'];
  gyldigFra: Scalars['Date']['output'];
  gyldigTil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  tilbud: Tilbud;
};

export type TilbudsTilknytningGodkendelse = {
  __typename?: 'TilbudsTilknytningGodkendelse';
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  manglerGodkendelse: Scalars['Boolean']['output'];
  valideretAf?: Maybe<Scalars['String']['output']>;
  valideretTidspunkt?: Maybe<Scalars['DateTime']['output']>;
};

export type TilbudsTilknytningMutationModelInput = {
  gyldigFra: Scalars['Date']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
};

export type TilbudsmedarbejderBarn = {
  __typename?: 'TilbudsmedarbejderBarn';
  accessLevel: AccessLevel;
  barn: Barn;
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  godkendelse: TilbudsmedarbejderBarnGodkendelse;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  tilbudsMedarbejder: TilbudsMedarbejder;
  tilbudsMedarbejderId: Scalars['Int']['output'];
};

export type TilbudsmedarbejderBarnGodkendelse = {
  __typename?: 'TilbudsmedarbejderBarnGodkendelse';
  antalNotifikationerSendt: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  domainActions: Array<DomainAction>;
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  naesteGodkendelseInden: Scalars['DateTime']['output'];
  valideretAf?: Maybe<Scalars['String']['output']>;
  valideretTidspunkt?: Maybe<Scalars['DateTime']['output']>;
};

export type TilbudsmedarbejderBarnMutationModelInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  barnId: Scalars['UUID']['input'];
  medarbejderId: Scalars['UUID']['input'];
};

export type TilbudsmedarbejderMutationModelInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasEfternavn?: InputMaybe<Scalars['String']['input']>;
  aliasFornavn?: InputMaybe<Scalars['String']['input']>;
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
  hasFullAccessLevel?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  type?: InputMaybe<TilbudsmedarbejderType>;
};

export enum TilbudsmedarbejderType {
  Type1 = 'TYPE1',
  Type2 = 'TYPE2',
  Type3 = 'TYPE3'
}

export type TilbudsmedarbejderWithLokalKonfigurationViewModel = {
  __typename?: 'TilbudsmedarbejderWithLokalKonfigurationViewModel';
  lokalKonfiguration: LokalKonfiguration;
  tilbudsmedarbejder: TilbudsMedarbejder;
};

export enum TilbudsportalChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Exchanged = 'EXCHANGED',
  Updated = 'UPDATED'
}

export type UniLoginFilterInput = {
  and?: InputMaybe<Array<UniLoginFilterInput>>;
  or?: InputMaybe<Array<UniLoginFilterInput>>;
  /** Unikt brugerid (UniID) */
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type UniLoginSortInput = {
  /** Unikt brugerid (UniID) */
  userId?: InputMaybe<SortEnumType>;
};

export type UdeladelserKontakpersonerModulViewModel = {
  __typename?: 'UdeladelserKontakpersonerModulViewModel';
  displayText: Scalars['String']['output'];
  kundeModulId?: Maybe<Scalars['UUID']['output']>;
};

export type UpdateKundeError = SupportToolMutationError;

export type UpdateKundeInput = {
  mutationModel: UpdateKundeMutationModelInput;
};

export type UpdateKundeMutationModelInput = {
  cvr?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  navn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateKundePayload = {
  __typename?: 'UpdateKundePayload';
  errors?: Maybe<Array<UpdateKundeError>>;
  kunde?: Maybe<Kunde>;
};

export type UpsertBrugereForInstitutionError = InstitutionsreplikaMutationError;

export type UpsertBrugereForInstitutionInput = {
  /** Brugernes ExternalId */
  brugerIds: Array<Scalars['UUID']['input']>;
  /** Institutionenes externalId */
  institutionExternalId: Scalars['UUID']['input'];
};

export type UpsertBrugereForInstitutionPayload = {
  __typename?: 'UpsertBrugereForInstitutionPayload';
  errors?: Maybe<Array<UpsertBrugereForInstitutionError>>;
  institution?: Maybe<Replikainstitution>;
};

export type UpsertDatakontrolModulError = SupportToolMutationError;

export type UpsertDatakontrolModulInput = {
  mutationModel: UpsertDatakontrolModulMutationModelInput;
};

export type UpsertDatakontrolModulMutationModelInput = {
  cprOpslagServiceAftaleUUID: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
};

export type UpsertDatakontrolModulPayload = {
  __typename?: 'UpsertDatakontrolModulPayload';
  datakontrolModulViewModel?: Maybe<DatakontrolModulViewModel>;
  errors?: Maybe<Array<UpsertDatakontrolModulError>>;
};

export type UpsertGruppeMutationError = DatakontrolMutationError;

export type UpsertGruppeMutationInput = {
  mutationModel: UpsertGruppeMutationModelInput;
};

export type UpsertGruppeMutationModelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  institutionExternalIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  navn?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGruppeMutationPayload = {
  __typename?: 'UpsertGruppeMutationPayload';
  errors?: Maybe<Array<UpsertGruppeMutationError>>;
  gruppe?: Maybe<Gruppe>;
};

export type UpsertInstitutionerForBrugerError = InstitutionsreplikaMutationError;

export type UpsertInstitutionerForBrugerInput = {
  /** Brugerens ExternalId */
  brugerExternalId: Scalars['UUID']['input'];
  /** Institutionernes externalId */
  institutionsIds: Array<Scalars['UUID']['input']>;
};

export type UpsertInstitutionerForBrugerPayload = {
  __typename?: 'UpsertInstitutionerForBrugerPayload';
  bruger?: Maybe<Replikabruger>;
  errors?: Maybe<Array<UpsertInstitutionerForBrugerError>>;
};

export type UpsertKommuneValideringsreglerMutationError = DatakontrolMutationError;

export type UpsertKommuneValideringsreglerMutationInput = {
  mutationModel: UpsertKommuneValideringsreglerMutationModelInput;
};

export type UpsertKommuneValideringsreglerMutationModelInput = {
  valideringsregelIdsWithValues: Array<KeyValuePairOfGuidAndStringInput>;
};

export type UpsertKommuneValideringsreglerMutationPayload = {
  __typename?: 'UpsertKommuneValideringsreglerMutationPayload';
  errors?: Maybe<Array<UpsertKommuneValideringsreglerMutationError>>;
  kommuneValideringsregelIndstilling?: Maybe<Array<KommuneValideringsregelIndstilling>>;
};

export type UpsertKontrolloerInstitutionMutationModelInput = {
  institutionId: Scalars['UUID']['input'];
  kontrolloerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpsertMedarbejderApiModulError = SupportToolMutationError;

export type UpsertMedarbejderApiModulInput = {
  mutationModel: UpsertMedarbejderApiModulMutationModelInput;
};

export type UpsertMedarbejderApiModulMutationModelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
  oprindelse?: InputMaybe<MedarbejderApiOprindelse>;
};

export type UpsertMedarbejderApiModulPayload = {
  __typename?: 'UpsertMedarbejderApiModulPayload';
  errors?: Maybe<Array<UpsertMedarbejderApiModulError>>;
  medarbejderApiModulViewModel?: Maybe<MedarbejderApiModulViewModel>;
};

export type UpsertRollemappingsError = DatakontrolMutationError;

export type UpsertRollemappingsInput = {
  mutationModel: UpsertRollemappingsMutationModelInput;
};

export type UpsertRollemappingsMutationModelInput = {
  rollemappings: Array<KeyValuePairOfStringAndRolleEnum__Input>;
};

export type UpsertRollemappingsPayload = {
  __typename?: 'UpsertRollemappingsPayload';
  errors?: Maybe<Array<UpsertRollemappingsError>>;
  rollemapping?: Maybe<Array<Rollemapping>>;
};

export type UpsertSkabelonMutationError = DatakontrolMutationError;

export type UpsertSkabelonMutationInput = {
  mutationModel: UpsertSkabelonMutationModelInput;
};

export type UpsertSkabelonMutationModelInput = {
  deadline?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  institutionExternalIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  navn?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DatakontrolTypeEnum>;
  valideringsregelExternalIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpsertSkabelonMutationPayload = {
  __typename?: 'UpsertSkabelonMutationPayload';
  errors?: Maybe<Array<UpsertSkabelonMutationError>>;
  skabelon?: Maybe<Skabelon>;
};

export type UpsertSocialTilbudModulError = SupportToolMutationError;

export type UpsertSocialTilbudModulInput = {
  mutationModel: UpsertSocialtilbudModulMutationModelInput;
};

export type UpsertSocialTilbudModulPayload = {
  __typename?: 'UpsertSocialTilbudModulPayload';
  errors?: Maybe<Array<UpsertSocialTilbudModulError>>;
  socialtilbudModulViewModel?: Maybe<SocialtilbudModulViewModel>;
};

export type UpsertSocialtilbudModulMutationModelInput = {
  beskedfordelerQueueId?: InputMaybe<Scalars['UUID']['input']>;
  beskedfordelerServiceAftaleUUID: Scalars['UUID']['input'];
  cprOpslagServiceAftaleUUID: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
};

export type UpsertUdeladelserKontaktpersonerModulError = SupportToolMutationError;

export type UpsertUdeladelserKontaktpersonerModulInput = {
  mutationModel: UpsertUdeladelserKontaktpersonerModulMutationModelInput;
};

export type UpsertUdeladelserKontaktpersonerModulMutationModelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
};

export type UpsertUdeladelserKontaktpersonerModulPayload = {
  __typename?: 'UpsertUdeladelserKontaktpersonerModulPayload';
  errors?: Maybe<Array<UpsertUdeladelserKontaktpersonerModulError>>;
  udeladelserKontakpersonerModulViewModel?: Maybe<UdeladelserKontakpersonerModulViewModel>;
};

export enum UserType {
  Forvalter = 'FORVALTER',
  Ist = 'IST',
  System = 'SYSTEM',
  TilbudsmedarbejderAdmin = 'TILBUDSMEDARBEJDER_ADMIN',
  Ukendt = 'UKENDT'
}

export type UserTypeOperationFilterInput = {
  eq?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  neq?: InputMaybe<UserType>;
  nin?: InputMaybe<Array<UserType>>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type Valideringskilde = {
  __typename?: 'Valideringskilde';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  navn: Scalars['String']['output'];
};

export type ValideringskildeFilterInput = {
  and?: InputMaybe<Array<ValideringskildeFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ValideringskildeFilterInput>>;
};

export type ValideringskildeSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type Valideringsregel = {
  __typename?: 'Valideringsregel';
  beskrivelse: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  kommuneValideringsregelIndstillinger: Array<KommuneValideringsregelIndstilling>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  loesning: Scalars['String']['output'];
  navn: Scalars['String']['output'];
  regelType: ValideringsregelPersonType;
  undersoeg: Scalars['String']['output'];
  valideringskilde: Valideringskilde;
};

export type ValideringsregelFilterInput = {
  and?: InputMaybe<Array<ValideringsregelFilterInput>>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  kommuneValideringsregelIndstillinger?: InputMaybe<ListFilterInputTypeOfKommuneValideringsregelIndstillingFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  loesning?: InputMaybe<StringOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ValideringsregelFilterInput>>;
  regelType?: InputMaybe<ValideringsregelPersonTypeOperationFilterInput>;
  undersoeg?: InputMaybe<StringOperationFilterInput>;
  valideringskilde?: InputMaybe<ValideringskildeFilterInput>;
};

export enum ValideringsregelIndstillingValueEnum {
  Groen = 'GROEN',
  Gul = 'GUL',
  Roed = 'ROED'
}

export type ValideringsregelIndstillingValueEnumOperationFilterInput = {
  eq?: InputMaybe<ValideringsregelIndstillingValueEnum>;
  in?: InputMaybe<Array<ValideringsregelIndstillingValueEnum>>;
  neq?: InputMaybe<ValideringsregelIndstillingValueEnum>;
  nin?: InputMaybe<Array<ValideringsregelIndstillingValueEnum>>;
};

export enum ValideringsregelPersonType {
  Barn = 'BARN',
  Medarbejder = 'MEDARBEJDER',
  Personer = 'PERSONER'
}

export type ValideringsregelPersonTypeOperationFilterInput = {
  eq?: InputMaybe<ValideringsregelPersonType>;
  in?: InputMaybe<Array<ValideringsregelPersonType>>;
  neq?: InputMaybe<ValideringsregelPersonType>;
  nin?: InputMaybe<Array<ValideringsregelPersonType>>;
};

export type ValideringsregelSortInput = {
  beskrivelse?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  loesning?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  regelType?: InputMaybe<SortEnumType>;
  undersoeg?: InputMaybe<SortEnumType>;
  valideringskilde?: InputMaybe<ValideringskildeSortInput>;
};

/** A connection to a list of items. */
export type ValideringsreglerConnection = {
  __typename?: 'ValideringsreglerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ValideringsreglerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Valideringsregel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ValideringsreglerEdge = {
  __typename?: 'ValideringsreglerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Valideringsregel;
};

export type Variable = {
  __typename?: 'Variable';
  brugerAktivitetId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VariableFilterInput = {
  and?: InputMaybe<Array<VariableFilterInput>>;
  brugerAktivitetId?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VariableFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type VariableSortInput = {
  brugerAktivitetId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VariablesConnection = {
  __typename?: 'VariablesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VariablesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Variable>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VariablesEdge = {
  __typename?: 'VariablesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Variable;
};

export type Ws10ContactPerson = {
  __typename?: 'WS10ContactPerson';
  accessLevel: Scalars['Int']['output'];
  childCustody: Scalars['Boolean']['output'];
  person: Ws10Person;
  relation: Serviceplatformen_Ws10_Relation;
};

export type Ws10Employee = {
  __typename?: 'WS10Employee';
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  groups: Array<Ws10Group>;
  location?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  roles: Array<EmployeeRole>;
  shortName?: Maybe<Scalars['String']['output']>;
};


export type Ws10EmployeeGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};

export type Ws10Extern = {
  __typename?: 'WS10Extern';
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  groups: Array<Ws10Group>;
  role: ExternRole;
};


export type Ws10ExternGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};

export type Ws10Group = {
  __typename?: 'WS10Group';
  fromDate?: Maybe<Scalars['Date']['output']>;
  groupId: Scalars['String']['output'];
  groupLevel: Level;
  groupName?: Maybe<Scalars['String']['output']>;
  groupType: GroupType;
  line?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type Ws10Institution = {
  __typename?: 'WS10Institution';
  groups: Array<Ws10Group>;
  importDate: Scalars['DateTime']['output'];
  institutionName?: Maybe<Scalars['String']['output']>;
  institutionNumber: Scalars['String']['output'];
  institutionPersons: Array<Ws10InstitutionPerson>;
};


export type Ws10InstitutionGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};


export type Ws10InstitutionInstitutionPersonsArgs = {
  order?: InputMaybe<Array<InstitutionPersonSortInput>>;
  where?: InputMaybe<InstitutionPersonFilterInput>;
};

export type Ws10InstitutionPerson = {
  __typename?: 'WS10InstitutionPerson';
  employee?: Maybe<Ws10Employee>;
  extern?: Maybe<Ws10Extern>;
  localPersonId: Scalars['String']['output'];
  person: Ws10Person;
  personType: PersonType;
  student?: Maybe<Ws10Student>;
};

export type Ws10Person = {
  __typename?: 'WS10Person';
  address?: Maybe<Address>;
  aliasFamilyName?: Maybe<Scalars['String']['output']>;
  aliasFirstName?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  civilRegistrationNumber: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Gender;
  homePhoneNumber?: Maybe<PhoneNumber>;
  mobilePhoneNumber?: Maybe<PhoneNumber>;
  photoId?: Maybe<Scalars['String']['output']>;
  protected: Scalars['Boolean']['output'];
  verificationLevel: Scalars['Int']['output'];
  workPhoneNumber?: Maybe<PhoneNumber>;
};

export type Ws10Student = {
  __typename?: 'WS10Student';
  contactPersons: Array<Ws10ContactPerson>;
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  groups: Array<Ws10Group>;
  level: Level;
  location?: Maybe<Scalars['String']['output']>;
  mainGroup: Ws10Group;
  mainGroupId: Scalars['String']['output'];
  role: StudentRole;
  studentNumber?: Maybe<Scalars['String']['output']>;
};


export type Ws10StudentContactPersonsArgs = {
  order?: InputMaybe<Array<ContactPersonSortInput>>;
  where?: InputMaybe<ContactPersonFilterInput>;
};


export type Ws10StudentGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};

export type Ws17ContactPerson = {
  __typename?: 'WS17ContactPerson';
  /**
   * 0 (default) angiver at kontaktpersonen må få adgang til almindelige personoplysninger om den tilknyttede elev.
   * 1 angiver at kontaktpersonen må få adgang til fortrolige og følsomme personoplysninger om eleven. NB. Hvis kontaktpersonen ikke er forældremyndighedsindehaver, skal hjemmel opnås på anden vis.
   */
  accessLevel?: Maybe<Scalars['Int']['output']>;
  /** Har personen forældremyndighed? */
  childCustody: Scalars['Boolean']['output'];
  /** Personoplysninger på kontaktpersonen */
  person: Ws17Person;
  /**
   * Kontaktpersonens relation til eleven.
   * En af værdierne: Mor, Far, Andet, Officielt tilknyttet person.
   */
  relation: Serviceplatformen_Ws10_Relation;
  /** Eventuelle Unilogin-oplysninger */
  uniLogin?: Maybe<Ws17UniLogin>;
};

export type Ws17Employee = {
  __typename?: 'WS17Employee';
  /** De grupper medarbejderen er tilknyttet. Feltet indeholder gruppernes unikke id på institutionen. */
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** De grupper medarbejderen er tilknyttet. */
  groups: Array<Ws17Group>;
  /** Afdeling, bygning eller værelsesnummer på efterskoler. */
  location?: Maybe<Scalars['String']['output']>;
  /** Stilling */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Den ansattes roller: "Laerer", "Paedagog", "Vikar", "Leder", "Ledelse", "TAP", "Konsulent". */
  roles: Array<EmployeeRole>;
  /** Initialer */
  shortName?: Maybe<Scalars['String']['output']>;
};


export type Ws17EmployeeGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};

export type Ws17Extern = {
  __typename?: 'WS17Extern';
  /** De grupper den eksterne medarbejder er tilknyttet. Feltet indeholder gruppernes unikke id på institutionen. */
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** De grupper den eksterne medarbejder er tilknyttet. */
  groups: Array<Ws17Group>;
  /** Den ikke-ansattes rolle: "Ekstern" eller "Praktikant" */
  role: ExternRole;
};


export type Ws17ExternGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};

export type Ws17Group = {
  __typename?: 'WS17Group';
  /** Gruppens startdato på formen YYYY-MM-DD */
  fromDate: Scalars['Date']['output'];
  /** Gruppeid som er unikt og uforanderligt i hele sin levetid på institutionen. For eksempel 2016a */
  groupId: Scalars['String']['output'];
  /** Hovedgruppens/stamklassens trin. Oplyses kun for grupper af typen ”Hovedgruppe”. En af følgende værdier: DT, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, U1, U2, U3, U4, VU, Andet. DT er dagtilbud, 1 svarer til 1. klassetrin i grundskolen, U1 er første trin på en ungdomsuddannelse. VU er voksenuddannelse. */
  groupLevel: Level;
  /** Gruppenavn, som vises til brugere. */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Gruppetypen. ”Hovedgruppe”, ”Årgang”, ”Retning”, ”Hold”, ”SFO”, ”Team” eller ”Andet”. */
  groupType: GroupType;
  /**
   * Spor, linje, studieretning eller lign. for hovedgruppen/stamklassen. Oplyses kun for grupper af typen ”Hovedgruppe”.
   * For grundskoler fx ”B”
   */
  line?: Maybe<Scalars['String']['output']>;
  /** Gruppens slutdato på formen YYYY-MM-DD */
  toDate: Scalars['Date']['output'];
};

export type Ws17Institution = {
  __typename?: 'WS17Institution';
  /** Tidspunkt for eksporten fra STIL. */
  exportDate: Scalars['DateTime']['output'];
  /** Grupper på institutionen */
  groups: Array<Ws17Group>;
  /** Institutionsnavn */
  institutionName: Scalars['String']['output'];
  /** Seks-tegns registreringsnummer, som identificerer en institution (kan indeholde både bogstaver og tal) */
  institutionNumber: Scalars['String']['output'];
  /** Ansatte og elever på institutionen. */
  institutionPersons: Array<Ws17InstitutionPerson>;
  /** Det niveau som institutionen er hentet på, kan være Lille, Mellem, Fuld eller FyldMyndighed */
  pakke: Pakke;
  /** Skoleår på formatet YYYY-YYYY */
  schoolYear: Scalars['String']['output'];
};


export type Ws17InstitutionGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};


export type Ws17InstitutionInstitutionPersonsArgs = {
  order?: InputMaybe<Array<Serviceplatformen_Ws17_InstitutionPersonSortInput>>;
  where?: InputMaybe<Serviceplatformen_Ws17_InstitutionPersonFilterInput>;
};

export type Ws17InstitutionPerson = {
  __typename?: 'WS17InstitutionPerson';
  /** Læreroplysninger om personen */
  employee?: Maybe<Ws17Employee>;
  /** Ikke-ansat person */
  extern?: Maybe<Ws17Extern>;
  /** Den lokale identifikation af personen i institutionens kildesystem. Findes ikke i gamle importer. */
  localPersonId?: Maybe<Scalars['String']['output']>;
  /** Personoplysninger */
  person?: Maybe<Ws17Person>;
  /** Typen af Person, baseret på om Student, Employee eller Extern er null */
  personType: PersonType;
  /** Elevoplysninger om personen */
  student?: Maybe<Ws17Student>;
  /** Unilogin-oplysninger. */
  uniLogin: Ws17UniLogin;
};

export type Ws17Person = {
  __typename?: 'WS17Person';
  /** Adresse */
  address?: Maybe<Address>;
  /** Efternavn importeret i SkoleGrunddata ved navn og adresse-beskyttelse. */
  aliasFamilyName?: Maybe<Scalars['String']['output']>;
  /** Fornavne importeret i SkoleGrunddata ved navn og adresse-beskyttelse. */
  aliasFirstName?: Maybe<Scalars['String']['output']>;
  /** Fødselsdato på formen YYYY-MM-DD */
  birthDate?: Maybe<Scalars['Date']['output']>;
  /** Personnummer på formen DDMMYYXXXX. */
  civilRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** E-mail */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Efternavn. Et alias-navn ved navne- og adressebeskyttelse undtagen i myndighedspakken. */
  familyName: Scalars['String']['output'];
  /** Fornavne. Et alias-navn ved navne- og adressebeskyttelse undtagen i myndighedspakken. */
  firstName: Scalars['String']['output'];
  /**
   * Personens køn.
   * En af værdierne ”M”, ”K”, "Ukendt"
   */
  gender: Gender;
  /** Hjemmetelefon */
  homePhoneNumber?: Maybe<PhoneNumber>;
  /** Mobiltelefon */
  mobilePhoneNumber?: Maybe<PhoneNumber>;
  /** Reference til foto i kildesystemet. */
  photoId?: Maybe<Scalars['String']['output']>;
  /** Har personen navne- og adressebeskyttelse? */
  protected?: Maybe<Scalars['Boolean']['output']>;
  /** Arbejdstelefon */
  workPhoneNumber?: Maybe<PhoneNumber>;
};

export type Ws17Student = {
  __typename?: 'WS17Student';
  /** Kontaktperson */
  contactPersons: Array<Ws17ContactPerson>;
  /** Yderligere gruppe id'er eleven er tilknyttet, ud over tilknytningen via MainGroupId. */
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Yderligere grupper eleven er tilknyttet, ud over tilknytningen via MainGroupId. */
  groups: Array<Ws17Group>;
  /** Elevens trin. En af følgende værdier: DT, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, U1, U2, U3, U4, VU, Andet. DT er dagtilbud, 1 svarer til 1. klassetrin i grundskolen, U1 er første trin på en ungdomsuddannelse. VU er voksenuddannelse. */
  level: Level;
  /** Afdeling, bygning eller værelsesnummer på efterskoler. */
  location?: Maybe<Scalars['String']['output']>;
  /** Elevens hovedgruppe. For grundskoler elevens klasse og kan for andre institutioner for eksempel studieretning eller stamhold. (groupType for mainGroup er ”Hovedgruppe”) */
  mainGroup: Ws17Group;
  /** Id for elevens hovedgruppe. For grundskoler elevens klasse og kan for andre institutioner for eksempel studieretning eller stamhold. (groupType for mainGroup er ”Hovedgruppe”) */
  mainGroupId: Scalars['String']['output'];
  /** Elevens Rolle: "Barn" for barn i dagtilbud. "Elev" for alle der går i skole eller "Studerende". */
  role: StudentRole;
  /** Elevens studienummer fra lokalt administrativt system. */
  studentNumber?: Maybe<Scalars['String']['output']>;
};


export type Ws17StudentContactPersonsArgs = {
  order?: InputMaybe<Array<Serviceplatformen_Ws17_ContactPersonSortInput>>;
  where?: InputMaybe<Serviceplatformen_Ws17_ContactPersonFilterInput>;
};


export type Ws17StudentGroupsArgs = {
  order?: InputMaybe<Array<GroupSortInput>>;
  where?: InputMaybe<GroupFilterInput>;
};

export type Ws17UniLogin = {
  __typename?: 'WS17UNILogin';
  /** Unikt brugerid (UniID) */
  userId: Scalars['String']['output'];
};

export type Institutionsreplika_BrugerFilterInput = {
  and?: InputMaybe<Array<Institutionsreplika_BrugerFilterInput>>;
  brugerExternalId?: InputMaybe<UuidOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Institutionsreplika_BrugerFilterInput>>;
  tilknyttedeInstitutioner?: InputMaybe<ListFilterInputTypeOfInstitutionFilterInput>;
};

export type Institutionsreplika_BrugerSortInput = {
  brugerExternalId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
};

export type Institutionsreplika_InstitutionFilterInput = {
  and?: InputMaybe<Array<Institutionsreplika_InstitutionFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  institutionType?: InputMaybe<InstitutionstypeOperationFilterInput>;
  institutionskode?: InputMaybe<StringOperationFilterInput>;
  kommunekode?: InputMaybe<StringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Institutionsreplika_InstitutionFilterInput>>;
  tilknyttedeBrugere?: InputMaybe<ListFilterInputTypeOfBrugerFilterInput>;
};

export type Institutionsreplika_InstitutionSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institutionType?: InputMaybe<SortEnumType>;
  institutionskode?: InputMaybe<SortEnumType>;
  kommunekode?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export enum Serviceplatformen_Ws10_Relation {
  Andet = 'ANDET',
  Far = 'FAR',
  Mor = 'MOR',
  Officielttilknyttetperson = 'OFFICIELTTILKNYTTETPERSON',
  Ukendt = 'UKENDT'
}

export type Serviceplatformen_Ws17_ContactPersonFilterInput = {
  /**
   * 0 (default) angiver at kontaktpersonen må få adgang til almindelige personoplysninger om den tilknyttede elev.
   * 1 angiver at kontaktpersonen må få adgang til fortrolige og følsomme personoplysninger om eleven. NB. Hvis kontaktpersonen ikke er forældremyndighedsindehaver, skal hjemmel opnås på anden vis.
   */
  accessLevel?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Serviceplatformen_Ws17_ContactPersonFilterInput>>;
  /** Har personen forældremyndighed? */
  childCustody?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Serviceplatformen_Ws17_ContactPersonFilterInput>>;
  /** Personoplysninger på kontaktpersonen */
  person?: InputMaybe<Serviceplatformen_Ws17_PersonFilterInput>;
  /**
   * Kontaktpersonens relation til eleven.
   * En af værdierne: Mor, Far, Andet, Officielt tilknyttet person.
   */
  relation?: InputMaybe<RelationOperationFilterInput>;
  /** Eventuelle Unilogin-oplysninger */
  uniLogin?: InputMaybe<UniLoginFilterInput>;
};

export type Serviceplatformen_Ws17_ContactPersonSortInput = {
  /**
   * 0 (default) angiver at kontaktpersonen må få adgang til almindelige personoplysninger om den tilknyttede elev.
   * 1 angiver at kontaktpersonen må få adgang til fortrolige og følsomme personoplysninger om eleven. NB. Hvis kontaktpersonen ikke er forældremyndighedsindehaver, skal hjemmel opnås på anden vis.
   */
  accessLevel?: InputMaybe<SortEnumType>;
  /** Har personen forældremyndighed? */
  childCustody?: InputMaybe<SortEnumType>;
  /** Personoplysninger på kontaktpersonen */
  person?: InputMaybe<Serviceplatformen_Ws17_PersonSortInput>;
  /**
   * Kontaktpersonens relation til eleven.
   * En af værdierne: Mor, Far, Andet, Officielt tilknyttet person.
   */
  relation?: InputMaybe<SortEnumType>;
  /** Eventuelle Unilogin-oplysninger */
  uniLogin?: InputMaybe<UniLoginSortInput>;
};

export type Serviceplatformen_Ws17_InstitutionPersonFilterInput = {
  and?: InputMaybe<Array<Serviceplatformen_Ws17_InstitutionPersonFilterInput>>;
  /** Læreroplysninger om personen */
  employee?: InputMaybe<EmployeeFilterInput>;
  /** Ikke-ansat person */
  extern?: InputMaybe<ExternFilterInput>;
  /** Den lokale identifikation af personen i institutionens kildesystem. Findes ikke i gamle importer. */
  localPersonId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Serviceplatformen_Ws17_InstitutionPersonFilterInput>>;
  /** Personoplysninger */
  person?: InputMaybe<Serviceplatformen_Ws17_PersonFilterInput>;
  /** Typen af Person, baseret på om Student, Employee eller Extern er null */
  personType?: InputMaybe<PersonTypeOperationFilterInput>;
  /** Elevoplysninger om personen */
  student?: InputMaybe<Serviceplatformen_Ws17_StudentFilterInput>;
  /** Unilogin-oplysninger. */
  uniLogin?: InputMaybe<UniLoginFilterInput>;
};

export type Serviceplatformen_Ws17_InstitutionPersonSortInput = {
  /** Læreroplysninger om personen */
  employee?: InputMaybe<EmployeeSortInput>;
  /** Ikke-ansat person */
  extern?: InputMaybe<ExternSortInput>;
  /** Den lokale identifikation af personen i institutionens kildesystem. Findes ikke i gamle importer. */
  localPersonId?: InputMaybe<SortEnumType>;
  /** Personoplysninger */
  person?: InputMaybe<Serviceplatformen_Ws17_PersonSortInput>;
  /** Typen af Person, baseret på om Student, Employee eller Extern er null */
  personType?: InputMaybe<SortEnumType>;
  /** Elevoplysninger om personen */
  student?: InputMaybe<StudentSortInput>;
  /** Unilogin-oplysninger. */
  uniLogin?: InputMaybe<UniLoginSortInput>;
};

export type Serviceplatformen_Ws17_ListFilterInputTypeOfContactPersonFilterInput = {
  all?: InputMaybe<Serviceplatformen_Ws17_ContactPersonFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Serviceplatformen_Ws17_ContactPersonFilterInput>;
  some?: InputMaybe<Serviceplatformen_Ws17_ContactPersonFilterInput>;
};

export type Serviceplatformen_Ws17_PersonFilterInput = {
  /** Adresse */
  address?: InputMaybe<AddressFilterInput>;
  /** Efternavn importeret i SkoleGrunddata ved navn og adresse-beskyttelse. */
  aliasFamilyName?: InputMaybe<StringOperationFilterInput>;
  /** Fornavne importeret i SkoleGrunddata ved navn og adresse-beskyttelse. */
  aliasFirstName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Serviceplatformen_Ws17_PersonFilterInput>>;
  /** Fødselsdato på formen YYYY-MM-DD */
  birthDate?: InputMaybe<DateOperationFilterInput>;
  /** Personnummer på formen DDMMYYXXXX. */
  civilRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  /** E-mail */
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  /** Efternavn. Et alias-navn ved navne- og adressebeskyttelse undtagen i myndighedspakken. */
  familyName?: InputMaybe<StringOperationFilterInput>;
  /** Fornavne. Et alias-navn ved navne- og adressebeskyttelse undtagen i myndighedspakken. */
  firstName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Personens køn.
   * En af værdierne ”M”, ”K”, "Ukendt"
   */
  gender?: InputMaybe<GenderOperationFilterInput>;
  /** Hjemmetelefon */
  homePhoneNumber?: InputMaybe<PhoneNumberFilterInput>;
  /** Mobiltelefon */
  mobilePhoneNumber?: InputMaybe<PhoneNumberFilterInput>;
  or?: InputMaybe<Array<Serviceplatformen_Ws17_PersonFilterInput>>;
  /** Reference til foto i kildesystemet. */
  photoId?: InputMaybe<StringOperationFilterInput>;
  /** Har personen navne- og adressebeskyttelse? */
  protected?: InputMaybe<BooleanOperationFilterInput>;
  /** Arbejdstelefon */
  workPhoneNumber?: InputMaybe<PhoneNumberFilterInput>;
};

export type Serviceplatformen_Ws17_PersonSortInput = {
  /** Adresse */
  address?: InputMaybe<AddressSortInput>;
  /** Efternavn importeret i SkoleGrunddata ved navn og adresse-beskyttelse. */
  aliasFamilyName?: InputMaybe<SortEnumType>;
  /** Fornavne importeret i SkoleGrunddata ved navn og adresse-beskyttelse. */
  aliasFirstName?: InputMaybe<SortEnumType>;
  /** Fødselsdato på formen YYYY-MM-DD */
  birthDate?: InputMaybe<SortEnumType>;
  /** Personnummer på formen DDMMYYXXXX. */
  civilRegistrationNumber?: InputMaybe<SortEnumType>;
  /** E-mail */
  emailAddress?: InputMaybe<SortEnumType>;
  /** Efternavn. Et alias-navn ved navne- og adressebeskyttelse undtagen i myndighedspakken. */
  familyName?: InputMaybe<SortEnumType>;
  /** Fornavne. Et alias-navn ved navne- og adressebeskyttelse undtagen i myndighedspakken. */
  firstName?: InputMaybe<SortEnumType>;
  /**
   * Personens køn.
   * En af værdierne ”M”, ”K”, "Ukendt"
   */
  gender?: InputMaybe<SortEnumType>;
  /** Hjemmetelefon */
  homePhoneNumber?: InputMaybe<PhoneNumberSortInput>;
  /** Mobiltelefon */
  mobilePhoneNumber?: InputMaybe<PhoneNumberSortInput>;
  /** Reference til foto i kildesystemet. */
  photoId?: InputMaybe<SortEnumType>;
  /** Har personen navne- og adressebeskyttelse? */
  protected?: InputMaybe<SortEnumType>;
  /** Arbejdstelefon */
  workPhoneNumber?: InputMaybe<PhoneNumberSortInput>;
};

export type Serviceplatformen_Ws17_StudentFilterInput = {
  and?: InputMaybe<Array<Serviceplatformen_Ws17_StudentFilterInput>>;
  /** Kontaktperson */
  contactPersons?: InputMaybe<Serviceplatformen_Ws17_ListFilterInputTypeOfContactPersonFilterInput>;
  /** Yderligere gruppe id'er eleven er tilknyttet, ud over tilknytningen via MainGroupId. */
  groupIds?: InputMaybe<ListStringOperationFilterInput>;
  /** Yderligere grupper eleven er tilknyttet, ud over tilknytningen via MainGroupId. */
  groups?: InputMaybe<ListFilterInputTypeOfGroupFilterInput>;
  /** Elevens trin. En af følgende værdier: DT, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, U1, U2, U3, U4, VU, Andet. DT er dagtilbud, 1 svarer til 1. klassetrin i grundskolen, U1 er første trin på en ungdomsuddannelse. VU er voksenuddannelse. */
  level?: InputMaybe<LevelOperationFilterInput>;
  /** Afdeling, bygning eller værelsesnummer på efterskoler. */
  location?: InputMaybe<StringOperationFilterInput>;
  /** Elevens hovedgruppe. For grundskoler elevens klasse og kan for andre institutioner for eksempel studieretning eller stamhold. (groupType for mainGroup er ”Hovedgruppe”) */
  mainGroup?: InputMaybe<GroupFilterInput>;
  /** Id for elevens hovedgruppe. For grundskoler elevens klasse og kan for andre institutioner for eksempel studieretning eller stamhold. (groupType for mainGroup er ”Hovedgruppe”) */
  mainGroupId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Serviceplatformen_Ws17_StudentFilterInput>>;
  /** Elevens Rolle: "Barn" for barn i dagtilbud. "Elev" for alle der går i skole eller "Studerende". */
  role?: InputMaybe<StudentRoleOperationFilterInput>;
  /** Elevens studienummer fra lokalt administrativt system. */
  studentNumber?: InputMaybe<StringOperationFilterInput>;
};

export type FjernBarnMutationVariables = Exact<{
  barnId: Scalars['UUID']['input'];
}>;


export type FjernBarnMutation = { __typename?: 'Mutation', fjernBarn: any };

export type RemoveBarnFromTilbudMutationVariables = Exact<{
  tilknytningId: Scalars['UUID']['input'];
}>;


export type RemoveBarnFromTilbudMutation = { __typename?: 'Mutation', fjernTilbudsTilknytning: any };

export type FjernMedarbejderFraBarnMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type FjernMedarbejderFraBarnMutation = { __typename?: 'Mutation', fjernMedarbejderFraBarn: Array<any> };

export type GodkendTildelingMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GodkendTildelingMutation = { __typename?: 'Mutation', godkendTilbudsTilknytning: { __typename?: 'TilbudsTilknytning', id: any, barn: { __typename?: 'Barn', antalAktiveMedarbejdere: any, antalAktiveTilbud: any, id: any, naesteMedarbejderBarnValideringInden?: Date | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', id: any, tilbudsnavn: string } } }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } } };

export type OpretBarnMutationVariables = Exact<{
  cpr: Scalars['String']['input'];
  tilbudId: Scalars['UUID']['input'];
  gyldigFra: Scalars['Date']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type OpretBarnMutation = { __typename?: 'Mutation', tilknytNytBarnTilTilbud: { __typename?: 'Barn', antalAktiveMedarbejdere: any, antalAktiveTilbud: any, id: any, naesteMedarbejderBarnValideringInden?: Date | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', id: any, tilbudsnavn: string } } }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } };

export type TilknytBarnTilMedarbejderMutationVariables = Exact<{
  barnId: Scalars['UUID']['input'];
  medarbejderId: Scalars['UUID']['input'];
}>;


export type TilknytBarnTilMedarbejderMutation = { __typename?: 'Mutation', tilknytMedarbejderTilBarn: { __typename?: 'TilbudsmedarbejderBarn', id: any, barn: { __typename?: 'Barn', person: { __typename?: 'Person', fornavn: string, efternavn: string } }, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', person: { __typename?: 'Person', fornavn: string, efternavn: string } } } };

export type TilknytTilbudTilBarnMutationVariables = Exact<{
  barnId: Scalars['UUID']['input'];
  tilbudId: Scalars['UUID']['input'];
  gyldigFra: Scalars['Date']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TilknytTilbudTilBarnMutation = { __typename?: 'Mutation', tilknytBarnTilTilbud: { __typename?: 'TilbudsTilknytning', id: any, barn: { __typename?: 'Barn', id: any, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any }>, person: { __typename?: 'Person', id: any, fornavn: string, efternavn: string } }, tilbud: { __typename?: 'Tilbud', id: any, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any }> } } };

export type UpdateMedarbejderBarnMutationVariables = Exact<{
  input: TilbudsmedarbejderBarnMutationModelInput;
}>;


export type UpdateMedarbejderBarnMutation = { __typename?: 'Mutation', opdaterTilbudsmedarbejderBarn: { __typename?: 'TilbudsmedarbejderBarn', id: any, accessLevel: AccessLevel, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any, person: { __typename?: 'Person', fornavn: string, efternavn: string } }, barn: { __typename?: 'Barn', id: any, person: { __typename?: 'Person', fornavn: string, efternavn: string } } } };

export type UpdateTilknytningMutationVariables = Exact<{
  tilknytningInput: TilbudsTilknytningMutationModelInput;
}>;


export type UpdateTilknytningMutation = { __typename?: 'Mutation', opdaterTilknytning: { __typename?: 'TilbudsTilknytning', id: any, barn: { __typename?: 'Barn', person: { __typename?: 'Person', fornavn: string, efternavn: string } } } };

export type ValiderTilbudsmedarbejderBarnMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ValiderTilbudsmedarbejderBarnMutation = { __typename?: 'Mutation', validerTilbudsmedarbejderBarn: { __typename?: 'TilbudsTilknytning', id: any } };

export type UpsertKontrolSkabelonMutationVariables = Exact<{
  input: UpsertSkabelonMutationModelInput;
}>;


export type UpsertKontrolSkabelonMutation = { __typename?: 'Mutation', upsertSkabelonMutation: { __typename?: 'UpsertSkabelonMutationPayload', skabelon?: { __typename?: 'Skabelon', navn: string, id: any, intervalDays: number, deadlineDays: number, type: DatakontrolTypeEnum, skabelonInstitutioner: Array<{ __typename?: 'SkabelonInstitution', id: any, institution: { __typename?: 'Institution', id: any, navn: string } }>, skabelonValideringsregler: Array<{ __typename?: 'SkabelonValideringsregel', id: any, valideringsregel: { __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string } }> } | null } };

export type OpretKontrolFraSkabelonMutationVariables = Exact<{
  inkluderValide?: InputMaybe<Scalars['Boolean']['input']>;
  skabelonId: Scalars['UUID']['input'];
}>;


export type OpretKontrolFraSkabelonMutation = { __typename?: 'Mutation', opretKontrolSkabelonMutation: { __typename?: 'OpretKontrolSkabelonMutationPayload', kontrol?: { __typename?: 'Kontrol', id: any } | null, errors?: Array<{ __typename: 'DatakontrolMutationError', contextData: string, message: string }> | null } };

export type OpdaterKontrolStatusMutationVariables = Exact<{
  input: KontrolStatusMutationModelInput;
}>;


export type OpdaterKontrolStatusMutation = { __typename?: 'Mutation', opdaterKontrolStatusMutation: { __typename?: 'OpdaterKontrolStatusMutationPayload', kontrol?: { __typename?: 'Kontrol', id: any } | null } };

export type OpdaterKontrolResultatMutationVariables = Exact<{
  input: KontrolResultatMutationModelInput;
}>;


export type OpdaterKontrolResultatMutation = { __typename?: 'Mutation', opdaterKontrolResultatMutation: { __typename?: 'OpdaterKontrolResultatMutationPayload', resultat?: { __typename?: 'Resultat', id: any, note?: string | null, vaerdi: ValideringsregelIndstillingValueEnum, handling: ResultatHandlingEnum } | null } };

export type SletKontrolMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SletKontrolMutation = { __typename?: 'Mutation', sletKontrolMutation: { __typename?: 'SletKontrolMutationPayload', uuid?: any | null, errors?: Array<{ __typename: 'DatakontrolMutationError', message: string, contextData: string }> | null } };

export type OpdaterKontrolloererMutationVariables = Exact<{
  input: UpsertKontrolloerInstitutionMutationModelInput;
}>;


export type OpdaterKontrolloererMutation = { __typename?: 'Mutation', synchronizeKontrolloerInstitutionMutation: { __typename?: 'SynchronizeKontrolloerInstitutionMutationPayload', boolean?: boolean | null } };

export type OpretKontrolTilpassetMutationVariables = Exact<{
  kontrolMutationModel: KontrolMutationModelInput;
}>;


export type OpretKontrolTilpassetMutation = { __typename?: 'Mutation', opretKontrolTilpassetMutation: { __typename?: 'OpretKontrolTilpassetMutationPayload', kontrol?: { __typename?: 'Kontrol', id: any } | null, errors?: Array<{ __typename: 'DatakontrolMutationError', contextData: string, message: string }> | null } };

export type UpsertKontrolGruppeMutationVariables = Exact<{
  kontrolGruppeInput: UpsertGruppeMutationModelInput;
}>;


export type UpsertKontrolGruppeMutation = { __typename?: 'Mutation', upsertGruppeMutation: { __typename?: 'UpsertGruppeMutationPayload', gruppe?: { __typename?: 'Gruppe', id: any, navn: string, gruppeInstitutioner: Array<{ __typename?: 'GruppeInstitution', id: any, institution: { __typename?: 'Institution', id: any, navn: string }, gruppe: { __typename?: 'Gruppe', id: any, navn: string, created: Date } }> } | null } };

export type SletKontrolGruppeMutationVariables = Exact<{
  gruppeId: Scalars['UUID']['input'];
}>;


export type SletKontrolGruppeMutation = { __typename?: 'Mutation', sletGruppeMutation: { __typename?: 'SletGruppeMutationPayload', uuid?: any | null, errors?: Array<{ __typename?: 'DatakontrolMutationError', message: string, contextData: string }> | null } };

export type SletKontrolSkabelonMutationVariables = Exact<{
  skabelonId: Scalars['UUID']['input'];
}>;


export type SletKontrolSkabelonMutation = { __typename?: 'Mutation', sletSkabelonMutation: { __typename?: 'SletSkabelonMutationPayload', uuid?: any | null, errors?: Array<{ __typename: 'DatakontrolMutationError', message: string, contextData: string }> | null } };

export type UpsertRolleMappingsMutationVariables = Exact<{
  rolleMappings: UpsertRollemappingsInput;
}>;


export type UpsertRolleMappingsMutation = { __typename?: 'Mutation', upsertRollemappings: { __typename?: 'UpsertRollemappingsPayload', errors?: Array<{ __typename: 'DatakontrolMutationError', message: string, contextData: string }> | null, rollemapping?: Array<{ __typename?: 'Rollemapping', stillingsbetegnelse: string, roller: Array<RolleEnum>, id: any }> | null } };

export type OpdaterKontrolInfoMutationVariables = Exact<{
  input: KontrolInfoMutationModelInput;
}>;


export type OpdaterKontrolInfoMutation = { __typename?: 'Mutation', opdaterKontrolInfoMutation: { __typename?: 'OpdaterKontrolInfoMutationPayload', kontrol?: { __typename?: 'Kontrol', id: any } | null, errors?: Array<{ __typename?: 'DatakontrolMutationError', message: string, contextData: string }> | null } };

export type GenkoerKontrolMutationVariables = Exact<{
  input: KontrolGenkoerMutationModelInput;
}>;


export type GenkoerKontrolMutation = { __typename?: 'Mutation', genkoerKontrolMutation: { __typename?: 'GenkoerKontrolMutationPayload', kontrol?: { __typename?: 'Kontrol', id: any } | null, errors?: Array<{ __typename?: 'DatakontrolMutationError', message: string, contextData: string }> | null } };

export type UpsertKommuneValideringsNoteMutationVariables = Exact<{
  key: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
}>;


export type UpsertKommuneValideringsNoteMutation = { __typename?: 'Mutation', upsertKommuneValideringsreglerMutation: { __typename?: 'UpsertKommuneValideringsreglerMutationPayload', kommuneValideringsregelIndstilling?: Array<{ __typename?: 'KommuneValideringsregelIndstilling', notat?: string | null, id: any }> | null } };

export type GetKontrolResultCsvMutationVariables = Exact<{
  kontrolId: Scalars['UUID']['input'];
}>;


export type GetKontrolResultCsvMutation = { __typename?: 'Mutation', genererValideResultaterRapportMutation: { __typename?: 'GenererValideResultaterRapportMutationPayload', string?: string | null, errors?: Array<{ __typename: 'DatakontrolMutationError', message: string, contextData: string }> | null } };

export type OpdaterLokalKonfigurationForOrganisationMutationVariables = Exact<{
  localConfig: LokalKonfigurationMutationModelInput;
}>;


export type OpdaterLokalKonfigurationForOrganisationMutation = { __typename?: 'Mutation', opdaterLokalKonfigurationForOrganisation: { __typename?: 'LokalKonfiguration', id: any, emailModtagere: Array<string>, kontrolInterval: number, organisationNavn: string, daysLeftBeforeFirstReminder: number, daysLeftBeforeSecondReminder: number, daysLeftBeforeThirdAndFinalReminder: number } };

export type FjernMedarbejderMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FjernMedarbejderMutation = { __typename?: 'Mutation', fjernMedarbejder: any };

export type TilknytNyMedarbejderTilBarnMutationVariables = Exact<{
  barnId: Scalars['UUID']['input'];
  cpr: Scalars['String']['input'];
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
  aliasFornavn?: InputMaybe<Scalars['String']['input']>;
  aliasEfternavn?: InputMaybe<Scalars['String']['input']>;
}>;


export type TilknytNyMedarbejderTilBarnMutation = { __typename?: 'Mutation', tilknytNyMedarbejderTilbarn: { __typename?: 'TilbudsmedarbejderBarn', id: any, barn: { __typename?: 'Barn', id: any, person: { __typename?: 'Person', fornavn: string, efternavn: string } }, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any, person: { __typename?: 'Person', fornavn: string, efternavn: string } } } };

export type OpdaterMedarbejderMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  aliasFornavn?: InputMaybe<Scalars['String']['input']>;
  aliasEfternavn?: InputMaybe<Scalars['String']['input']>;
  gyldigTil?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type OpdaterMedarbejderMutation = { __typename?: 'Mutation', opdaterMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any } };

export type OpretKundeMutationVariables = Exact<{
  opretKundeInput: CreateKundeMutationModelInput;
}>;


export type OpretKundeMutation = { __typename?: 'Mutation', createKunde: { __typename?: 'CreateKundePayload', kunde?: { __typename?: 'Kunde', navn: string, cvr: string, kommuneKode: string, id: any } | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type GensendCprHaendelserForKundeMutationVariables = Exact<{
  kundeId: Scalars['UUID']['input'];
  fraDato: Scalars['Date']['input'];
}>;


export type GensendCprHaendelserForKundeMutation = { __typename?: 'Mutation', gensendCprHaendelserForKunde: { __typename?: 'GensendCprHaendelserForKundePayload', string?: string | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type PopulateInstitutionerForKundeMutationVariables = Exact<{
  kommunekode: Scalars['String']['input'];
}>;


export type PopulateInstitutionerForKundeMutation = { __typename?: 'Mutation', populateInstitutionerForKunde: { __typename?: 'PopulateInstitutionerForKundePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type SletMedarbejderApiMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  kundeId: Scalars['UUID']['input'];
}>;


export type SletMedarbejderApiMutation = { __typename?: 'Mutation', removeMedarbejderApiModul: { __typename?: 'RemoveMedarbejderApiModulPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type RemoveMedarbejderApiMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  kundeId: Scalars['UUID']['input'];
}>;


export type RemoveMedarbejderApiMutation = { __typename?: 'Mutation', removeMedarbejderApiModul: { __typename?: 'RemoveMedarbejderApiModulPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type RemoveDatakontrolMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  kundeId: Scalars['UUID']['input'];
}>;


export type RemoveDatakontrolMutation = { __typename?: 'Mutation', removeDatakontrolModul: { __typename?: 'RemoveDatakontrolModulPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type RemoveSocialtilbudMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  kundeId: Scalars['UUID']['input'];
}>;


export type RemoveSocialtilbudMutation = { __typename?: 'Mutation', removeSocialTilbudModul: { __typename?: 'RemoveSocialTilbudModulPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type RemoveKontaktpersonerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  kundeId: Scalars['UUID']['input'];
}>;


export type RemoveKontaktpersonerMutation = { __typename?: 'Mutation', removeUdeladelserKontaktpersonerModul: { __typename?: 'RemoveUdeladelserKontaktpersonerModulPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type OpdaterKundeMutationVariables = Exact<{
  opdaterKundeInput: UpdateKundeMutationModelInput;
}>;


export type OpdaterKundeMutation = { __typename?: 'Mutation', updateKunde: { __typename?: 'UpdateKundePayload', kunde?: { __typename?: 'Kunde', navn: string, cvr: string, kommuneKode: string, id: any } | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type UpsertDatakontrolModuleMutationVariables = Exact<{
  input: UpsertDatakontrolModulMutationModelInput;
}>;


export type UpsertDatakontrolModuleMutation = { __typename?: 'Mutation', upsertDatakontrolModul: { __typename?: 'UpsertDatakontrolModulPayload', datakontrolModulViewModel?: { __typename?: 'DatakontrolModulViewModel', kundeModulId?: any | null, cprOpslagServiceAftaleUUID?: any | null, displayText: string } | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string, contextData: string }> | null } };

export type UpsertKontaktpersonerModuleMutationVariables = Exact<{
  modulId?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
}>;


export type UpsertKontaktpersonerModuleMutation = { __typename?: 'Mutation', upsertUdeladelserKontaktpersonerModul: { __typename?: 'UpsertUdeladelserKontaktpersonerModulPayload', udeladelserKontakpersonerModulViewModel?: { __typename?: 'UdeladelserKontakpersonerModulViewModel', kundeModulId?: any | null, displayText: string } | null } };

export type UpsertMedarbejderApiMutationVariables = Exact<{
  modulId?: InputMaybe<Scalars['UUID']['input']>;
  kundeId: Scalars['UUID']['input'];
  oprindelse: MedarbejderApiOprindelse;
}>;


export type UpsertMedarbejderApiMutation = { __typename?: 'Mutation', upsertMedarbejderApiModul: { __typename?: 'UpsertMedarbejderApiModulPayload', medarbejderApiModulViewModel?: { __typename?: 'MedarbejderApiModulViewModel', kundeModulId?: any | null, displayText: string, apiKey?: string | null, graviteeApplicationId?: string | null } | null, errors?: Array<{ __typename?: 'SupportToolMutationError', message: string }> | null } };

export type UpsertSocialtilbudModuleMutationVariables = Exact<{
  socialtilbudInput: UpsertSocialtilbudModulMutationModelInput;
}>;


export type UpsertSocialtilbudModuleMutation = { __typename?: 'Mutation', upsertSocialTilbudModul: { __typename?: 'UpsertSocialTilbudModulPayload', socialtilbudModulViewModel?: { __typename?: 'SocialtilbudModulViewModel', kundeModulId?: any | null, cprOpslagServiceAftaleUUID?: any | null, beskedfordelerServiceAftaleUUID?: any | null, displayText: string } | null } };

export type ResetTestDataMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetTestDataMutation = { __typename?: 'Mutation', resetTestData: boolean };

export type OpretTilbudMutationVariables = Exact<{
  tilbud: OpretTilbudInput;
}>;


export type OpretTilbudMutation = { __typename?: 'Mutation', opretTilbud: { __typename?: 'Tilbud', id: any, antalBarnManglerGodkendelse: any, antalBarnManglerValidering: any, antalBarnManglerMedarbejder: any, tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', godkendelse: { __typename?: 'TilbudsmedarbejderBarnGodkendelse', valideretTidspunkt?: Date | null } }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any }>, tilbudInfo: { __typename?: 'TilbudInfo', id: any, cvrNummer?: string | null, tilbudsnavn: string, tilbudsadresse: string, lokaltOprettet: boolean } } };

export type OpdaterTilbudMutationMutationVariables = Exact<{
  tilbudsinfo: TilbudMutationModelInput;
}>;


export type OpdaterTilbudMutationMutation = { __typename?: 'Mutation', opdaterTilbud: { __typename?: 'Tilbud', tilbudInfo: { __typename?: 'TilbudInfo', id: any, vejkode: string, lokaltOprettet: boolean, cvrNummer?: string | null, tilbudsnavn: string, tilbudsadresse: string, vejnavn: string, husnummer: string, husbogstav: string, email?: string | null, bynavn: string, kommune: string, region: string, postnummer: string, afdelingsnavn: string, mobil?: string | null, telefon?: string | null, kontaktBemaerkning?: string | null } } };

export type GetBarnWithTilbudByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetBarnWithTilbudByIdQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any, gyldigFra: Date, gyldigTil?: Date | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', tilbudsnavn: string, tilbudsadresse: string, lokaltOprettet: boolean } } }>, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any, aliasFornavn?: string | null, aliasEfternavn?: string | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', tilbudsnavn: string } } } }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } }> };

export type GetBarnWithMedarbejdereQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetBarnWithMedarbejdereQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, person: { __typename?: 'Person', id: any, fornavn: string, efternavn: string }, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', id: any, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any, person: { __typename?: 'Person', id: any, fornavn: string, efternavn: string } } }> }> };

export type GetBoernQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', antalAktiveMedarbejdere: any, antalAktiveTilbud: any, id: any, naesteMedarbejderBarnValideringInden?: Date | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', id: any, tilbudsnavn: string } } }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } }>, aktiveTilbud: { __typename?: 'AggregationCount', count: number } };

export type GetBoernAktiveQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernAktiveQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null } }> }> };

export type GetBoernWithApproveStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernWithApproveStateQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, antalAktiveMedarbejdere: any, naesteMedarbejderBarnValideringInden?: Date | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, registrerendeKommuneInfo?: { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string, defaultAccessLevel: AccessLevel, accessLevelChangePermission: AccessPermission, accessLevelInfoText: string, maxAntalMedarbejderePerBarn: number } | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any, gyldigTil?: Date | null, tilbud: { __typename?: 'Tilbud', tilbudInfo: { __typename?: 'TilbudInfo', tilbudsnavn: string } }, godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null, valideretAf?: string | null } }> }> };

export type GetBoernForTilbudForsideQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernForTilbudForsideQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, antalAktiveMedarbejdere: any, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', id: any, afdelingsnavn: string } } }> }> };

export type GetBarnWithCprQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetBarnWithCprQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', person: { __typename?: 'Person', cprNummer: string, adresse: string, stednavn?: string | null, postnummer: number, by: string } }> };

export type GetBoernForTilknytningQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernForTilknytningQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, antalAktiveMedarbejdere: any, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, registrerendeKommuneInfo?: { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string, defaultAccessLevel: AccessLevel, accessLevelChangePermission: AccessPermission, accessLevelInfoText: string, maxAntalMedarbejderePerBarn: number } | null, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null } }>, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', accessLevel: AccessLevel, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any } }> }> };

export type GetBarnWithTilknytningerAndMedarbejdereQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetBarnWithTilknytningerAndMedarbejdereQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, antalAktiveMedarbejdere: any, registrerendeKommuneInfo?: { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string, defaultAccessLevel: AccessLevel, accessLevelChangePermission: AccessPermission, accessLevelInfoText: string, maxAntalMedarbejderePerBarn: number } | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', id: any, accessLevel: AccessLevel, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any, aliasEfternavn?: string | null, aliasFornavn?: string | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } }> }>, tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, aliasEfternavn?: string | null, aliasFornavn?: string | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } }> };

export type GetBoernForAgregationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernForAgregationQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', antalAktiveMedarbejdere: any, antalAktiveTilbud: any, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null } }> }> };

export type GetPersonByCprQueryVariables = Exact<{
  cpr: Scalars['String']['input'];
  id?: Scalars['String']['input'];
}>;


export type GetPersonByCprQuery = { __typename?: 'Query', person?: { __typename?: 'CPRdata', fornavn: string, efternavn: string, stednavn?: string | null, adresse: string, adresseBeskyttet: boolean, postnummer: number, by: string, cprNummer: string } | null };

export type GetKontrolInstitutionerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKontrolInstitutionerQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', institutioner: Array<{ __typename?: 'Institution', id: any, navn: string, institutionType: Institutionstype, institutionKode: string, kontrolloerer: Array<{ __typename?: 'Replikabruger', brugerId: any, id: any, created: Date }> }> } | null };

export type GetInstitutionerForTilpassetKontrolQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstitutionerForTilpassetKontrolQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', institutioner: Array<{ __typename?: 'Institution', id: any, navn: string, institutionType: Institutionstype, institutionKode: string }> } | null };

export type GetInstitutionByIdQueryVariables = Exact<{
  institutionId: Scalars['UUID']['input'];
}>;


export type GetInstitutionByIdQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', institutioner: Array<{ __typename?: 'Institution', navn: string, kontrolloerer: Array<{ __typename?: 'Replikabruger', brugerId: any, id: any }> }> } | null };

export type GetKontrolSkabelonerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKontrolSkabelonerQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', id: any, skabeloner: Array<{ __typename?: 'Skabelon', id: any, navn: string, intervalDays: number, deadlineDays: number, type: DatakontrolTypeEnum, created: Date, lastUpdated?: Date | null }> } | null };

export type GetKontrolskabelonerNameAndIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKontrolskabelonerNameAndIdQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', id: any, skabeloner: Array<{ __typename?: 'Skabelon', id: any, navn: string }> } | null };

export type CheckIfKildeExistsQueryVariables = Exact<{
  kilde: Scalars['String']['input'];
}>;


export type CheckIfKildeExistsQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', kommuneValideringskilder: Array<{ __typename?: 'KommuneValideringskilde', valideringskilde: { __typename?: 'Valideringskilde', navn: string } }> } | null };

export type GetKommunekodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKommunekodeQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', kommunekode: number } | null };

export type GetValideringsReglerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetValideringsReglerQuery = { __typename?: 'Query', barnRegler?: { __typename?: 'ValideringsreglerConnection', nodes?: Array<{ __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string, regelType: ValideringsregelPersonType }> | null } | null, medarbejderRegler?: { __typename?: 'ValideringsreglerConnection', nodes?: Array<{ __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string, regelType: ValideringsregelPersonType }> | null } | null, personRegler?: { __typename?: 'ValideringsreglerConnection', nodes?: Array<{ __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string, regelType: ValideringsregelPersonType }> | null } | null };

export type GetKontrolSkabelonByIdQueryVariables = Exact<{
  skabelonId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetKontrolSkabelonByIdQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', id: any, skabeloner: Array<{ __typename?: 'Skabelon', id: any, navn: string, intervalDays: number, deadlineDays: number, type: DatakontrolTypeEnum, created: Date, lastUpdated?: Date | null, skabelonInstitutioner: Array<{ __typename?: 'SkabelonInstitution', institution: { __typename?: 'Institution', id: any, navn: string, institutionType: Institutionstype, institutionKode: string } }>, skabelonValideringsregler: Array<{ __typename?: 'SkabelonValideringsregel', valideringsregel: { __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string } }> }> } | null };

export type GetKontrolGrupperQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKontrolGrupperQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', grupper: Array<{ __typename?: 'Gruppe', id: any, navn: string, gruppeInstitutioner: Array<{ __typename?: 'GruppeInstitution', id: any, institution: { __typename?: 'Institution', navn: string, id: any } }> }> } | null };

export type GetKontrolgruppeByIdQueryVariables = Exact<{
  gruppeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetKontrolgruppeByIdQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', grupper: Array<{ __typename?: 'Gruppe', id: any, navn: string, gruppeInstitutioner: Array<{ __typename?: 'GruppeInstitution', id: any, institution: { __typename?: 'Institution', id: any, navn: string, institutionType: Institutionstype } }> }> } | null };

export type GetKontrollerQueryVariables = Exact<{
  kontrolloer?: InputMaybe<Scalars['Boolean']['input']>;
  visAfsluttede?: InputMaybe<Scalars['Boolean']['input']>;
  inkluderKontrollerUdenAfsluttede?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetKontrollerQuery = { __typename?: 'Query', kontrollerUdenAfsluttede?: Array<{ __typename?: 'Kontrol', id: any, navn: string, oprettetAfBrugerId: any, afsluttetDato?: Date | null, deadline: Date, inkluderValide: boolean, oprettetDato: Date, statusViewModel: KontrolStatusEnum, antalInstitutioner: number, antalResultater: number, antalBehandlet: number }>, kontrollerMedAfsluttede?: Array<{ __typename?: 'Kontrol', id: any, navn: string, oprettetAfBrugerId: any, afsluttetDato?: Date | null, deadline: Date, inkluderValide: boolean, oprettetDato: Date, statusViewModel: KontrolStatusEnum, antalInstitutioner: number, antalResultater: number, antalBehandlet: number }>, kontrollerKontrolloer?: Array<{ __typename?: 'Kontrol', id: any, navn: string, oprettetAfBrugerId: any, afsluttetDato?: Date | null, deadline: Date, oprettetDato: Date, statusViewModel: KontrolStatusEnum, antalInstitutioner: number, antalResultater: number, antalBehandlet: number }> };

export type GetKontrolForUpdatingQueryVariables = Exact<{
  kontrolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetKontrolForUpdatingQuery = { __typename?: 'Query', kontroller: Array<{ __typename?: 'Kontrol', navn: string, id: any, deadline: Date }> };

export type GetKontrolWithInstitutionsAndResultsQueryVariables = Exact<{
  kontrolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetKontrolWithInstitutionsAndResultsQuery = { __typename?: 'Query', kontroller: Array<{ __typename?: 'Kontrol', navn: string, id: any, deadline: Date, created: Date, oprettetAfBrugerId: any, statusViewModel: KontrolStatusEnum, antalResultater: number, antalBehandlet: number, kontrolValideringsregler: Array<{ __typename?: 'KontrolValideringsregel', valideringsregel: { __typename?: 'Valideringsregel', id: any, beskrivelse: string, regelType: ValideringsregelPersonType, navn: string, kommuneValideringsregelIndstillinger: Array<{ __typename?: 'KommuneValideringsregelIndstilling', notat?: string | null }> } }>, kontrolInstitutioner: Array<{ __typename?: 'KontrolInstitution', id: any, antalResultater: number, antalBehandlet: number, institution: { __typename?: 'Institution', navn: string, institutionType: Institutionstype, id: any, institutionKode: string }, medarbejderResults: Array<{ __typename?: 'Resultat', id: any, cpr: string, handling: ResultatHandlingEnum, behandletPersonNavn: string, behandletAfPersonNavn?: string | null, note?: string | null, beskrivelse?: string | null, created: Date, barnHovedgruppe?: string | null, relationName?: string | null, relationType?: string | null, displayText: string, vaerdi: ValideringsregelIndstillingValueEnum, tidligereResultater: Array<{ __typename?: 'BaseResultat', id: any, note?: string | null, handling: ResultatHandlingEnum, behandletAfPersonNavn?: string | null, behandletDato?: Date | null, created: Date, lastUpdated?: Date | null }>, beskedHandling?: { __typename?: 'BeskedHandling', dato?: Date | null, udfoertAf?: string | null, note?: string | null } | null, valideringsregel: { __typename?: 'Valideringsregel', navn: string, beskrivelse: string, undersoeg: string, loesning: string, kommuneValideringsregelIndstillinger: Array<{ __typename?: 'KommuneValideringsregelIndstilling', notat?: string | null }> } }>, barnWithoutRelationResult: Array<{ __typename?: 'Resultat', id: any, cpr: string, handling: ResultatHandlingEnum, behandletPersonNavn: string, behandletAfPersonNavn?: string | null, note?: string | null, beskrivelse?: string | null, displayText: string, created: Date, barnHovedgruppe?: string | null, relationName?: string | null, relationType?: string | null, vaerdi: ValideringsregelIndstillingValueEnum, tidligereResultater: Array<{ __typename?: 'BaseResultat', id: any, note?: string | null, handling: ResultatHandlingEnum, behandletAfPersonNavn?: string | null, behandletDato?: Date | null, created: Date, lastUpdated?: Date | null }>, beskedHandling?: { __typename?: 'BeskedHandling', dato?: Date | null, udfoertAf?: string | null, note?: string | null } | null, valideringsregel: { __typename?: 'Valideringsregel', navn: string, beskrivelse: string, undersoeg: string, loesning: string, kommuneValideringsregelIndstillinger: Array<{ __typename?: 'KommuneValideringsregelIndstilling', notat?: string | null }> } }> }> }> };

export type GetInstituionsForSkabelonQueryVariables = Exact<{
  skabelonId: Scalars['UUID']['input'];
}>;


export type GetInstituionsForSkabelonQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', skabeloner: Array<{ __typename?: 'Skabelon', skabelonInstitutioner: Array<{ __typename?: 'SkabelonInstitution', id: any, institution: { __typename?: 'Institution', navn: string, id: any } }> }>, institutioner: Array<{ __typename?: 'Institution', navn: string, id: any }> } | null };

export type GetRolleMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolleMappingsQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', rollemappings: Array<{ __typename?: 'Rollemapping', stillingsbetegnelse: string, roller: Array<RolleEnum>, id: any, created: Date }> } | null };

export type GetKontrolQueryVariables = Exact<{
  kontrolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetKontrolQuery = { __typename?: 'Query', kontroller: Array<{ __typename?: 'Kontrol', navn: string, id: any, deadline: Date, created: Date, oprettetAfBrugerId: any }> };

export type GetMedarbejderImportDatakilderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedarbejderImportDatakilderQuery = { __typename?: 'Query', medarbejderImportDatakilder: Array<{ __typename?: 'MedarbejderImportDatakildeViewModel', instId?: string | null, instNavn?: string | null, instType?: string | null, stilling?: string | null, cpr: string }> };

export type GetMedarbejderFagsystemDatakilderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedarbejderFagsystemDatakilderQuery = { __typename?: 'Query', medarbejderFagsystemDatakilder: Array<{ __typename?: 'FagsystemMedarbejderDatakildeViewModel', instId?: string | null, instNavn?: string | null, instType: string, stilling?: string | null, rolle?: string | null, cpr: string }> };

export type GetKommuneValideringsReglerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKommuneValideringsReglerQuery = { __typename?: 'Query', kommune?: { __typename?: 'Kommune', kommuneValideringsregler: Array<{ __typename?: 'KommuneValideringsregelIndstilling', created: Date, id: any, notat?: string | null, valideringsregel: { __typename?: 'Valideringsregel', beskrivelse: string, created: Date, id: any, navn: string, regelType: ValideringsregelPersonType, undersoeg: string, loesning: string } }> } | null, barnRegler?: { __typename?: 'ValideringsreglerConnection', nodes?: Array<{ __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string, regelType: ValideringsregelPersonType, undersoeg: string, loesning: string }> | null } | null, medarbejderRegler?: { __typename?: 'ValideringsreglerConnection', nodes?: Array<{ __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string, regelType: ValideringsregelPersonType, undersoeg: string, loesning: string }> | null } | null, personRegler?: { __typename?: 'ValideringsreglerConnection', nodes?: Array<{ __typename?: 'Valideringsregel', id: any, navn: string, beskrivelse: string, regelType: ValideringsregelPersonType, undersoeg: string, loesning: string }> | null } | null };

export type GetForvalterOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetForvalterOverviewQuery = { __typename?: 'Query', aktiveBoern: { __typename?: 'AggregationCount', count: number }, aktiveTilbud: { __typename?: 'AggregationCount', count: number } };

export type NameFieldsFragment = { __typename?: 'Person', id: any, fornavn: string, efternavn: string };

export type ExtendedPersonFieldsFragment = { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null };

export type BarnMainFieldsFragment = { __typename?: 'Barn', antalAktiveMedarbejdere: any, antalAktiveTilbud: any, id: any, naesteMedarbejderBarnValideringInden?: Date | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null }, tilbud: { __typename?: 'Tilbud', id: any, tilbudInfo: { __typename?: 'TilbudInfo', id: any, tilbudsnavn: string } } }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } };

export type TilbudsFieldsFragment = { __typename?: 'Tilbud', id: any, antalBarnManglerGodkendelse: any, antalBarnManglerValidering: any, antalBarnManglerMedarbejder: any, tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', godkendelse: { __typename?: 'TilbudsmedarbejderBarnGodkendelse', valideretTidspunkt?: Date | null } }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any }>, tilbudInfo: { __typename?: 'TilbudInfo', id: any, cvrNummer?: string | null, tilbudsnavn: string, tilbudsadresse: string, lokaltOprettet: boolean } };

export type ExtendedTilbudInfoFragment = { __typename?: 'TilbudInfo', id: any, vejkode: string, lokaltOprettet: boolean, cvrNummer?: string | null, tilbudsnavn: string, tilbudsadresse: string, vejnavn: string, husnummer: string, husbogstav: string, email?: string | null, bynavn: string, kommune: string, region: string, postnummer: string, afdelingsnavn: string, mobil?: string | null, telefon?: string | null, kontaktBemaerkning?: string | null };

export type RegistrerendeKommuneInfoFieldsFragment = { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string, defaultAccessLevel: AccessLevel, accessLevelChangePermission: AccessPermission, accessLevelInfoText: string, maxAntalMedarbejderePerBarn: number };

export type DomainActionFieldsFragment = { __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> };

export type GetBoernWithMedarbejdereGodkendelseStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoernWithMedarbejdereGodkendelseStatusQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', id: any, naesteMedarbejderBarnValideringInden?: Date | null, sidsteMedarbejderBarnValideringsTidspunkt?: Date | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any, gyldigTil?: Date | null, godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', id: any, valideretTidspunkt?: Date | null } }>, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', id: any, godkendelse: { __typename?: 'TilbudsmedarbejderBarnGodkendelse', naesteGodkendelseInden: Date, valideretTidspunkt?: Date | null }, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any, aliasEfternavn?: string | null, aliasFornavn?: string | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } }> }> };

export type GetLokalKonfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLokalKonfigurationQuery = { __typename?: 'Query', lokalKonfiguration: Array<{ __typename?: 'LokalKonfiguration', id: any, organisationNavn: string, organisationCvr: string, pNummer?: string | null, kommuneKode: number, kontrolInterval: number, daysLeftBeforeFirstReminder: number, daysLeftBeforeSecondReminder: number, daysLeftBeforeThirdAndFinalReminder: number, emailModtagere: Array<string>, accessLevelChangePermission: AccessPermission, defaultAccessLevel: AccessLevel, accessLevelInfoText?: string | null, contactInformationText?: string | null, includeMedarbejdereInElevadministrativeSystemer: boolean, includeMedarbejdereInElevadministrativeSystemerChangePermission: AccessPermission } | null> };

export type GetTilbudKontaktInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTilbudKontaktInformationQuery = { __typename?: 'Query', boern: Array<{ __typename?: 'Barn', registrerendeKommuneInfo?: { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string } | null }> };

export type GetMedarbejdereQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedarbejdereQuery = { __typename?: 'Query', tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, grace?: number | null, gyldigTil: Date, aliasEfternavn?: string | null, aliasFornavn?: string | null, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } }>, aktiveBoern: { __typename?: 'AggregationCount', count: number } };

export type GetMedarbejderWithBornQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetMedarbejderWithBornQuery = { __typename?: 'Query', tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', barn: { __typename?: 'Barn', id: any, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } }> }> };

export type GetMedarbejderForTilknytningQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedarbejderForTilknytningQuery = { __typename?: 'Query', tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, aliasEfternavn?: string | null, aliasFornavn?: string | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', barn: { __typename?: 'Barn', id: any } }> }> };

export type GetMedarbejderWithTilknytningAndBoernQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMedarbejderWithTilknytningAndBoernQuery = { __typename?: 'Query', tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, gyldigTil: Date, aliasEfternavn?: string | null, aliasFornavn?: string | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', id: any, accessLevel: AccessLevel, barn: { __typename?: 'Barn', id: any, registrerendeKommuneInfo?: { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string, defaultAccessLevel: AccessLevel, accessLevelChangePermission: AccessPermission, accessLevelInfoText: string, maxAntalMedarbejderePerBarn: number } | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } }> }>, boern: Array<{ __typename?: 'Barn', id: any, antalAktiveMedarbejdere: any, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null }, registrerendeKommuneInfo?: { __typename?: 'RegistrendeKommuneInfo', navn: string, contactInformationText: string, defaultAccessLevel: AccessLevel, accessLevelChangePermission: AccessPermission, accessLevelInfoText: string, maxAntalMedarbejderePerBarn: number } | null, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null } }>, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', accessLevel: AccessLevel, tilbudsMedarbejder: { __typename?: 'TilbudsMedarbejder', id: any } }> }> };

export type GetKommuneMedarbejderAktivitetOversigtQueryVariables = Exact<{
  kommunekode: Scalars['String']['input'];
  fra: Scalars['DateTime']['input'];
  til: Scalars['DateTime']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type GetKommuneMedarbejderAktivitetOversigtQuery = { __typename?: 'Query', kommuneMedarbejderAktivitetOversigt: { __typename?: 'PagedResultOfKommuneMedarbejderAktivitetSummary', totalCount: number, items: Array<{ __typename?: 'KommuneMedarbejderAktivitetSummary', brugerId: number, navn: string, aktivitetAntal: number, senesteAktivitet: Date }> } };

export type GetKommuneBorgerAktivitetOversigtQueryVariables = Exact<{
  kommunekode: Scalars['String']['input'];
  fra: Scalars['DateTime']['input'];
  til: Scalars['DateTime']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type GetKommuneBorgerAktivitetOversigtQuery = { __typename?: 'Query', kommuneBorgerAktivitetOversigt: { __typename?: 'PagedResultOfKommuneBorgerAktivitetSummary', totalCount: number, items: Array<{ __typename?: 'KommuneBorgerAktivitetSummary', entityId: any, entityType: EntityType, navn?: string | null, erFundet: boolean, aktivitetAntal: number, senesteAktivitet: Date }> } };

export type AktivitetDetaljeFelterFragment = { __typename?: 'BrugerAktivitetDetalje', tidspunkt: Date, brugerId: number, operation: string, type: string, aktivitet: string, elapsedMiliseconds: number, variables: Array<{ __typename?: 'BrugerAktivitetVariabel', name: string, value: string }> };

export type GetBrugerAktiviteterQueryVariables = Exact<{
  brugerId: Scalars['Int']['input'];
  fra: Scalars['DateTime']['input'];
  til: Scalars['DateTime']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  soegetekst?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OperationType>;
  sorteringStigende?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBrugerAktiviteterQuery = { __typename?: 'Query', aktiviteter: { __typename?: 'PagedResultOfBrugerAktivitetDetalje', totalCount: number, items: Array<{ __typename?: 'BrugerAktivitetDetalje', tidspunkt: Date, brugerId: number, operation: string, type: string, aktivitet: string, elapsedMiliseconds: number, variables: Array<{ __typename?: 'BrugerAktivitetVariabel', name: string, value: string }> }> } };

export type GetBorgerAktiviteterQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  fra: Scalars['DateTime']['input'];
  til: Scalars['DateTime']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  soegetekst?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OperationType>;
  sorteringStigende?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBorgerAktiviteterQuery = { __typename?: 'Query', aktiviteter: { __typename?: 'PagedResultOfBrugerAktivitetDetalje', totalCount: number, items: Array<{ __typename?: 'BrugerAktivitetDetalje', brugerNavn: string, tidspunkt: Date, brugerId: number, operation: string, type: string, aktivitet: string, elapsedMiliseconds: number, variables: Array<{ __typename?: 'BrugerAktivitetVariabel', name: string, value: string }> }> } };

export type GetHealthcheckStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHealthcheckStatusQuery = { __typename?: 'Query', healthcheckStatus: { __typename?: 'HealthcheckStatusViewModel', overallStatus: HealthcheckOverallStatus, dashboardUrl: string, services: Array<{ __typename?: 'HealthcheckServiceStatusViewModel', name: string, status: HealthcheckOverallStatus }> } };

export type GetKunderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKunderQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', navn: string, cvr: string, kommuneKode: string, id: any, created: Date, lastUpdated?: Date | null, moduler: Array<{ __typename?: 'KundeModul', created: Date, id: any, modul: { __typename?: 'Modul', navn: string, modulKode: ModulKode, created: Date, id: any } }> }> };

export type GetDatakontrolModuleQueryVariables = Exact<{
  kundeId: Scalars['UUID']['input'];
  kundeModulId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetDatakontrolModuleQuery = { __typename?: 'Query', datakontrolModule: { __typename?: 'DatakontrolModulViewModel', kundeModulId?: any | null, cprOpslagServiceAftaleUUID?: any | null, displayText: string } };

export type GetSocialtilbudModuleQueryVariables = Exact<{
  kundeId: Scalars['UUID']['input'];
  kundeModulId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSocialtilbudModuleQuery = { __typename?: 'Query', socialtilbudModule: { __typename?: 'SocialtilbudModulViewModel', kundeModulId?: any | null, beskedfordelerServiceAftaleUUID?: any | null, cprOpslagServiceAftaleUUID?: any | null, displayText: string } };

export type GetMedarbejderApiModuleQueryVariables = Exact<{
  kundeId: Scalars['UUID']['input'];
  kundeModulId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetMedarbejderApiModuleQuery = { __typename?: 'Query', medarbejderAPIModule: { __typename?: 'MedarbejderApiModulViewModel', kundeModulId?: any | null, displayText: string, oprindelse: MedarbejderApiOprindelse, apiKey?: string | null } };

export type GetMedarbejderApiModuleByKommunekodeQueryVariables = Exact<{
  kommunekode: Scalars['String']['input'];
}>;


export type GetMedarbejderApiModuleByKommunekodeQuery = { __typename?: 'Query', medarbejderApiModuleByKommunekode?: { __typename?: 'MedarbejderApiModulViewModel', oprindelse: MedarbejderApiOprindelse, apiKey?: string | null, displayText: string } | null };

export type SearchTilbudByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type SearchTilbudByNameQuery = { __typename?: 'Query', tilbud: Array<{ __typename?: 'Tilbud', id: any, tilbudsregisterId: any, tilbudInfo: { __typename?: 'TilbudInfo', id: any } }>, tilbudInfo: Array<{ __typename?: 'TilbudInfoSearch', tilbud_UUID: any, tilbudsnavn: string, tilbudsadresse: string, afdelingsnavn: string, cvrNummer?: string | null, afdeling_UUID: any, husnummer: string, kommune: string, vejnavn: string, postnummer: string, bynavn: string, alreadyAdded: boolean, oprettendeKommune: string }> };

export type GetTilbudWithBarnAndMedarbejderByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTilbudWithBarnAndMedarbejderByIdQuery = { __typename?: 'Query', tilbud: Array<{ __typename?: 'Tilbud', tilbudInfo: { __typename?: 'TilbudInfo', id: any, vejkode: string, lokaltOprettet: boolean, cvrNummer?: string | null, tilbudsnavn: string, tilbudsadresse: string, vejnavn: string, husnummer: string, husbogstav: string, email?: string | null, bynavn: string, kommune: string, region: string, postnummer: string, afdelingsnavn: string, mobil?: string | null, telefon?: string | null, kontaktBemaerkning?: string | null }, tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, aliasFornavn?: string | null, aliasEfternavn?: string | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any, barn: { __typename?: 'Barn', id: any, grace?: number | null, person: { __typename?: 'Person', id: any, f_dselsdato?: Date | null, fornavn: string, efternavn: string, adresseBeskyttetTil?: Date | null, adresseBeskyttetFra?: Date | null } } }> }> };

export type BoernMedarbejderTilknytningQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BoernMedarbejderTilknytningQuery = { __typename?: 'Query', tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', barn: { __typename?: 'Barn', id: any, person: { __typename?: 'Person', id: any, fornavn: string, efternavn: string } } }> }> };

export type GetTilbudQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTilbudQuery = { __typename?: 'Query', tilbud: Array<{ __typename?: 'Tilbud', id: any, antalBarnManglerGodkendelse: any, antalBarnManglerValidering: any, antalBarnManglerMedarbejder: any, domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsMedarbejdere: Array<{ __typename?: 'TilbudsMedarbejder', id: any, tilbudsmedarbejderBoern: Array<{ __typename?: 'TilbudsmedarbejderBarn', godkendelse: { __typename?: 'TilbudsmedarbejderBarnGodkendelse', valideretTidspunkt?: Date | null } }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', id: any }>, tilbudInfo: { __typename?: 'TilbudInfo', id: any, cvrNummer?: string | null, tilbudsnavn: string, tilbudsadresse: string, lokaltOprettet: boolean } }> };

export type GetTilbudForTilknytQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTilbudForTilknytQuery = { __typename?: 'Query', tilbud: Array<{ __typename?: 'Tilbud', id: any, tilbudsregisterId: any, includeMedarbejdereInElevadministrativeSystemer: boolean, tilbudInfo: { __typename?: 'TilbudInfo', id: any, tilbudsnavn: string, tilbudsadresse: string, lokaltOprettet: boolean, pNummer?: string | null, vejnavn: string, husnummer: string, bynavn: string, postnummer: string, afdelingsnavn: string, kommune: string, region: string, cvrNummer?: string | null, email?: string | null, telefon?: string | null, mobil?: string | null, kontaktBemaerkning?: string | null } }> };

export type GetTilbudForAggregationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTilbudForAggregationQuery = { __typename?: 'Query', tilbud: Array<{ __typename?: 'Tilbud', domainActions: Array<{ __typename?: 'DomainAction', type: DomainActionType, entityId: any, entityType: string, severity: DomainActionSeverity, values: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }>, tilbudsTilknytninger: Array<{ __typename?: 'TilbudsTilknytning', godkendelse: { __typename?: 'TilbudsTilknytningGodkendelse', valideretTidspunkt?: Date | null } }> }> };

export type GetPossibleInstitutionsQueryVariables = Exact<{
  kommuneKode: Scalars['String']['input'];
}>;


export type GetPossibleInstitutionsQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', kommuneKode: string, institutioner: Array<{ __typename?: 'Replikainstitution', institutionskode: string, navn: string }> }> };

export type GetPersonsForDataComparisonQueryVariables = Exact<{
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  institutionskode: Scalars['String']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPersonsForDataComparisonQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', navn: string, id: any, institutioner: Array<{ __typename?: 'Replikainstitution', id: any, institutionType: Institutionstype, navn: string, institutionskode: string, ws17?: { __typename?: 'WS17Institution', institutionPersons: Array<{ __typename?: 'WS17InstitutionPerson', personType: PersonType, localPersonId?: string | null, person?: { __typename?: 'WS17Person', firstName: string, familyName: string, protected?: boolean | null, aliasFirstName?: string | null, aliasFamilyName?: string | null, civilRegistrationNumber?: string | null, emailAddress?: string | null, birthDate?: Date | null, gender: Gender, photoId?: string | null, homePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null, mobilePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, workPhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null } | null, student?: { __typename?: 'WS17Student', role: StudentRole, studentNumber?: string | null, level: Level, location?: string | null, mainGroupId: string, groupIds?: Array<string> | null, contactPersons: Array<{ __typename?: 'WS17ContactPerson', relation: Serviceplatformen_Ws10_Relation, childCustody: boolean, accessLevel?: number | null, person: { __typename?: 'WS17Person', protected?: boolean | null, firstName: string, familyName: string, aliasFirstName?: string | null, aliasFamilyName?: string | null, civilRegistrationNumber?: string | null, emailAddress?: string | null, birthDate?: Date | null, gender: Gender, photoId?: string | null, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null, homePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, workPhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, mobilePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null } }>, mainGroup: { __typename?: 'WS17Group', fromDate: Date, groupId: string, groupLevel: Level, groupName?: string | null, groupType: GroupType, line?: string | null, toDate: Date }, groups: Array<{ __typename?: 'WS17Group', fromDate: Date, groupId: string, groupLevel: Level, groupName?: string | null, groupType: GroupType, line?: string | null, toDate: Date }> } | null }> } | null, ws10?: { __typename?: 'WS10Institution', importDate: Date, institutionName?: string | null, institutionNumber: string, institutionPersons: Array<{ __typename?: 'WS10InstitutionPerson', personType: PersonType, localPersonId: string, person: { __typename?: 'WS10Person', firstName: string, familyName: string, protected: boolean, aliasFirstName?: string | null, aliasFamilyName?: string | null, civilRegistrationNumber: string, emailAddress?: string | null, birthDate?: Date | null, gender: Gender, photoId?: string | null, homePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null, mobilePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, workPhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null }, student?: { __typename?: 'WS10Student', role: StudentRole, studentNumber?: string | null, level: Level, location?: string | null, mainGroupId: string, groupIds?: Array<string> | null, contactPersons: Array<{ __typename?: 'WS10ContactPerson', relation: Serviceplatformen_Ws10_Relation, childCustody: boolean, accessLevel: number, person: { __typename?: 'WS10Person', protected: boolean, firstName: string, familyName: string, aliasFirstName?: string | null, aliasFamilyName?: string | null, civilRegistrationNumber: string, emailAddress?: string | null, birthDate?: Date | null, gender: Gender, photoId?: string | null, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null, homePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, workPhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, mobilePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null } }>, mainGroup: { __typename?: 'WS10Group', fromDate?: Date | null, groupId: string, groupLevel: Level, groupName?: string | null, groupType: GroupType, line?: string | null, toDate?: Date | null }, groups: Array<{ __typename?: 'WS10Group', fromDate?: Date | null, groupId: string, groupLevel: Level, groupName?: string | null, groupType: GroupType, line?: string | null, toDate?: Date | null }> } | null }> } | null }> }> };

export type GetPersonsForSelectorQueryVariables = Exact<{
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  institutionskode: Scalars['String']['input'];
}>;


export type GetPersonsForSelectorQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', navn: string, institutioner: Array<{ __typename?: 'Replikainstitution', navn: string, ws17?: { __typename?: 'WS17Institution', institutionPersons: Array<{ __typename?: 'WS17InstitutionPerson', person?: { __typename?: 'WS17Person', firstName: string, familyName: string } | null, student?: { __typename?: 'WS17Student', mainGroup: { __typename?: 'WS17Group', groupName?: string | null } } | null }> } | null }> }> };

export type GetGroupsQueryVariables = Exact<{
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  institutionskode: Scalars['String']['input'];
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchInputUpperCase?: InputMaybe<Scalars['String']['input']>;
  searchInputLowerCase?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', navn: string, id: any, institutioner: Array<{ __typename?: 'Replikainstitution', id: any, institutionType: Institutionstype, navn: string, institutionskode: string, ws17?: { __typename?: 'WS17Institution', groups: Array<{ __typename?: 'WS17Group', fromDate: Date, groupId: string, groupLevel: Level, groupName?: string | null, groupType: GroupType, line?: string | null, toDate: Date }> } | null, ws10?: { __typename?: 'WS10Institution', groups: Array<{ __typename?: 'WS10Group', fromDate?: Date | null, groupId: string, groupLevel: Level, groupName?: string | null, groupType: GroupType, line?: string | null, toDate?: Date | null }> } | null }> }> };

export type GetEmployeesQueryVariables = Exact<{
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  institutionskode: Scalars['String']['input'];
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchInputCapitalized?: InputMaybe<Scalars['String']['input']>;
  searchInputUpperCase?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', navn: string, id: any, institutioner: Array<{ __typename?: 'Replikainstitution', id: any, institutionType: Institutionstype, navn: string, institutionskode: string, ws17?: { __typename?: 'WS17Institution', institutionPersons: Array<{ __typename?: 'WS17InstitutionPerson', personType: PersonType, localPersonId?: string | null, person?: { __typename?: 'WS17Person', firstName: string, familyName: string, aliasFirstName?: string | null, aliasFamilyName?: string | null, emailAddress?: string | null, birthDate?: Date | null, gender: Gender, photoId?: string | null, protected?: boolean | null, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null, homePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, workPhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, mobilePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null } | null, employee?: { __typename?: 'WS17Employee', roles: Array<EmployeeRole>, location?: string | null, occupation?: string | null, shortName?: string | null, groupIds?: Array<string> | null, groups: Array<{ __typename?: 'WS17Group', groupId: string, groupName?: string | null, groupType: GroupType, groupLevel: Level, line?: string | null, fromDate: Date, toDate: Date }> } | null }> } | null, ws10?: { __typename?: 'WS10Institution', institutionPersons: Array<{ __typename?: 'WS10InstitutionPerson', personType: PersonType, localPersonId: string, person: { __typename?: 'WS10Person', firstName: string, familyName: string, aliasFirstName?: string | null, aliasFamilyName?: string | null, emailAddress?: string | null, birthDate?: Date | null, gender: Gender, photoId?: string | null, protected: boolean, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null, homePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, workPhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null, mobilePhoneNumber?: { __typename?: 'PhoneNumber', protected: boolean, value?: string | null } | null }, employee?: { __typename?: 'WS10Employee', roles: Array<EmployeeRole>, location?: string | null, occupation?: string | null, shortName?: string | null, groupIds?: Array<string> | null, groups: Array<{ __typename?: 'WS10Group', groupId: string, groupName?: string | null, groupType: GroupType, groupLevel: Level, line?: string | null, fromDate?: Date | null, toDate?: Date | null }> } | null }> } | null }> }> };

export type GetExternalContactsQueryVariables = Exact<{
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  institutionskode: Scalars['String']['input'];
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchInputCapitalized?: InputMaybe<Scalars['String']['input']>;
  searchInputUpperCase?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExternalContactsQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', navn: string, id: any, institutioner: Array<{ __typename?: 'Replikainstitution', id: any, institutionType: Institutionstype, navn: string, institutionskode: string, ws17?: { __typename?: 'WS17Institution', institutionPersons: Array<{ __typename?: 'WS17InstitutionPerson', localPersonId?: string | null, person?: { __typename?: 'WS17Person', firstName: string, familyName: string, protected?: boolean | null, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null } | null, extern?: { __typename?: 'WS17Extern', role: ExternRole, groupIds?: Array<string> | null, groups: Array<{ __typename?: 'WS17Group', groupId: string, groupName?: string | null, groupType: GroupType, groupLevel: Level, line?: string | null, fromDate: Date, toDate: Date }> } | null }> } | null, ws10?: { __typename?: 'WS10Institution', institutionPersons: Array<{ __typename?: 'WS10InstitutionPerson', localPersonId: string, person: { __typename?: 'WS10Person', firstName: string, familyName: string, protected: boolean, address?: { __typename?: 'Address', streetAddress?: string | null, postalCode?: string | null, postalDistrict?: string | null, countryCode?: string | null, country?: string | null, municipalityCode?: string | null, municipalityName?: string | null } | null }, extern?: { __typename?: 'WS10Extern', role: ExternRole, groupIds?: Array<string> | null, groups: Array<{ __typename?: 'WS10Group', groupId: string, groupName?: string | null, groupType: GroupType, groupLevel: Level, line?: string | null, fromDate?: Date | null, toDate?: Date | null }> } | null }> } | null }> }> };

export type GetInstitutionDataDatesQueryVariables = Exact<{
  kommuneKode?: InputMaybe<Scalars['String']['input']>;
  institutionskode: Scalars['String']['input'];
}>;


export type GetInstitutionDataDatesQuery = { __typename?: 'Query', kunder: Array<{ __typename?: 'Kunde', id: any, institutioner: Array<{ __typename?: 'Replikainstitution', id: any, ws17?: { __typename?: 'WS17Institution', exportDate: Date } | null, ws10?: { __typename?: 'WS10Institution', importDate: Date } | null }> }> };


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CreateKundeError": [
      "SupportToolMutationError"
    ],
    "DeleteGraviteeApplicationError": [
      "SupportToolMutationError"
    ],
    "DeleteOutOfScopeError": [
      "DatakontrolMutationError"
    ],
    "Error": [
      "DatakontrolMutationError",
      "InstitutionsreplikaMutationError",
      "SupportToolMutationError"
    ],
    "GenererValideResultaterRapportMutationError": [
      "DatakontrolMutationError"
    ],
    "GenkoerKontrolMutationError": [
      "DatakontrolMutationError"
    ],
    "GensendCprHaendelserForKundeError": [
      "SupportToolMutationError"
    ],
    "InternalPopulateInstitutionsError": [
      "InstitutionsreplikaMutationError"
    ],
    "OpdaterKontrolInfoMutationError": [
      "DatakontrolMutationError"
    ],
    "OpdaterKontrolResultatMutationError": [
      "DatakontrolMutationError"
    ],
    "OpdaterKontrolStatusMutationError": [
      "DatakontrolMutationError"
    ],
    "OpretKontrolSkabelonMutationError": [
      "DatakontrolMutationError"
    ],
    "OpretKontrolTilpassetMutationError": [
      "DatakontrolMutationError"
    ],
    "PopulateInstitutionerForKundeError": [
      "SupportToolMutationError"
    ],
    "PopulateInstitutionsError": [
      "InstitutionsreplikaMutationError"
    ],
    "ProcessInactiveKontrollerError": [
      "DatakontrolMutationError"
    ],
    "ProcessKontrollerPerformanceError": [
      "DatakontrolMutationError"
    ],
    "ProcessNotificationsError": [
      "DatakontrolMutationError"
    ],
    "ProcessSystemKontrollerError": [
      "DatakontrolMutationError"
    ],
    "ProvisionGraviteeApplicationError": [
      "SupportToolMutationError"
    ],
    "RemoveDatakontrolModulError": [
      "SupportToolMutationError"
    ],
    "RemoveMedarbejderApiModulError": [
      "SupportToolMutationError"
    ],
    "RemoveSocialTilbudModulError": [
      "SupportToolMutationError"
    ],
    "RemoveUdeladelserKontaktpersonerModulError": [
      "SupportToolMutationError"
    ],
    "SletGruppeMutationError": [
      "DatakontrolMutationError"
    ],
    "SletKontrolMutationError": [
      "DatakontrolMutationError"
    ],
    "SletSkabelonMutationError": [
      "DatakontrolMutationError"
    ],
    "SynchronizeKontrolloerInstitutionMutationError": [
      "DatakontrolMutationError"
    ],
    "SynchronizeKontrolloererError": [
      "InstitutionsreplikaMutationError"
    ],
    "UpdateKundeError": [
      "SupportToolMutationError"
    ],
    "UpsertBrugereForInstitutionError": [
      "InstitutionsreplikaMutationError"
    ],
    "UpsertDatakontrolModulError": [
      "SupportToolMutationError"
    ],
    "UpsertGruppeMutationError": [
      "DatakontrolMutationError"
    ],
    "UpsertInstitutionerForBrugerError": [
      "InstitutionsreplikaMutationError"
    ],
    "UpsertKommuneValideringsreglerMutationError": [
      "DatakontrolMutationError"
    ],
    "UpsertMedarbejderApiModulError": [
      "SupportToolMutationError"
    ],
    "UpsertRollemappingsError": [
      "DatakontrolMutationError"
    ],
    "UpsertSkabelonMutationError": [
      "DatakontrolMutationError"
    ],
    "UpsertSocialTilbudModulError": [
      "SupportToolMutationError"
    ],
    "UpsertUdeladelserKontaktpersonerModulError": [
      "SupportToolMutationError"
    ]
  }
};
      export default result;
    